export const language_el = {
    "GeneralTab": "Γενικά",
    "General": {
        "name": "Όνομα",
        "firstName": "Όνομα",
        "lastName": "Επώνυμο",
        "clientName": "Όνομα Πελάτη",
        "smallName": "Διακριτικός Τίτλος",
        "documentType": "Τύπος Παραστατικού",
        "date": "Ημερομηνία",
        "time": "Ώρα",
        "installation": "Εγκατάσταση",
        "installations": "Εγκαταστάσεις",
        "active": "Ενεργοποιημένο",
        "inactive": "Απενεργοποιημένο",
        "inActive": "Απενεργοποιημένο",
        "actions": "Ενέργειες",
        "preNumber": "Σειρά",
        "number": "Αριθμός",
        "client": "Πελάτης",
        "supplier": "Προμηθευτής",
        "supplierVAT": "ΑΦΜ Προμηθευτή",
        "supplierName": "Όνομα Προμηθευτή",
        "supplierNameVAT": "Όνομα/ΑΦΜ Προμηθευτή",
        "supplierInstallation": "Εγκατάσταση Προμηθευτή",
        "vatNumber": "Α.Φ.Μ.",
        "address": "Διεύθυνση",
        "doy": "ΔΟΥ",
        "city": "Πόλη",
        "postalCode": "Ταχυδρομικός Κωδικός",
        "paymentType": "Τρόπος Πληρωμής",
        "paymentTypes": "Τρόποι Πληρωμής",
        "no": "Αρ.",
        "productCode": "Κωδικός Είδους",
        "productName": "Όνομα Είδους",
        "quantity": "Ποσότητα",
        "measurementUnit": "Μ.Μ.",
        "unitPrice": "Τιμή Μονάδας",
        "discount": "Έκπτωση",
        "vatPercentage": "Φ.Π.Α. %",
        "netValue": "Καθαρή Αξία",
        "vatValue": "Αξία Φ.Π.Α.",
        "isNetValue": "Είναι Καθαρή Αξία",
        "isTax": "Είναι Φόρος",
        "taxes": "Φόροι",
        "taxWithholding": "Παρακρατούμενος Φόρος",
        "totalValue": "Τελική Αξία",
        "withholdTaxes": "Παρακρατούμενοι Φόροι",
        "otherTax": "Λοιπός Φόρος",
        "otherTaxes": "Λοιποί Φόροι",
        "ruleName": "Όνομα Κανόνα",
        "rules": "Κανόνες",
        "sign": "Πρόσημο",
        "fees": "Τέλη",
        "stampDuty": "Τέλος Χαρτοσήμου",
        "totals": "Σύνολα",
        "totalQuantity": "Συνολική Ποσότητα",
        "totalBeforeDiscount": "Σύνολο προ έκπτωσης",
        "totalDiscount": "Συνολικό ποσό έκπτωσης",
        "totalNetValue": "Συνολική Καθαρή Αξία",
        "totalVatValue": "Συνολική Αξία Φ.Π.Α.",
        "totalWithheldAmount": "Σύνολο Παρακρατούμενων Φόρων",
        "totalTaxesAmount": "Σύνολο Φόρων",
        "totalAmount": "Συνολική Αξία",
        "totalCredit": "Συνολικό Ποσό",
        "paymentAmount": "Πληρωτέο Ποσό",
        "totalPrice": "Τελική Τιμή",
        "notes": "Σημειώσεις",
        "extraData": "Λοιπά Δεδομένα",
        "wayOfSendingGoods": "Τρόπος αποστολής εμπορευμάτων",
        "waysOfSendingGoods": "Τρόποι αποστολής εμπορευμάτων",
        "goodsSendDate": "Ημερομηνία αποστολής εμπορευμάτων",
        "carNumber": "Αριθμός Αυτοκινήτου",
        "carNumbers": "Αριθμοί Αυτοκινήτων",
        "totalSumFrom": "Συνολική Αξία από",
        "totalSumTo": "Συνολική Αξία μέχρι",
        "sumFrom": "Αξία από",
        "sumTo": "Αξία μέχρι",
        "preNumberFrom": "Σειρά από",
        "preNumberTo": "Σειρά μέχρι",
        "numberFrom": "Αριθμός από",
        "numberTo": "Αριθμός μέχρι",
        "dateFrom": "Ημερομηνία από",
        "dateTo": "Ημερομηνία μέχρι",
        "reason": "Αιτιολογία",
        "startDate": "Ημερομηνία Έναρξης",
        "endDate": "Ημερομηνία Λήξης",
        "phone": "Τηλέφωνο",
        "category": "Κατηγορία",
        "subCategory": "Υποκατηγορία",
        "systemCode": "Κωδικός Συστήματος",
        "manualCode": "Χειροκίνητος Κωδικός",
        "vatCategory": "Κατηγορία Φ.Π.Α.",
        "country": "Χώρα",
        "email": "E-Mail",
        "amka": "Α.Μ.Κ.Α.",
        "gemhNo": "Αριθμός ΓΕΜΗ",
        "webpage": "Ιστοσελίδα",
        "contactPoints": "Στοιχεία επαφών",
        "contactName": "Όνομα επαφής",
        "mobilePhone": "Κινητό τηλέφωνο",
        "landline": "Σταθερό τηλέφωνο",
        "otherPhone": "Άλλο τηλέφωνο",
        "contactNotes": "Σημειώσεις Επαφής",
        "myDataStatus": "Κατάσταση MyData",
        "products": "Είδη",
        "code": "Κωδικός",
        "alternateCode": "Εναλλακτικός Κωδικός",
        "alternateName": "Εναλλακτικό Όνομα",
        "type": "Τύπος",
        "loading": "Γίνεται φόρτωση...",
        "warning": "Προσοχή!",
        "warningDataLoss": "Τα δεδομένα θα χαθούν, είσαστε σίγουροι ότι θέλετε να συνεχίσετε;",
        "warningSupplierInactive": "Είσαστε σίγουροι ότι θέλετε να απενεργοποιήσετε τον προμηθευτή;",
        "noOption": "Όχι",
        "yesOption": "Ναι",
        "empty": "Κενό",
        "serialNumber": "Σειριακός Αριθμός",
        "bankName": "Όνομα Τράπεζας",
        "iban": "IBAN",
        "amount": "Ποσό",
        "bankAccountData": "Δεδομένα τραπεζικού λογαριασμού",
        "posData": "Δεδομένα POS",
        "chequeData": "Δεδομένα Επιταγής",
        "forbidChangeProductsBuys": "Να μην είναι επεξεργάσιμη η τιμή των ειδών στις αγορές",
        "autocompleteProductsInClassification": "Αυτόματη συμπλήρωση ειδών στον χαρακτηρισμό",
        "autoUpdatePriceSale": "Να ενημερώνεται αυτόματα η τιμή είδους μετά από πώληση",
        "autoUpdatePriceBuy": "Να ενημερώνεται αυτόματα η τιμή είδους μετά από αγορά",
        "hide0stockProducts": "Απόκρυψη ειδών με μηδενικό απόθεμα κατά την πώληση",
        "paymentOptions": "Ρυθμίσεις Τρόπου Πληρωμής",
        "createAutomaticSupplierPayment": "Αυτόματη δημιουργία πληρωμής προμηθευτή",
        "preselectedPOSBankAccount": "Προεπιλεγμένο POS/Τραπεζικός Λογαριασμός",
        "wildcards": "Μεταβλητές",
        "addWildcard": "Προσθήκη Μεταβλητής",
        "clickWildcard" : "Πατήστε πάνω στην μεταβλητή για να την προσθέσετε στην αιτία",
        "totalDeductibleNetValue": "Καθαρή Εκπ. Αξία",
        "totalDeductibleVAT": "Αξία Εκπ. Φ.Π.Α.",
        "totalNonDeductibleNetValue": "Μη Εκπ. Καθαρή Αξία",
        "totalNonDeductibleVAT": "Μη Εκπ. Αξία Φ.Π.Α.",
        "numbering": "Αρίθμηση",
        "applyFilter": "Εφαρμογή Φίλτρων",
        "noData": "Δεν βρέθηκαν δεδομένα",
        "filterBy": "Φιλτράρισμα κατά",
        "0vatReason": "Κατηγορία Εξαίρεσης Φ.Π.Α.",
        "customVat": "Προσαρμοσμένος Φ.Π.Α.",
        "subject": "Θέμα",
        "details": "Λεπτομέρειες",
        "followUpDate": "Επόμενη Ημερομηνία",
        "followUpDateFrom": "Επόμενη Ημερομηνία από",
        "followUpDateTo": "Επόμενη Ημερομηνία μέχρι",
        "done": "Ολοκληρωμένο",
        "activeSupplier": "Ενεργός Προμηθευτής",
        "autofillData": "Αυτόματη Συμπλήρωση Στοιχείων",
        "activity": "Δραστηριότητα",
        "supplierBalance": "Υπόλοιπο Προμηθευτή",
        "sum": "Άθροισμα",
        "census": "Απογραφή",
        "balance": "Υπόλοιπο",
        "BalanceTo": "Υπολογισμός υπολοίπου έως",
        "includeInactiveSuppliers": "Συμπερίληψη ανενεργών προμηθευτών",
        "includeInactiveClients": "Συμπερίληψη ανενεργών πελατών",
        "includeZeroBalanceSuppliers": "Συμπερίληψη προμηθευτών με μηδενικό υπόλοιπο",
        "includeZeroBalanceClients": "Συμπερίληψη πελατών με μηδενικό υπόλοιπο",
        "includeSettlements": "Συμπερίληψη διακανονισμών",
        "includeInactive": "Συμπερίληψη Ανενεργών",
        "accountingAccountType": "Τύπος Λογιστικού Λογαριασμού",
        "templateAccountName": "Όνομα προτύπου λογαριασμού",
        "supplierFrom": "Προμηθευτής από",
        "supplierTo": "Προμηθευτής μέχρι",
        "instructions": "Οδηγίες",
        "instructionsCodeMask": "Το πρόθεμα χρησιμοποιείται για τη δημιουργία του κωδικού προμηθευτή. Ο χαρακτήρας *, παράγει αυξανόμενη αρίθμηση. Παράδειγμα: ABC-***, παράγει τον κωδικό ABC-001",
        "categoryName": "Όνομα Κατηγορίας",
        "subcategoryName": "Όνομα Υποκατηγορίας",
        "codeMask": "Μορφή Κωδικού",
        "dateSelection": "Επιλογή Ημερομηνιών",
        "thisMonth": "Αυτόν τον μήνα",
        "lastMonth": "Τον προηγούμενο μήνα",
        "thisYear": "Αυτήν την χρονιά",
        "monthSelection": "Επιλογή Μηνός",
        "fastFilter": "Γρήγορη επιλογή φίλτρου",
        "amountFrom": "Ποσό από",
        "amountTo": "Ποσό μέχρι",
        "showInactiveSuppliers": "Εμφάνιση Ανενεργών Προμηθευτών",
        "credit": "Πίστωση",
        "debit": "Χρέωση",
        "cashRegister": "Ταμειακή Μηχανή",
        "printer": "Εκτυπωτής",
        "exportPDF": "Εξαγωγή ως PDF",
        "exportPNG": "Εξαγωγή ως PNG",
        "employee": "Εργαζόμενος",
        "user": "Χρήστης",
        "logTypes": "Τύπος Εγγραφής",
        "AccountingYearlyResults": "Κανόνες Ετησίων Αποτελεσμάτων",
        "articleCategory": "Κατηγορία Άρθρου",
        "articleSubcategory": "Υποκατηγορία Άρθρου",
        "articleCreator": "Δημιουργός Άρθρου",
        "invoiceType": "Είδος Παραστατικού",
        "correlatedΑrticle": "συσχετιζόμενο άρθρο",
        "clearCorrelatedΑrticle": "Καθαρισμός συσχετιζόμενου άρθρου",
        "accountingRecordNotes": "Σημειώσεις Λογιστικού Άρθρου",
        "selectInvoiceType": "Επιλογή Τύπου Παραστατικού",
        "preferredSalePrice": "Προτιμώμενη τιμή πώλησης",
        "preferredBuyPrice": "Προτιμώμενη τιμή αγοράς",
        "sendToMyData": "Αποστολή στο MyData",
        "bypassAccounting": "Παράκαμψη Λογιστικής Γέφυρας",
        "copyAccountRecord": "Αντιγραφή Λογιστικού Άρθρου",
        "copy": "Αντιγραφή",
        "filter": "Φίλτρο",
        "changeProfileImage": "Αλλαγή εικόνας προφίλ",
        "upload": "Ανέβασμα",
        "imageInstructions": "Επιτρέπονται φωτογραφίες",
        "pageRefreshAfterSave": "Η σελίδα θα ανανεωθεί αμέσως μετά την επιτυχή αποθήκευση",
        "passwordChange": "Αλλαγή κωδικού",
        "currentPassword": "Τωρινός κωδικός",
        "currentPasswordPlaceholder": "Εισάγετε τον τωρινό σας κωδικό",
        "newPassword": "Νέος κωδικός",
        "newPasswordPlaceholder": "Εισάγετε τον καινούργιο κωδικό",
        "passwordConfirm": "Επιβεβαίωση νέου κωδικού",
        "passwordConfirmPlaceholder": "Εισάγετε ξανά τον καινούργιο κωδικό",
        "changeUserDetails": "Αλλαγή στοιχείων χρήστη",
        "lastnamePlaceholder": "Εισάγετε επώνυμο",
        "emailPlaceholder": "Εισάγετε E-Mail",
        "language": "Γλώσσα",
        "refreshAfterSave": "Η σελίδα θα ανανεωθεί αμέσως μετά την επιτυχή αποθήκευση",
        "saveChanges": "Αποθήκευση Αλλαγών",
        "saveColumns": "Αποθήκευση Στηλών",
        "bankingConnected": "Διασυνδεδεμένος",
        "firstPage": "Πρώτη",
        "lastPage": "Τελευταία",
        "nextPage": "Επόμενη",
        "previousPage": "Προηγούμενη",
        "includingProductName": "Όνομα περιέχοντος είδους"
    },
    "Confirm": {
        "changeInvoiceType": "Είσαστε σίγουροι ότι θέλετε να αλλάξετε τύπο παραστατικού;"
    },
    "Headers": {
        "SalesGraphicReport": "Γραφική Αναφορά Πωλήσεων",
        "BuysNew": "Εισαγωγή Αγοράς",
        "BuysEdit": "Επεξεργασία Αγοράς",
        "BuysView": "Προβολή Αγοράς",
        "SupplierPaymentNew": "Εισαγωγή Πληρωμής",
        "SupplierPaymentEdit": "Επεξεργασία Πληρωμής",
        "BuysMyData": "Αναφορά MyData Αγορών",
        "BuysBalanceSheet": "Ανάλυση Αγορών",
        "SupplierBalanceSheet": "Ανάλυση Πληρωμών",
        "BuysGraphicReport": "Γραφική Ανάλυση Αγορών",
        "BuysSettings": "Ρυθμίσεις Αγορών",
        "SupplierNew": "Εισαγωγή Προμηθευτή",
        "SupplierEdit": "Επεξεργασία Προμηθευτή",
        "SupplierMovementNew": "Εισαγωγή Κίνησης Προμηθευτών",
        "SupplierMovementEdit": "Επεξεργασία Κίνησης Προμηθευτών",
        "SupplierBalanceReport": "Υπόλοιπα Προμηθευτών",
        "SupplierMovementReport": "Καρτέλες Προμηθευτών",
        "SupplierSettings": "Ρυθμίσεις Προμηθευτών"
    },
    "InnerTabs": {
        "buysMyData": "Αναφορά MyData Αγορών",
        "settings": "Ρυθμίσεις",
        "buysEmailSettings": "Ρυθμίσεις E-Mail Αγορών",
        "installations": "Εγκαταστάσεις",
        "communicationHistory": "Ιστορικό Επικοινωνίας",
        "accounting": "Λογιστική"
    },
    "Placeholders": {
        "client": "Εισαγάγετε πελάτη",
        "notes": "Εισαγάγετε σημειώσεις",
        "selectInstallation": "Επιλέξτε εγκατάσταση",
        "selectSupplier": "Επιλέξτε προμηθευτή",
        "selectFilters": "Παρακαλώ επιλέξτε φίλτρα και πατήστε το κουμπί 'Εφαρμόστε φίλτρο'",
        "selectProductCode": "Επιλέξτε κωδικό είδους",
        "selectProductName": "Επιλέξτε όνομα είδους",
        "selectClient": "Επιλέξτε πελάτη",
        "selectEmployee": "Επιλέξτε εργαζόμενο",
        "reason": "Εισάγετε Αιτιολογία",
        "correlatedΑrticle": "Εισάγετε συσχετιζόμενο άρθρο",
        "accountingRecordNotes": "Προσθέστε Σημειώσεις Λογιστικού Άρθρου",
        "preferredSalePrice": "Τιμή πώλησης",
        "preferredBuyPrice": "Τιμή αγοράς"
    },
    "Required": {
        "selectSupplierFirst": "Παρακαλώ επιλέξτε προμηθευτή",
        "selectDocumentFirst": "Παρακαλώ επιλέξτε τύπο παραστατικού",
        "selectCategoryFirst": "Παρακαλώ επιλέξτε κατηγορία",
        "productList": "Η λίστα ειδών δεν μπορεί να είναι άδεια",
        "installation": "Η εγκατάσταση είναι υποχρεωτική.",
        "preNumber": "Η σειρά είναι υποχρεωτική.",
        "number": "Ο αριθμός είναι υποχρεωτικός",
        "supplier": "Ο προμηθευτής είναι υποχρεωτικός.",
        "emailOrPhone": "Παρακαλώ συμπληρώστε email ή τηλέφωνο.",
        "name": "Το όνομα είναι υποχρεωτικό.",
        "vatCategory": "Η κατηγορία Φ.Π.Α. είναι υποχρεωτική.",
        "0vatReason": "Η κατηγορία εξαίρεσης Φ.Π.Α. είναι υποχρεωτική.",
        "customVat": "Ο προσαρμοσμένος Φ.Π.Α. είναι υποχρεωτικός.",
        "vatNumber": "Το Α.Φ.Μ. είναι υποχρεωτικός.",
        "doy": "H Δ.Ο.Υ. είναι υποχρεωτική.",
        "activity": "Η δραστηριότητα είναι υποχρεωτική.",
        "country": "Η χώρα είναι υποχρεωτική.",
        "address": "Η διεύθυνση είναι υποχρεωτική.",
        "city": "Η πόλη είναι υποχρεωτική.",
        "postalCode": "Ο Τ.Κ. είναι υποχρεωτικός.",
        "invalidEmail": "Το e-mail δεν είναι σωστό."
    },
    "printResults": {
        "name": "Εκτύπωση Αποτελεσμάτων",
        "printer": "Εκτυπωτής",
        "pdf": "Αποθήκευση ως PDF",
        "excel": "Αποθήκευση ως Excel"
    },
    "January": "Ιανουάριος",
    "February": "Φεβρουάριος",
    "March": "Μάρτιος",
    "April": "Απρίλιος",
    "May": "Μάιος",
    "June": "Ιούνιος",
    "July": "Ιούλιος",
    "August": "Αύγουστος",
    "September": "Σεπτέμβριος",
    "October": "Οκτώβριος",
    "November": "Νοέμβριος",
    "December": "Δεκέμβριος",
    "Products": "Αποθήκη",
    "Sales": "Πωλήσεις",
    "Clients": "Πελάτες",
    "Suppliers": "Προμηθευτές",
    "Buys": "Αγορές",
    "Cash Registers - POS - Bank Accounts": "Ταμειακές Μηχανές - POS - Τραπεζικοί Λογαριασμοί",
    "SelectPlaceholder": "Επιλέξτε...",
    "Accounting": "Λογιστική",
    "Payroll": "Μισθοδοσία",
    "Prescription": "Συνταγογράφηση",
    "FixedAssets": "Πάγια",
    "Null": "Κενό",
    "Settings": "Ρυθμίσεις",
    "Retail": "Πελάτης Λιανικής",
    "Freelancer": "Ελεύθερος επαγγελματίας",
    "Patient": "Ασθενής",
    "Client within E.U.": "Πελάτης εντός Ε.Ε.",
    "Client outside E.U.": "Πελάτης εκτός Ε.Ε.",
    "translate Πελάτης Λιανικής": "Retail",
    "LoaderText": {
        "loading": "Φόρτωση",
        "cancel": "Ακύρωση",
        "loaderDesc5": "Παρακαλώ περιμένετε καθώς η διαδικασία άντλησης δεδομένων μπορεί να καθυστερήσει έως και 5 λεπτά. Μπορείτε να κλείσετε αυτό το παράθυρο και να συνεχίσετε την εργασία σας καθώς η διαδικασία εκτελείται στο παρασκήνιο.",
        "loaderDesc15": "Παρακαλώ περιμένετε καθώς η διαδικασία άντλησης δεδομένων μπορεί να καθυστερήσει έως και 15 λεπτά. Μπορείτε να κλείσετε αυτό το παράθυρο και να συνεχίσετε την εργασία σας καθώς η διαδικασία εκτελείται στο παρασκήνιο."
    },
    "RestartApplyFiltersModal": {
        "desc1": "Προειδοποίηση: Ένας άλλος χρήστης με όνομα: ",
        "desc2": " ήδη προσπαθεί να αντλήσει δεδομένα. Θέλετε να συνεχίσετε και να ακυρώσετε την προσπάθεια του χρήστη?"
    },
    "TabsText": {
        "start": "Αρχική",
        "products-new": "Εισαγωγή είδους",
        "products-search": "Αναζήτηση ειδών",
        "edit-product": "Επεξεργασία είδους",
        "product-movements-new": "Εισαγωγή Κινήσεων Ειδών",
        "product-movements-search": "Αναζήτηση Κινήσεων Ειδών",
        "edit-product-movements": "Επεξεργασία Κινήσεων Ειδών",
        "product-pricelist-new": "Εισαγωγή Τιμοκαταλόγου",
        "pricelist-search": "Αναζήτηση Τιμοκαταλόγου",
        "edit-price-list": "Επεξεργασία Τιμοκαταλόγου",
        "product-balancesheet-reports": "Υπόλοιπο Ειδών",
        "product-movments-reports": "Κινήσεις Ειδών",
        "products-settings-product-categories": "Ρυθμίσεις",
        "sales-new": "Εισαγωγή Πωλήσεων",
        "sales-search": "Αναζήτηση Πωλήσεων",
        "primer-ai-url": "Primer AI",
        "view-sales": "Προβολή Πωλήσεων",
        "sales-quotations-new": "Εισαγωγή Προσφοράς",
        "sales-quotations-search": "Αναζήτηση Προσφορών",
        "sales-quotations-view": "Προβολή Προσφορών",
        "sales-quotations-edit": "Επεξεργασία Προσφοράς",
        "search-quick-retail-sales": "Αναζήτηση e-Ταμειακή",
        "new-client-payments": "Εισαγωγή Εισπράξεων",
        "search-client-payments": "Αναζήτηση Εισπράξεων",
        "edit-client-payments": "Επεξεργασία Εισπράξεων",
        "new-automatic-sales": "Εισαγωγή Αυτόματων Πωλήσεων",
        "search-automatic-sales": "Αναζήτηση Αυτόματων Πωλήσεων",
        "edit-automatic-sales": "Επεξεργασία Αυτόματων Πωλήσεων",
        "mydata-report": "Αναφορά MyData Πωλήσεων",
        "sales-monthly-turnover": "Τζίρος Πωλήσεων Ανά Περίοδο",
        "buys-monthly-turnover": "Τζίρος Αγορών Ανά Περίοδο",
        "sales-balance-sheet": "Ανάλυση Πωλήσεων",
        "sales-graphic-report": "Γραφική Αναφορά",
        "emron-payments": "Μηνιαίες Χρεώσεις",
        "client-payments-report": "Αναφορά Εισπράξεων",
        "sales-general-settings": "Ρυθμίσεις Πωλήσεων",
        "quick-retail-sales-settings": "Ρυθμίσεις e-Ταμειακή",
        "new-client": "Εισαγωγή πελάτη",
        "search-client": "Αναζήτηση πελάτη",
        "edit-client": "Επεξεργασία πελάτη",
        "new-client-movements": "Εισαγωγή Κινήσεων Πελατών",
        "search-client-movements": "Αναζήτηση Κινήσεων Πελατών",
        "edit-client-movements": "Επεξεργασία Κινήσεων Πελατών",
        "client-balance": "Υπόλοιπο Πελάτη",
        "clients-movements": "Κινήσεις Πελάτη",
        "report-client-isozygio": "Ισοζύγιο Πελατών",
        "clients-settings": "Ρυθμίσεις Πελατών",
        "cash-registers-new": "Εισαγωγή Ταμειακών Μηχανών",
        "cash-registers-search": "Αναζήτηση Ταμειακών Μηχανών",
        "new-pos": "Εισαγωγή POS",
        "search-pos": "Αναζήτηση POS",
        "edit-pos": "Επεξεργασία POS",
        "new-bank-account": "Εισαγωγή Τραπεζικού Λογαριασμού",
        "search-bank-account": "Αναζήτηση Τραπεζικού Λογαριασμού",
        "edit-bank-account": "Επεξεργασία Τραπεζικού Λογαριασμού",
        "cash-reports": "Αναφορές Ταμειακών",
        "general-settings": "Γενικές ρυθμίσεις",
        "primer-my-data": "Κωδικοί MyData",
        "primer-my-data-data": "Δεδομένα MyData",
        "basic-types-new": "Εισαγωγή Βασικού Παραστατικού",
        "basic-types-search": "Αναζήτηση Βασικού Παραστατικού",
        "edit-basic-types": "Επεξεργασία Βασικού Παραστατικού",
        "advanced-types-new": "Εισαγωγή Γενικού Παραστατικού",
        "advanced-types-search": "Αναζήτηση Γενικού Παραστατικού",
        "edit-advanced-types": "Επεξεργασία Γενικού Παραστατικού",
        "company-settings": "Ρυθμίσεις Εταιρίας",
        "system-tasks": "Εργασίες Συστήματος",
        "email-smtp": "Email SMTP",
        "subscriptions" : "Συνδρομές",
        "settings-import": "Ρυθμίσεις Εισαγωγής",
        "settings-export": "Ρυθμίσεις Εξαγωγής",
        "settings-backup": "Ρυθμίσεις Backup",
        "settings-restore": "Ρυθμίσεις Restore",
        "employee-new": "Εισαγωγή Υπαλλήλου",
        "employee-edit": "Επεξεργασία Υπαλλήλου",
        "employee-search": "Αναζήτηση Υπαλλήλων",
        "accounting-account-new": "Εισαγωγή Λογιστικού Λογαριασμού",
        "accounting-account-edit": "Επεξεργασία Λογιστικού Λογαριασμού",
        "accounting-account-search": "Αναζήτηση Λογιστικών Λογαριασμών",
        "accounting-record-new": "Εισαγωγή Λογιστικού Άρθρου",
        "accounting-record-edit": "Επεξεργασία Λογιστικού Άρθρου",
        "accounting-record-search": "Αναζήτηση Λογιστικών Άρθρων",
        "accounting-record-settings": "Ρυθμίσεις Προτύπων Εγγραφής",
        "accounting-settings": "Ρυθμίσεις Προτύπων Λογαριασμών",
        "reports-client-subscriptions": "Συνδρομές Πελατών",
        "accounting-report-isozygio": "Ισοζύγιο",
        "accounting-report-accounts": "Καρτέλα Λογαριασμών",
        "accounting-report-calendar": "Ημερολόγιο Λογαριασμών",
        "accounting-report-general-calendar": "Γενικό Ημερολόγιο",
        "accounting-ie-book": "Βιβλίο Εσόδων/Εξόδων",
        "buys-new": "Εισαγωγή Αγοράς",
        "buys-search": "Αναζήτηση Αγορών",
        "edit-buys": "Επεξεργασία Αγοράς",
        "buys-mydata-report": "Αναφορά MyData Αγορών",
        "buys-balance-sheet": "Ανάλυση Αγορών",
        "accounting-bridge-settings": "Λογιστική Γέφυρα",
        "new-supplier": "Εισαγωγή Προμηθευτή",
        "edit-supplier": "Επεξεργασία Προμηθευτή",
        "search-supplier": "Αναζήτηση Προμηθευτών",
        "new-supplier-movements": "Εισαγωγή Κίνησης Προμηθευτών",
        "edit-supplier-movements": "Επεξεργασία Κίνησης Προμηθευτών",
        "search-supplier-movements": "Αναζήτηση Κινήσεων Προμηθευτών",
        "supplier-balance": "Υπόλοιπα Προμηθευτών",
        "suppliers-movements": "Κινήσεις Προμηθευτών",
        "report-supplier-isozygio": "Ισοζύγιο Προμηθευτών",
        "suppliers-settings": "Ρυθμίσεις Προμηθευτών",
        "reports-primer-payments": "Πληρωμές Συνδρομών",
        "cdr-viewer": "Αναφορά Τηλεφωνικού",
        "accounting-year-report": "Ετήσια Αποτελέσματα",
        "buys-general-settings": "Ρυθμίσεις Αγορών",
        "buys-graphic-report": "Γραφική Εκτύπωση Αγορών",
        "supplier-payments-report": "Ανάλυση Πληρωμών",
        "new-supplier-payments": "Εισαγωγή Πληρωμής",
        "edit-supplier-payments": "Επεξεργασία Πληρωμής",
        "search-supplier-payments": "Αναζήτηση Πληρωμών",
        "cash-settings-accounting": "Ρυθμίσεις Λογ. Ταμειακών",
        "primer-client-payments": "Μαζ. Εισαγωγή Εισπράξεων",
        "emron-client-payments": "Μαζ. Εισαγωγή Εισπράξεων",
        "user-settings": "Ρυθμίσεις Χρήστη",
        "manage-companies": "Διαχείριση Εταιρειών",
        "reports-emron-settlements": "Ανάλυση Διακανονισμών",
        "reports-primer-pos": "Διαχείριση POS",
        "primer-pos-new-list": "Εισαγωγή Λίστας Αποστολής",
        "primer-pos-search-list": "Αναζήτηση Λιστών Αποστολής",
        "edit-cash-registers": "Επεξεργασία Ταμειακής Μηχανής",
        "payroll-settings": "Ρυθμίσεις Μισθοδοσίας",
        "working-program": "Πρόγραμμα Εργασίας",
        "working-program-employee": "Πρόγραμμα Εργασίας Εργαζομένου",
        "new-work-movement": "Εισαγωγή Κίνησης Εργαζομένου",
        "edit-work-movement": "Επεξεργασία Κίνησης Εργαζομένου",
        "search-work-movements": "Αναζήτηση Κινήσεων Εργαζομένων",
        "new-dcl": "Ψηφιακό Πελατολόγιο",
        "edit-dcl": "Επεξεργασία Κίνησης Ψηφιακού Πελατολογίου",
        "search-dcl": "Αναζήτηση Κινήσεων Ψηφιακού Πελατολογίου",
        "payroll-qr-scanner": "Σαρωτής QR",
        "master-log-search": "Ιστορικό συστήματος",
        "reports-companies-ai-usage": "Στατιστικά Χρήσης AI",
        "ergani-submissions-report": "Αιτήματα Εργάνης",
        "employee-view": "Κάρτα Εργαζομένου",
        "new-work-permit": "Νέες Άδειες Εργαζομένων",
        "edit-work-permit": "Προβολή Αδειών Εργαζομένων",
        "search-work-permits": "Αναζήτηση Αδειών Εργαζομένων",
        "components": "Components",
        "new-quick-retail-sales": "Εισαγωγή πωλήσεων (e-Ταμειακή)",
        "accounting-transfer": "Μεταφορά Λογαριασμού",
        "payroll-hour-report": "Ωρομέτρηση",
        "cloud": "Primer Connect",
        "reports-primer-payments-admin": "Πράξεις Συνδρομών",
        "accounting-closure": "Κλείσιμο Λογαριασμών",
        "accounting-operating-statement": "Γενική Εκμετάλλευση",
        "prescription-settings": "Ρυθμίσεις Συνταγογράφησης",
        "visit-new": "Νέα Επίσκεψη",
        "visit-active": "Ενεργή Επίσκεψη",
        "search-visits": "Αναζήτηση Επισκέψεων",
        "search-prescriptions": "Αναζήτηση Συνταγών",
        "search-referrals": "Αναζήτηση Παραπεμπτικών",
        "search-icd10s": "Αναζήτηση ICD-10",
        "search-drugs": "Αναζήτηση Φαρμάκων",
        "search-exams": "Αναζήτηση Εξετάσεων",
        "visit-edit": "Προβολή Επίσκεψης",
        "prescription-edit": "Προβολή Συνταγής",
        "referral-edit": "Προβολή Παραπεμπτικού",
        "prescription-home": "Συνταγογράφηση",
        "patient-history": "Ιστορικό Ασθενή",
        "reports-drugs": "Συνταγογραφημένα Φάρμακα",
        "reports-prescriptions": "Αναφορά Συνταγών",
        "classifications-report": "Αναφορά Χαρακτηρισμών",
        "accounting-report-vat-information": "Αναφορά Φ2 ΦΠΑ",
        "accounting-issue-vat-information": "Έκδοση Φ2 ΦΠΑ",
        "accounting-issue-f4-vat-information": "Έκδοση Φ4",
        "accounting-issue-f5-vat-information": "Έκδοση Φ5",
        "accounting-submitted-declarations": "Αναζήτηση Δηλώσεων Φ2",
        "accounting-submitted-f4-declarations": "Αναζήτηση Δηλώσεων Φ4",
        "accounting-submitted-f5-declarations": "Αναζήτηση Δηλώσεων Φ5",
        "accounting-debts-search": "Αναζήτηση Οφειλών",
        "prescription-monthly-invoicing": "Μηνιαία Τιμολόγηση",
        "accounting-banking-transactions": "Τραπεζικές Συναλλαγές",
        "accounting-banking-agreements": "Τραπεζικές Διασυνδέσεις",
        "accounting-banking-agreements-admin": "Τραπεζικές Διασυνδέσεις",
        "work-permit-report": "Αναφορά Αδειών",
        "fixedassets-settings": "Ρυθμίσεις Παγίων",
        "new-fixed-asset": "Εισαγωγή Παγίου",
        "edit-fixed-asset": "Επεξεργασία Παγίου",
        "new-fixed-asset-movement": "Εισαγωγή Κίνησης Παγίων",
        "edit-fixed-asset-movement": "Επεξεργασία Κίνησης Παγίων",
        "new-fixed-asset-record": "Εισαγωγή Απόσβεσης",
        "edit-fixed-asset-record": "Επεξεργασία Απόσβεσης",
        "search-fixed-assets": "Αναζήτηση Παγίων",
        "search-fixed-asset-movements": "Αναζήτηση Κινήσεων Παγίων",
        "search-fixed-asset-records": "Αναζήτηση Αποσβέσεων",
        "report-fixed-asset-movements": "Καρτέλες Παγίων",
        "report-fixed-asset-book": "Βιβλίο Παγίων",
        "report-sold-fixed-assets": "Πωληθέντα Πάγια",
        "report-client-provider-contracts": "Συμβόλαια Παρόχου",
        "ai-settings": "Ρυθμίσεις AI",
        "ai-module": "AI",
        "new-transfer": "Εισαγωγή Διακίνησης",
        "search-transfers": "Αναζήτηση Διακινήσεων",
        "generated-group-qrs": "Ομαδικοί Κωδικοί QR",
        "new-cheque": "Εισαγωγή Επιταγής",
        "edit-cheque": "Επεξεργασία Επιταγής",
        "search-cheques": "Αναζήτηση Επιταγών",
        "cheque-report": "Αναφορά Επιταγών",
        "new-loan": "Εισαγωγή Δανείου",
        "edit-loan": "Επεξεργασία Δανείου",
        "search-loans": "Αναζήτηση Δανείου",
        "loan-report": "Αναφορά Δανείων",
        "banking-settings": "Ρυθμίσεις Όψεως",
        "accounting-ai-banking-transactions": "Τραπ. Συν. AI",
        "view-submitted-vat-declaration": "Δήλωση ΦΠΑ",
        "cards-new": "Εισαγωγή Κάρτας",
        "cards-edit": "Επεξεργασία Κάρτας",
        "cards-search": "Αναζήτηση Καρτών"
    },
    "SearchTableIndex": {
        "filterBy": "Φιλτράρισμα Κατά",
        "dateFrom": "Ημερομηνία Από",
        "dateTo": "Ημερομηνία Μέχρι",
        "applyFilter": "Εφαρμογή φίλτρων",
        "sendFilteredToMyData": "Αποστολή φιλτραρισμένων στο MyData",
        "warning": "Προειδοποίηση!",
        "message": "Προειδοποίηση: Όλα τα παραστατικά που ταιριάζουν με τα φίλτρα θα σταλούν στο MyData, θέλετε να συνεχίσετε;",
        "no": "Όχι",
        "yes": "Ναι",
        "sendToMyDataReport": "Αποστολή αναφοράς στο MyData",
        "message2": "Παρακάτω εμφανίζονται τα αποτελέσματα για την αποστολή των επιλεγμένων παραστατικών στο MyData:",
        "filters": "Φίλτρα"
    },
    "SaveAsTemplateIndex": {
        "saveAsTemplate": "Αποθήκευση Προτύπου",
        "nameOfNewTemplate": "Όνομα Νέου Προτύπου",
        "placeholder": "Όνομα Προτύπου",
        "message": "Να επιτρέπεται στους χρήστες χωρίς δικαιώματα να γράφουν επιπλέον δεδομένα",
        "useTemplateForAutomaticSales": "Χρησιμοποιήστε το πρότυπο για αυτόματες πωλήσεις",
        "cancel": "Ακύρωση",
        "save": "Αποθήκευση"
    },
    "DataPanelIndex": {
        "template": {
            "template": "Πρότυπο",
            "placeholder": "Επιλέξτε Πρότυπο"
        },
        "sendEmailToExistingClientContactPoints": "Στείλτε email σε υπάρχοντα σημεία επαφής πελατών:",
        "placeholder": "Επιλέξτε ένα ή περισσότερα σημεία επαφής",
        "pleaseSelectAtLeastOneEmailAddress": "Επιλέξτε τουλάχιστον μία διεύθυνση email.",
        "sendEmailToCustomEmailAddresses": {
            "sendEmailToCustomEmailAddresses": "Αποστολή email σε προσαρμοσμένες διευθύνσεις email:",
            "placeholder": "Παρακαλώ γράψτε πολλά μηνύματα ηλεκτρονικού ταχυδρομείου διαχωρισμένα με κόμμα",
            "warning": "Εισαγάγετε μια σωστή διεύθυνση email."
        },
        "create": "Δημιουργία",
        "printLayout": "Διάταξη Εκτύπωσης",
        "print": "Εκτύπωση",
        "covertDocument": "Μετατροπή Παραστατικού",
        "convertQuotation": "Μετατροπή Προσφοράς",
        "issueCreditDocument": "Έκδοση Πιστωτικού Παραστατικού",
        "cancelInvoiceFromMyData": "Ακύρωση Τιμολογίου από το MyData",
        "clear": "Καθαρισμός",
        "saveAndRepeat": "Αποθήκευση και Επανάληψη",
        "delete": "Διαγραφή",
        "save": "Αποθήκευση",
        "templateChange": "Προειδοποίηση Αλλαγής Προτύπου!!",
        "templateWarning": "Όλα τα δεδομένα στη φόρμα θα αντικατασταθούν, είστε σίγουροι;",
        "no": "Όχι",
        "yes": "Ναι",
        "deleteConfirmation": "Επιβεβαίωση Διαγραφής",
        "activateConfirmation": "Επιβεβαίωση Ενεργοποίησης",
        "deleteMessage": "Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτό το στοιχείο;",
        "activateMessage": "Είστε βέβαιοι ότι θέλετε να αποθηκεύστε έναν ενεργό τιμοκατάλογο? Ένας άλλος τιμοκατάλογος είναι ήδη ενεργός και θα απενεργοποιηθεί αυτόματα με την αποθήκευση του νέου.",
        "cancel": "Ακύρωση",
        "convertDocumentConfirmation": "Επιβεβαίωση Μετατροπής Παραστατικού",
        "convertQuotationConfirmation": "Επιβεβαίωση Μετατροπής Προσφοράς",
        "convertDocumentMessage": "Πρόκειται να μετατρέψετε το επιλεγμένο παραστατικό. Θέλετε να συνεχίσετε;",
        "convertQuotationMessage": "Πρόκειται να μετατρέψετε την επιλεγμένη προσφορά.",
        "convertQuotationQuestion": "Θέλετε να συνεχίσετε;",
        "issueCreditDocumentConfirmation": "Έκδοση Επιβεβαίωσης Πιστωτικού Παραστατικού",
        "issueCreditDocumentMessage": "Πρόκειται να εκδώσετε ένα νέο πιστωτικό παραστατικό για αυτό το παραστατικό. Θέλετε να συνεχίσετε;",
        "cancelMyDataDocumentConfirmation": "Ακύρωση επιβεβαίωσης παραστατικού MyData",
        "cancelMyDataDocumentMessage": "Πρόκειται να ακυρώσετε αυτό το παραστατικό από το MyData. Θέλετε να συνεχίσετε?",
        "sendEmailOnSave": "Αποστολή email κατά την αποθήκευση",
        "convert": "Μετατροπή"
    },
    "DatePanelIndex": {
        "template": "Πρότυπο",
        "saveAndRepeat": "Αποθήκευση και Επανάληψη",
        "delete": "Διαγραφή"
    },
    "EditableTableIndex": {
        "printResults": {
            "printResults": "Εκτύπωση Αποτελεσμάτων",
            "printer": "Εκτυπωτής",
            "printToCSV": "Εκτύπωση σε CSV",
            "printToPDF": "Εκτύπωση σε PDF",
            "printToExcel": "Εκτύπωση σε Excel",
            "printToWord": "Εκτύπωση σε Word"
        },
        "deleteSelected": "Διαγραφή Επιλεγμένων",
        "warning": "Προειδοποίηση!",
        "warningMessage1": "Προειδοποίηση: Έχετε επιλέξει",
        "warningMessage2": "παραστατικά για αποστολή στο MyData, θέλετε να συνεχίσετε;",
        "no": "Όχι",
        "yes": "Ναι",
        "sendToMyDataReport": "Αποστολή Αναφοράς στο MyData",
        "sendToMyDataReportMessage": "Παρακάτω εμφανίζονται τα αποτελέσματα για την αποστολή των επιλεγμένων Παραστατικών στο MyData:",
        "sendSelectedDocumentsToMyData": "Αποστολή Επιλεγμένων παραστατικών στο MyData"
    },
    "CompanyTable": {
        "company": "Επωνυμία Εταιρείας",
        "number": "Αριθμός",
        "selectCompanyAndYear": "Επιλέξτε Εταιρεία και Έτος",
        "selectYear": "Επιλέξτε Έτος",
        "close": "Κλείσιμο",
        "select": "Επιλογή",
        "placeholder": "Αναζήτηση με όνομα ή Α.Φ.Μ..."
    },
    "ProductsSideBar": {
        "Products": {
            "title": "Είδη",
            "new": "Εισαγωγή",
            "search": "Αναζήτηση"
        },
        "Movements": {
            "title": "Κινήσεις Ειδών",
            "new": "Εισαγωγή",
            "search": "Αναζήτηση"
        },
        "List": {
            "title": "Τιμοκατάλογος",
            "new": "Εισαγωγή",
            "search": "Αναζήτηση"
        },
        "Reports": {
            "title": "Εκτυπώσεις",
            "balanceSheet": "Υπόλοιπο Ειδών",
            "productMovements": "Κινήσεις Ειδών"
        },
        "Settings": {
            "title": "Ρυθμίσεις",
            "productCategories": "Κατηγορίες Ειδών"
        },
        "Components": {
            "title": "Components",
            "primerComponents": "Primer Components"
        }
    },
    "SalesSideBar": {
        "Sales": {
            "title": "Πωλήσεις",
            "new": "Εισαγωγή",
            "search": "Αναζήτηση",
            "primer-ai-url": "Primer AI"
        },
        "QuickRetailSales": {
            "title": "Cloud e-Ταμειακή",
            "new": "Εισαγωγή",
            "search": "Αναζήτηση"
        },
        "ClientPayments": {
            "title": "Εισπράξεις",
            "new": "Εισαγωγή",
            "search": "Αναζήτηση"
        },
        "AutomaticSales": {
            "title": "Αυτόματες Πωλήσεις",
            "new": "Εισαγωγή",
            "search": "Αναζήτηση"
        },
        "MyData": {
            "title": "MyData",
            "report": "Αναφορά MyData Πωλήσεων"
        },
        "Reports": {
            "title": "Εκτυπώσεις",
            "monthlyTurnover": "Τζίρος Ανά Περίοδο",
            "salesBalanceSheet": "Ανάλυση Πωλήσεων",
            "salesGraphicReport": "Γραφική Εκτύπωση",
            "clientPaymentReport": "Ανάλυση Εισπράξεων"
        },
        "Settings": {
            "title": "Ρυθμίσεις",
            "SalesGeneralSettings": "Γενικές Ρυθμίσεις Πωλήσεων",
            "QuickRetailSettings": "Cloud e-Ταμειακή"
        }
    },
    "BuysSideBar": {
        "Buys": {
            "title": "Αγορές",
            "new": "Εισαγωγή",
            "search": "Αναζήτηση"
        },
        "MyData": {
            "title": "MyData",
            "report": "Αναφορά MyData Αγορών"
        },
        "SupplierPayments": {
            "title": "Πληρωμές",
            "new": "Εισαγωγή",
            "search": "Αναζήτηση"
        },
        "Reports": {
            "title": "Εκτυπώσεις",
            "monthlyTurnover": "Τζίρος Ανά Περίοδο",
            "buysBalanceSheet": "Ανάλυση Αγορών",
            "buysGraphicReport": "Γραφική Εκτύπωση",
            "supplierPaymentsReport": "Ανάλυση Πληρωμών"
        },
        "Settings": {
            "title": "Ρυθμίσεις",
            "buysGeneralSettings": "Γενικές Ρυθμίσεις Αγορών"
        }
    },
    "ClientSideBar": {
        "General": {
            "title": "Πελάτες",
            "general": "Εισαγωγή",
            "search": "Αναζήτηση"
        },
        "Movements": {
            "title": "Κινήσεις Πελατών",
            "general": "Εισαγωγή",
            "search": "Αναζήτηση"
        },
        "Reports": {
            "title": "Εκτυπώσεις",
            "clientBalance": "Υπόλοιπα Πελατών",
            "clientsMovements": "Καρτέλες Πελατών"
        },
        "Settings": {
            "title": "Ρυθμίσεις",
            "clientSettings": "Ρυθμίσεις Πελάτη"
        }
    },
    "SupplierSideBar": {
        "General": {
            "title": "Προμηθευτές",
            "new": "Εισαγωγή",
            "search": "Αναζήτηση"
        },
        "Movements": {
            "title": "Κινήσεις Προμηθευτών",
            "new": "Εισαγωγή",
            "search": "Αναζήτηση"
        },
        "Reports": {
            "title": "Εκτυπώσεις",
            "supplierBalance": "Υπόλοιπα Προμηθευτών",
            "supplierMovements": "Καρτέλες Προμηθευτών"
        },
        "Settings": {
            "title": "Ρυθμίσεις",
            "supplierSettings": "Ρυθμίσεις Προμηθευτών"
        }
    },
    "AccountingSideBar": {
        "Employee": {
            "title": "Εργαζόμενοι",
            "new": "Εισαγωγή",
            "search": "Αναζήτηση"
        },
        "AccountingAccounts": {
            "title": "Λογιστικοί Λογαριασμοί",
            "new": "Εισαγωγή",
            "search": "Αναζήτηση"
        },
        "AccountingRecords": {
            "title": "Λογιστικές Εγγραφές",
            "new": "Εισαγωγή",
            "search": "Αναζήτηση"
        },
        "Reports": {
            "title": "Εκτυπώσεις",
            "balanceSheet": "Λογιστικό Υπόλοιπο",
            "accountActivities": "Δραστηριότητες Λογαριασμού",
            "accountRecords": "Αρχεία Λογαριασμού"
        },
        "Settings": {
            "title": "Ρυθμίσεις",
            "accounting": "Λογιστική",
            "sendMyDataData": "Αποστολή Δεδομένων MyData",
            "recordTemplates": "Πρότυπα Εγγραφών",
            "accountTransfer": "Μεταφορά Λογαριασμού"
        },
        "Forms": {
            "title": "Έντυπα"
        },
        "Debts": {
            "title": "Οφειλές",
            "search": "Αναζήτηση"
        }
    },
    "Cash": {
        "CashRegisters": {
            "title": "Ταμειακές Μηχανές",
            "new": "Εισαγωγή",
            "search": "Αναζήτηση"
        },
        "POS": {
            "title": "POS",
            "new": "Εισαγωγή",
            "search": "Αναζήτηση"
        },
        "bankAccounts": {
            "title": "Τραπεζικοί Λογαριασμοί",
            "new": "Εισαγωγή",
            "search": "Αναζήτηση"
        },
        "Reports": {
            "title": "Εκτυπώσεις",
            "cash": "Ταμειακά"
        },
        "Settings": {
            "title": "Ρυθμίσεις",
            "general": "Γενικά"
        }
    },
    "SettingsSideBar": {
        "PrimerMyData": {
            "title": "Κωδικοί MyData",
            "data": "Δεδομένα MyData"
        },
        "DocumentType": {
            "title": "Τύποι Παραστατικών",
            "basicTypesNew": "Εισαγωγή Βασικού Παρ.",
            "basicTypesSearch": "Αναζήτηση Βασικού Παρ.",
            "advancedTypesNew": "Εισαγωγή Γενικού Παρ.",
            "advancedTypesSearch": "Αναζήτηση Γενικού Παρ."
        },
        "GeneralSettings": {
            "title": "Γενικές Ρυθμίσεις",
            "companySettings": "Ρυθμίσεις Εταιρίας",
            "systemTasks": "Εργασίες Συστήματος",
            "emailSTMP": "Email SMTP",
            "subscriptions": "Συνδρομές",
            "logHistory": "Ιστορικό συστήματος",
            "aiUsageCompaniesReport": "Στατιστικά Χρήσης AI"
        },
        "ImportExport": {
            "title": "Εισαγωγή-Εξαγωγή",
            "import": "Εισαγωγή",
            "export": "Εξαγωγή"
        },
        "BackupRestore": {
            "title": "Backup-Restore",
            "backup": "Backup",
            "restore": "Restore"
        }
    },
    "NavBar": {
        "start": "Αρχική",
        "products": "Αποθήκη",
        "sales": "Πωλήσεις",
        "buys": "Αγορές",
        "clients": "Πελάτες",
        "suppliers": "Προμηθευτές",
        "cash": "Ταμειακά",
        "accounting": "Λογιστική",
        "payroll": "Μισθοδοσία",
        "prescription": "Συνταγογράφηση",
        "fixedassets": "Πάγια",
        "settings": "Ρυθμίσεις",
        "signOut": "Αποσύνδεση"
    },
    "Headings": {
        "newProduct": "Εισαγωγή Είδους",
        "editProduct": "Επεξεργασία Είδους",
        "newProductMovements": "Εισαγωγή Κινήσεων Ειδών",
        "editProductMovements": "Επεξεργασία Κινήσεων Ειδών",
        "newPriceList": "Νέος Τιμοκατάλογος",
        "editPriceList": "Επεξεργασία Τιμοκαταλόγου",
        "reportsBalanceSheet": "Υπόλοιπο Ειδών",
        "productMovements": "Κινήσεις Ειδών",
        "productCategoriesSettings": "Ρυθμίσεις Κατηγοριών Ειδών",
        "primerMyData": "Κωδικοί MyData",
        "settingsPrimerData": "Δεδομένα MyData",
        "newBasicTypes": "Εισαγωγή Βασικού Παραστατικού",
        "editBasicTypes": "Επεξεργασία Βασικού Παραστατικού",
        "basicTypesSearch": "Αναζήτηση Βασικού Παραστατικού",
        "newAdvancedType": "Εισαγωγή Γενικού Παραστατικού",
        "editAdvancedType": "Επεξεργασία Γενικού Παραστατικού",
        "advancedTypesSearch": "Αναζήτηση Γενικού Παραστατικού",
        "companySettings": "Ρυθμίσεις Εταιρίας",
        "systemTasks": "Εργασίες Συστήματος",
        "newClient": "Εισαγωγή Πελάτη",
        "searchClient": "Αναζήτηση Πελάτη",
        "editClient": "Επεξεργασία Πελάτη",
        "newClientMovements": "Εισαγωγή Κινήσεων Πελατών ",
        "editClientMovements": "Επεξεργασία Κινήσεων Πελατών ",
        "clientMovementsSearch": "Αναζήτηση Κινήσεων Πελατών ",
        "clientBalance": "Υπόλοιπο Πελάτη",
        "clientMovements": "Κινήσεις Πελάτη",
        "clientsSettings": "Ρυθμίσεις Πελατών",
        "newSales": "Εισαγωγή Πωλήσεων",
        "salesSearch": "Αναζήτηση Πωλήσεων",
        "viewSales": "Προβολή Πωλήσεων",
        "editSales": "Επεξεργασία Πωλήσεων",
        "newQuickRetailSales": "Εισαγωγή Cloud e-Ταμειακή",
        "QuickRetailSalesSearch": "Αναζήτηση Cloud e-Ταμειακή",
        "editQuickRetailSales": "Επεξεργασία Cloud e-Ταμειακή",
        "clientPaymentsNew": "Εισαγωγή Εισπράξεων",
        "clientPaymentsSearch": "Αναζήτηση Εισπράξεων",
        "editClientPayments": "Επεξεργασία Εισπράξεων",
        "automaticSalesNew": "Εισαγωγή Αυτόματων Πωλήσεων",
        "editAutomaticSales": "Επεξεργασία Αυτόματων Πωλήσεων",
        "automaticSalesSearch": "Αναζήτηση Αυτόματων Πωλήσεων",
        "myDataDataReport" :"Αναφορά MyData Πωλήσεων",
        "salesBalanceSheet" :"Υπόλοιπο Πωλήσεων",
        "salesGraphicReport" :"Γραφική Αναφορά",
        "salesClientPaymentReport" :"Αναφορά Πληρωμής Πελάτη",
        "salesGeneralSettings": "Ρυθμίσεις Πωλήσεων",
        "quickRetailSalesSettings": "Ρυθμίσεις Cloud e-Ταμειακή",
        "newCashRegisters": "Εισαγωγή Ταμειακών Μηχανών",
        "cashRegistersSearch": "Αναζήτηση Ταμειακών Μηχανών",
        "editCashRegisters": "Επεξεργασία Ταμειακών Μηχανών",
        "newPOS": "Εισαγωγή POS",
        "searchPOS": "Αναζήτηση POS",
        "editPOS": "Επεξεργασία POS",
        "newEmployee": "Εισαγωγή Υπαλλήλου",
        "searchEmployee": "Αναζήτηση Υπαλλήλου",
        "editEmployee": "Επεξεργασία Υπαλλήλου",
        "newAccountingAccount": "Εισαγωγή Λογιστικού Λογαριασμού",
        "searchAccountingAccount": "Αναζήτηση Λογιστικού Λογαριασμού",
        "editAccountingAccount": "Επεξεργασία Λογιστικού Λογαριασμού",
        "newAccountingRecord": "Εισαγωγή Λογιστικού Άρθρου",
        "searchAccountingRecord": "Αναζήτηση Λογιστικού Άρθρου",
        "editAccountingRecord": "Επεξεργασία Λογιστικού Άρθρου",
        "newBankAccount": "Εισαγωγή Τραπεζικού Λογαριασμού",
        "editBankAccount": "Επεξεργασία Τραπεζικού Λογαριασμού",
        "bankSearch": "Αναζήτηση Τράπεζας"
    },
    "ProductsNewGeneralTabs": {
        "general": "Γενικά",
        "otherTaxes": "Άλλοι Φόροι",
        "accounting": "Λογιστική",
        "tags": "Ετικέτες",
        "variants": "Παραλλαγές"
    },
    "ProductsNewGeneralEditTabs": {
        "general": "Γενικά",
        "otherTaxes": "Άλλοι Φόροι",
        "accounting": "Λογιστική",
        "tags": "Ετικέτες"
    },
    "ProductVariants": {
        "delete": "Διαγραφή παραλλαγής",
        "deleteMultiple": "Διαγραφή παραλλαγών",
        "confirmDelete": "Πρόκειται να διαγραφεί η παραλλαγή. Είστε βέβαιοι?",
        "confirmDeleteMultiple": "Πρόκειται να διαγραφούν οι επιλεγμένες παραλλαγές. Είστε βέβαιοι?",
        "autoCreate": "Δημιουργία όλων των παραλλαγών",
        "confirmAutoCreate": "Πρόκειται να δημιουργηθούν αυτόματα όλες οι πιθανές παραλλαγές με βάση τις ιδιότητες του είδους. Οι ήδη υπάρχουσες δε θα τροποποιηθούν.",
        "productProperties": "Ιδιότητες Είδους"
    },
    "ProductsMovementsNewTabs": {
        "general": "Γενικά"
    },
    "ProductsNewGeneral": {
        "table": {
            "name": "Όνομα",
            "rowType": "Κατηγορία Γραμμής",
            "invoiceType": "Τύπος Παραστατικού",
            "category": "Κατηγορία",
            "type": "Τύπος",
            "vatExpenseType": "Τύπος Εξόδων για Φ.Π.Α."
        },
        "message": "Επιλέξτε κατηγορία πρώτα....",
        "invetoryBalance": "Υπόλοιπο αποθέματος ειδών:",
        "productActive": "Ενεργό Είδος:",
        "files": "Αρχεία",
        "errorMessage": "Το My Data πρέπει να έχει τουλάχιστον μία σειρά",
        "productCategory": {
            "productCategory": "Κατηγορία Είδους",
            "required": "Απαιτείται η κατηγορία ειδών."
        },
        "productName": {
            "productName": "Ονομασία είδους",
            "placeholder": "Ονομασία είδους",
            "required": "Απαιτείται όνομα είδους."
        },
        "alternativeName": {
            "alternativeName": "Εναλλακτικό Όνομα",
            "placeholder": "Εναλλακτικό Όνομα"
        },
        "productCode": {
            "productCode": "Κωδικός Είδους",
            "placeholder": "Κωδικός Είδους"
        },
        "alternativeCode": {
            "alternativeCode": "Εναλλακτικός κωδικός",
            "placeholder": "Εναλλακτικός κωδικός"
        },
        "vat": {
            "vat": "Φ.Π.Α. %",
            "required": "Απαιτείται Φ.Π.Α."
        },
        "customVat": {
            "customVat": "Προσαρμοσμένο % Φ.Π.Α.",
            "placeholder": "Προσαρμοσμένο % Φ.Π.Α",
            "required": "Απαιτείται προσαρμοσμένο Φ.Π.Α."
        },
        "0VatReason": {
            "0VatReason": "Κατηγορία Εξαίρεσης Φ.Π.Α.",
            "required": "Απαιτείται η κατηγορία εξαίρεσης Φ.Π.Α."
        },
        "measurementUnit": {
            "measurementUnit": "Μονάδα Μέτρησης",
            "required": "Απαιτείται μονάδα μέτρησης."
        },
        "preferredPrice": {
            "preferredPrice": "Προτιμώμενη τιμή",
            "placeholder": "Προτιμώμενη τιμή"
        },
        "vatIncluded": "Περιλαμβάνεται Φ.Π.Α.",
        "productNotes": "Σημειώσεις Είδους",
        "addProductNotes": "Προσθήκη Σημειώσεων Ειδών",
        "warning": "Προειδοποίηση Αλλαγής Κατηγορίας!",
        "warningMessage": "Τα δεδομένα που εισάγατε θα αλλάξουν, είστε σίγουροι;",
        "no": "Όχι",
        "yes": "Ναι",
        "packagingDetails": "Λεπτομέρειες Συσκευασίας",
        "packagingQuantity":  "Ποσότητα Συσκευασίας",
        "packagingType": "Τύπος Συσκευασίας"
    },
    "ProductsNewGeneralEdit": {
        "table": {
            "name": "Όνομα",
            "invoiceType": "Τύπος Παραστατικού",
            "category": "Κατηγορία",
            "type": "Τύπος",
            "vatExpenseType": "Τύπος Εξόδων για Φ.Π.Α."
        },
        "table2": {
            "supplierCode": "Κωδικός Προμηθευτή",
            "supplierName": "Όνομα Προμηθευτή",
            "vat": "Α.Φ.Μ."
        },
        "table3": {
            "code": "Κωδικός",
            "productName": "Ονομασία Είδους",
            "alternativeName": "Εναλλακτικό Όνομα"
        },
        "table4": {
            "type": "Τύπος",
            "address": "Διεύθυνση",
            "inventory": "Καταγραφή Εμπορευμάτων"
        },
        "save": "Αποθήκευση",
        "delete": "Διαγραφή",
        "message": "Επιλέξτε κατηγορία πρώτα....",
        "invetoryBalance": "Υπόλοιπο αποθέματος ειδών:",
        "productActive": "Ενεργό Είδος:",
        "files": "Αρχεία",
        "errorMessage": "Το My Data πρέπει να έχει τουλάχιστον μία σειρά",
        "productCategory": {
            "productCategory": "Κατηγορία Είδους",
            "required": "Απαιτείται η κατηγορία ειδών."
        },
        "productName": {
            "productName": "Ονομασία είδους",
            "placeholder": "Ονομασία είδους",
            "required": "Απαιτείται όνομα είδους."
        },
        "alternativeName": {
            "alternativeName": "Εναλλακτικό Όνομα",
            "placeholder": "Εναλλακτικό Όνομα"
        },
        "productCode": {
            "productCode": "Κωδικός Είδους",
            "placeholder": "Κωδικός Είδους"
        },
        "alternativeCode": {
            "alternativeCode": "Εναλλακτικός κωδικός",
            "placeholder": "Εναλλακτικός κωδικός"
        },
        "vat": {
            "vat": "Φ.Π.Α. %",
            "required": "Απαιτείται Φ.Π.Α."
        },
        "customVat": {
            "customVat": "Προσαρμοσμένο % Φ.Π.Α.",
            "placeholder": "Προσαρμοσμένο % Φ.Π.Α",
            "required": "Απαιτείται προσαρμοσμένο Φ.Π.Α."
        },
        "0VatReason": {
            "0VatReason": "Κατηγορία Εξαίρεσης Φ.Π.Α.",
            "required": "Απαιτείται η κατηγορία εξαίρεσης Φ.Π.Α."
        },
        "measurementUnit": {
            "measurementUnit": "Μονάδα Μέτρησης",
            "required": "Απαιτείται μονάδα μέτρησης."
        },
        "preferredPrice": {
            "preferredPrice": "Προτιμώμενη τιμή",
            "placeholder": "Προτιμώμενη τιμή"
        },
        "vatIncluded": "Περιλαμβάνεται Φ.Π.Α.",
        "productNotes": "Σημειώσεις είδους",
        "addProductNotes": "Προσθήκη Σημειώσεων Είδους"
    },
    "ProductsNewOtherTaxes": {
        "otherTaxes": "Άλλοι φόροι",
        "withholdTaxes": "Παρακρατούμενοι Φόροι",
        "stamp": "Χαρτόσημο",
        "fees": "Τέλη",
        "message": "Επιλέξτε κατηγορία είδους για ενεργοποίηση πεδίων",
        "message2": "*Εδώ μπορείτε να επιλέξετε τους άλλους φόρους του είδους. Εάν επιλέξετε έναν φόρο που έχει αξία ευρώ (για παράδειγμα 5 ευρώ), η συνολική τιμή του είδους θα υπολογιστεί ως ο συνολικός φόρος. Σε αυτήν την περίπτωση, μπορείτε να χρησιμοποιήσετε το είδος ΜΟΝΟ για λόγους φόρου.",
        "save": "Αποθήκευση"
    },
    "ProductsNewAccounting": {
        "accounting": "Λογιστική",
        "message": "Έρχεται σύντομα..."
    },
    "ProductsNewTags": {
        "productCodes": "Κωδικοί ειδών",
        "productTag": "Ετικέτα είδους",
        "addTag": "Προσθήκη ετικέτας",
        "table": {
            "supplier": "Προμηθευτής",
            "productName": "Ονομασία Είδους",
            "productCode": "Κωδικός Είδους",
            "selectSupplierName": "Επιλέξτε Όνομα Προμηθευτή"
        },
        "table2": {
            "supplierCode": "Κωδικός Προμηθευτή",
            "supplierName": "Όνομα Προμηθευτή",
            "vat": "Α.Φ.Μ."
        },
        "table3": {
            "code": "Κωδικός",
            "productName": "Ονομασία Είδους",
            "alternativeName": "Εναλλακτικό Όνομα"
        },
        "save": "Αποθήκευση"
    },
    "ProductsSearchGeneral": {
        "table": {
            "productCode": "Κωδικός Είδους",
            "productName": "Ονομασία Είδους",
            "productCategory": "Κατηγορία / Υποκατηγορία Είδους",
            "productTags": "Ετικέτες Ειδών",
            "alternativeName": "Εναλλακτικό Όνομα",
            "alternativeCode": "Εναλλακτικός Κωδικός",
            "productInventoryBalance": "Υπόλοιπο Αποθέματος Ειδών",
            "productActive": "Ενεργό Είδος",
            "productPrice": "Τιμή Πώλησης",
            "productBuyPrice": "Τιμή Αγοράς",
            "supplierProductName": "Όνομα Προμηθευτή Είδους",
            "supplierProductCode": "Κωδικός Προμηθευτή Είδους"
        },
        "tableFilter": {
            "productNameFrom": "Όνομα Είδους Από",
            "productNameTo": "Όνομα Είδους Μέχρι",
            "productCodeFrom": "Κωδικός Είδους Από",
            "productCodeTo": "Κωδικός Είδους Μέχρι",
            "productCategoryFrom": "Κατηγορία Είδους Από",
            "productCategoryTo": "Κατηγορία Είδους Μέχρι",
            "supplierProductNameFrom": "Όνομα είδους προμηθευτή Από",
            "supplierProductNameTo": "Όνομα είδους προμηθευτή Μέχρι",
            "supplierProductCodeFrom": "Κωδικός είδους προμηθευτή Από",
            "supplierProductCodeTo": "Κωδικός είδους Προμηθευτή Μέχρι",
            "showInActiveProducts": "Εμφάνιση μη ενεργών ειδών"
        }
    },
    "ProductsMovementsNew": {
        "smallTable": {
            "code": "Κωδικός",
            "productName": "Ονομασία Είδους",
            "alternativeName": "Εναλλακτική Ονομασία"
        },
        "table": {
            "productCode": "Κωδικός Είδους",
            "productCodePlaceholder": "Επιλέξτε τον κωδικό είδους",
            "productName": "Ονομασία Είδους",
            "productNamePlaceholder": "Επιλέξτε το Όνομα του είδους",
            "mu": "Μ.Μ.",
            "quantity": "Ποσότητα",
            "required": "Ο πίνακας πρέπει να έχει τουλάχιστον μία σειρά"
        },
        "message": "Επιλέξτε πρώτα τον Τύπο εγγράφου..",
        "files": "Αρχεία",
        "documentTypes": "Τύπος Παραστατικών",
        "installation": "Εγκατάσταση",
        "preNumber": "Σειρά",
        "innerMovement": "Μεταφορά σε άλλη εγκατάσταση",
        "innerMovementMessage": "Αφήστε το κενό αν δεν είναι εσωτερική μεταφορά.",
        "number": {
            "number": "Αριθμός",
            "placeholder": "Αριθμός Εγγράφου"
        },
        "date": "Ημερομηνία",
        "reason": {
            "reason": "Αιτιολογία",
            "placeholder": "Εισάγετε αιτιολογία"
        },
        "sum": "Άθροισμα",
        "movementsNotes": "Σημειώσεις Κινήσεων",
        "addMovementsNotes": "Προσθέστε Σημειώσεις Κινήσεων"
    },
    "ProductsMovementsNewEdit": {
        "smallTable": {
            "code": "Κωδικός",
            "productName": "Ονομασία Είδους",
            "alternativeName": "Εναλλακτική Ονομασία"
        },
        "table": {
            "productCode": "Κωδικός Είδους",
            "productCodePlaceholder": "Επιλέξτε τον κωδικό είδους",
            "productName": "Ονομασία Είδους",
            "productNamePlaceholder": "Επιλέξτε το Όνομα του είδους",
            "mu": "Μ.Μ.",
            "quantity": "Ποσότητα",
            "required": "Ο πίνακας πρέπει να έχει τουλάχιστον μία σειρά"
        },
        "message": "Επιλέξτε πρώτα τον Τύπο εγγράφου..",
        "files": "Αρχεία",
        "documentTypes": "Τύπος Παραστατικού",
        "installation": "Εγκατάσταση",
        "preNumber": "Σειρά",
        "number": {
            "number": "Αριθμός",
            "placeholder": "Αριθμός Εγγράφου"
        },
        "date": "Ημερομηνία",
        "reason": {
            "reason": "Αιτιολογία",
            "placeholder": "Εισάγετε αιτιολογία"
        },
        "sum": "Άθροισμα",
        "movementsNotes": "Σημειώσεις Κινήσεων",
        "addMovementsNotes": "Προσθέστε Σημειώσεις Κινήσεων"
    },
    "ProductsMovementsSearch": {
        "table": {
            "date": "Ημερομηνία",
            "reason": "Αιτιολογία",
            "totalAmount": "Συνολική Αξία",
            "totalQuantity": "Συνολική Ποσότητα",
            "totalNetValue": "Συνολική Καθαρή Αξία",
            "totalVatValue": "Συνολική Αξία Φ.Π.Α.",
            "products": "Είδη",
            "number": "Αριθμός",
            "documentType": "Τύπος Παραστατικού"
        }
    },
    "ProductsListNewTabs": {
        "general": "Γενικά"
    },
    "ProductsListNew": {
        "smallTable": {
            "code": "Κωδικός",
            "productName": "Ονομασία είδους",
            "alternativeName": "Εναλλακτικό Όνομα"
        },
        "table": {
            "productCode": "Κωδικός Είδους",
            "productName": "Ονομασία Είδους",
            "client": "Πελάτης",
            "price": "Τιμή",
            "vat": "Φ.Π.Α.",
            "discount": "Έκπτωση",
            "placeholderCode": "Επιλέξτε Κωδικό Είδους",
            "placeholderName": "Επιλέξτε Όνομα Είδους"
        },
        "pricelistActive": "Ενεργός Τιμοκατάλογος",
        "name": "Όνομα",
        "namePlaceholder": "Εισαγάγετε το όνομα του τιμοκαταλόγου",
        "required": "Το όνομα είναι υποχρεωτικό πεδίο.",
        "files": "Αρχεία",
        "priceListNotes": "Σημειώσεις τιμοκαταλόγου",
        "addPriceListNotes": "Προσθέστε σημειώσεις τιμοκαταλόγου",
        "warning": "Ο πίνακας δεν πρέπει να είναι κενός."
    },
    "ProductsListNewEdit": {
        "smallTable": {
            "code": "Κωδικός",
            "productName": "Ονομασία είδους",
            "alternativeName": "Εναλλακτικό Όνομα"
        },
        "table": {
            "productCode": "Κωδικός Είδους",
            "productName": "Ονομασία Είδους",
            "client": "Πελάτης",
            "price": "Τιμή",
            "vat": "Φ.Π.Α.",
            "discount": "Έκπτωση"
        },
        "pricelistActive": "Ενεργός Τιμοκατάλογος",
        "name": "Όνομα",
        "namePlaceholder": "Εισαγάγετε το όνομα του τιμοκαταλόγου",
        "required": "Το όνομα είναι υποχρεωτικό πεδίο.",
        "files": "Αρχεία",
        "priceListNotes": "Σημειώσεις τιμοκαταλόγου",
        "addPriceListNotes": "Προσθέστε σημειώσεις τιμοκαταλόγου",
        "warning": "Ο πίνακας δεν πρέπει να είναι κενός."
    },
    "ProductsListSearch": {
        "smallTable": {
            "priceListName": "Όνομα τιμοκαταλόγου",
            "showActivePriceList": "Εμφάνιση ενεργού τιμοκαταλόγου"

        },
        "table": {
            "productPriceList": "Τιμοκατάλογος ειδών",
            "active": "Ενεργά"
        }
    },
    "ReportsBalanceSheetTabs": {
        "general": "Γενικά"
    },
    "ReportsBalanceSheet": {
        "smallTable": {
            "productCode": "Κωδικός Είδους",
            "productName": "Ονομασία Είδους"
        },
        "table": {
            "inventory": "Καταγραφή Εμπορευμάτων",
            "productCode": "Κωδικός Είδους",
            "productName": "Ονομασία Είδους",
            "inventoryBalance": "Υπόλοιπο Αποθέματος Ειδών",
            "inactiveInventoryBalance": "Συμπερίληψη ανενεργών ειδών"
        },
        "productName": "Όνομα είδους",
        "filterMessage": "Παρακαλώ, επιλέξτε πρώτα φίλτρα και πατήστε \"Εφαρμογή φίλτρων\"\n",
        "includeInactiveProducts": "Συμπερίληψη ανενεργών ειδών",
        "includeZeroBalanceProducts": "Συμπερίληψη ειδών με μηδενικό απόθεμα",
        "applyFilter": "Εφαρμογή φίλτρων",
        "productsBalance": "Αποθήκη Ειδών",
        "page": "Σελίδα:",
        "of": "από",
        "first": "<< Πρώτη",
        "previous": "< Προηγούμενη",
        "next": "Επόμενη >",
        "last": "Τελευταία >>",
        "printResults": {
            "printResults": "Εκτύπωση Αποτελεσμάτων",
            "printer": "Εκτυπωτής",
            "printToCSV": "Εκτύπωση σε CSV",
            "printToPDF": "Εκτύπωση σε PDF",
            "printToExcel": "Εκτύπωση σε Excel",
            "printToWord": "Εκτύπωση σε Word"
        }
    },
    "ReportsProductMovementsTabs": {
        "general": "Γενικά"
    },
    "ReportsProductMovements": {
        "table": {
            "filterBy": "Φιλτράρισμα Κατά",
            "dateFrom": "Ημερομηνία Από",
            "productName": "Όνομα Είδους",
            "productFrom": {
                "productFrom": "Είδος Από",
                "placeholder": "Επιλέξτε Είδος"
            },
            "dateTo": "Ημερομηνία Έως",
            "productTo": {
                "productTo": "Είδος Μέχρι",
                "placeholder": "Επιλέξτε Είδος"
            },
            "includeProductsWithZeroBalance": "Συμπερίληψη ειδών με μηδενικό υπόλοιπο",
            "includeInactiveProducts": "Συμπερίληψη ανενεργών ειδών",
            "includeMovementsNotAffectingInventory": "Συμπερίληψη κινήσεων που δεν επηρεάζουν το απόθεμα"
        },
        "table2": {
            "date": "Ημερομηνία",
            "invoiceType": "Τύπος Παραστατικού",
            "number": "Αριθμός",
            "movementType": "Τύπος Κίνησης",
            "inventoryAmount": "Ποσό Αποθέματος",
            "balance": "Υπόλοιπο"
        },
        "filterMessage": "Παρακαλώ, επιλέξτε πρώτα φίλτρα και πατήστε \"Εφαρμογή φίλτρων\"",
        "applyFilter": "Εφαρμογή φίλτρων",
        "productTab": "Καρτέλα Είδους",
        "productCode": "Κωδικός Είδους:",
        "productName": "Ονομασία Είδους:",
        "page": "Σελίδα:",
        "of": "από",
        "first": "<< Πρώτη",
        "previous": "< Προηγούμενη",
        "next": "Επόμενη >",
        "last": "Τελευταία >>",
        "printResults": {
            "printResults": "Εκτύπωση Αποτελεσμάτων",
            "printer": "Εκτυπωτής",
            "printToCSV": "Εκτύπωση σε CSV",
            "printToPDF": "Εκτύπωση σε PDF",
            "printToExcel": "Εκτύπωση σε Excel",
            "printToWord": "Εκτύπωση σε Word"
        },
        "pageTotals": "Σύνολα",
        "totalInventoryAmount": "Συνολικό Ποσό Αποθέματος",
        "totalBalance": "Συνολικό Υπόλοιπο"
    },
    "ProductsSettingsTabs": {
        "settings": "Ρυθμίσεις"
    },
    "ProductsSettings": {
        "smallTable": {
            "categoryName": "Όνομα Κατηγορίας",
            "codeMask": "Πρόθεμα"
        },
        "table": {
            "name": "Όνομα",
            "invoiceType": "Τύπος παραστατικού",
            "category": "Κατηγορία",
            "type": "Τύπος"
        },
        "instructions": "Οδηγίες:",
        "text1": "Το όνομα κατηγορίας είναι το όνομα της κατηγορίας για το είδους",
        "text2": "Το πρόθεμα χρησιμοποιείται για τη δημιουργία του κωδικού είδους. Ο χαρακτήρας \"*\", παράγει αυξανόμενη αρίθμηση. Παράδειγμα: Abc-***, παράγει τον κωδικό Abc-001",
        "save": "Αποθήκευση",
        "categorySettings": "Ρυθμίσεις Κατηγορίας",
        "proposedMyDataValue": "Προτεινόμενος πίνακας myDATA",
        "taxes": "Φόροι",
        "vat%": "Φ.Π.Α. %",
        "0%vatReason": "Κατηγορία Εξαίρεσης Φ.Π.Α.",
        "otherTaxes": "Άλλοι Φόροι",
        "withHoldTaxes": "Παρακρατούμενοι Φόροι",
        "stamp": "Χαρτόσημο (Ψηφ. τέλος συν.)",
        "fees": "Τέλη",
        "measurementUnit": "Μονάδα Μέτρησης"
    },
    "SalesNewTabs": {
        "sales": "Πωλήσεις"
    },
    "SalesSearchTabs": {
        "search": "Αναζήτηση"
    },
    "QuotationsNewTabs": {
        "quotations": "Προσφορές"
    },
    "QuotationsSearchTabs": {
        "search": "Αναζήτηση"
    },
    "SalesNew": {
        "clientTable": {
            "code": "Κωδικός",
            "name": "Όνομα",
            "phone": "Τηλέφωνο",
            "email": "Ηλεκτρονική Διεύθυνση",
            "vatNumber": "Αριθμός Α.Φ.Μ."
        },
        "productTable": {
            "title": "Είδη",
            "code": {
                "code": "Κωδ. Είδους",
                "placeholder": "Επιλέξτε Κωδ. Είδους"
            },
            "name": {
                "name": "Ονομασία Είδους",
                "placeholder": "Επιλέξτε Όνομα Είδους"
            },
            "quantity": "Ποσότητα",
            "mu": "Μ.Μ.",
            "unitPrice": "Τιμή Μονάδας",
            "discount": "Έκπτωση",
            "vat": "Φ.Π.Α.%",
            "netValue": "Καθαρή Αξία",
            "vatValue": "Αξία Φ.Π.Α.",
            "taxes": "Φόροι",
            "totalValue": "Συνολική Αξία"
        },
        "extraDataTable": {
            "title": "Επιπλέον Δεδομένα",
            "locationDelivery": "Τοποθεσία Παράδοσης",
            "locationCountry": {
                "locationCountry": "Τοποθεσία Χώρας",
                "required": "Απαιτείται η τοποθεσία χώρας."
            },
            "locationCity": {
                "locationCity": "Τοποθεσία Πόλης",
                "required": "Απαιτείται η τοποθεσία πόλης."
            },
            "locationAddress": {
                "locationAddress": "Διεύθυνση τοποθεσίας",
                "required": "Απαιτείται διεύθυνση τοποθεσίας."
            },
            "locationPostalCode": {
                "locationPostalCode": "Ταχυδρομικός Κώδικας Τοποθεσίας",
                "required": "Απαιτείται ταχυδρομικός κώδικας τοποθεσίας ."
            },
            "wayOfSendingGoods": "Τρόπος αποστολής εμπορευμάτων",
            "otherTaxes": "Άλλοι Φόροι",
            "withHoldTaxes": "Παρακρατούμενοι Φόροι",
            "goodsSendDate": "Ημερομηνία Αποστολής Εμπορευμάτων",
            "carNumber": "Αριθμός Αυτοκινήτου",
            "fees": "Τέλη",
            "stampDuty": "Τέλος Χαρτοσήμου"
        },
        "productCodeTable": {
            "code": "Κωδικός",
            "alternativeCode": "Εναλλακτικός Κωδικός",
            "productName": "Ονομασία Είδους",
            "alternativeName": "Εναλλακτικό Όνομα"
        },
        "quickClientTable": {
            "name": "Όνομα Πελάτη",
            "vatCategory": "Κατηγορία Φ.Π.Α.",
            "vatNumber": "Α.Φ.Μ.",
            "phone": "Αριθμός Τηλεφώνου",
            "email": "Ηλεκτρονική Διεύθυνση",
            "address": "Διεύθυνση",
            "city": "Πόλη"
        },
        "corelatedTable": {
            "name": "Όνομα Πελάτη",
            "clientVat": "Α.Φ.Μ. πελάτη",
            "documentType": "Τύπος Παραστατικού",
            "date": "Ημερομηνία",
            "preNumber": "Σειρά",
            "number": "Αριθμός",
            "totalAmount": "Συνολικό Ποσό"
        },
        "salesTaxesTables": {
            "vat%": "Φ.Π.Α. %",
            "netValue": "Καθαρή Αξία €",
            "vat": "Φ.Π.Α. €",
            "withHoldTaxes": "Παρακρατούμενοι Φόροι",
            "otherTaxes": "Άλλοι Φόροι",
            "fees": "Τέλη",
            "stampDuty": "Τέλος Χαρτοσήμου"
        },
        "installationTable": {
            "type": "Τύπος",
            "address": "Διεύθυνση"
        },
        "totalsTable": {
            "title": "Σύνολα",
            "totalQuantity": "Συνολική Ποσότητα",
            "totalBeforeDiscount": "Σύνολο πριν από την Έκπτωση",
            "totalDiscount": "Συνολική Έκπτωση",
            "totalNetValue": "Συνολική Καθαρή Αξία",
            "totalVatAmount": "Συνολικό Ποσό Φ.Π.Α.",
            "totalWithHoldTaxesAmount": "Συνολικό Ποσό Παρακρατούμενων Φόρων",
            "totalTaxesAmount": "Συνολικό Ποσό Φόρων",
            "totalAmount": "Συνολικό ποσό",
            "paymentAmount": "Πληρωτέο Ποσό"
        },
        "message": "Επιλέξτε πρώτα τον Τύπο παραστατικού...",
        "message2": "Επιλέξτε πρώτα πελάτη..",
        "addNewClient": "Προσθήκη νέου πελάτη",
        "loading": "Φόρτωση...",
        "messageProductList": "Η λίστα ειδών δεν πρέπει να είναι κενή.",
        "myDataStatus": "Κατάσταση My Data",
        "files": "Αρχεία",
        "installation": "Εγκατάσταση",
        "DocumentType": "Τύπος Παραστατικού",
        "Date": "Ημερομηνία",
        "time": "Ώρα",
        "preNumber": {
            "preNumber": "Σειρά",
            "required": "Απαιτείται σειρά."
        },
        "number": {
            "number": "Αριθμός",
            "placeholder": "Αριθμός",
            "required": "Απαιτείται αριθμός."
        },
        "corelatedDocument": {
            "corelatedDocument": "Συσχετιζόμενο παραστατικό",
            "placeholder": "Επιλέξτε Συσχετιζόμενο παραστατικό",
            "required": "Απαιτείται Συσχετιζόμενο παραστατικό."
        },
        "newRetailClient": {
            "newRetailClient": "Νέος Πελάτης Λιανικής",
            "placeholder": "Προσθήκη νέου ονόματος πελάτη λιανικής"
        },
        "client": {
            "client": "Πελάτης",
            "placeholder": "Επιλέξτε Πελάτη",
            "required": "Απαιτείται ο Πελάτης."
        },
        "clientInstallation": {
            "clientInstallation": "Εγκατάσταση Πελάτη",
            "placeholder": "Εγκατάσταση Πελάτη"
        },
        "vat": "Α.Φ.Μ.",
        "email": {
            "email": "Ηλεκτρονική Διεύθυνση",
            "required": "Απαιτείται ηλεκτρονική διεύθυνση ή τηλέφωνο."
        },
        "phone": {
            "phone": "Τηλέφωνο",
            "required": "Απαιτείται ηλεκτρονική διεύθυνση ή τηλέφωνο."
        },
        "address": "Διεύθυνση",
        "doy": "Δ.Ο.Υ.",
        "city": "Πόλη",
        "pc": "Τ.Κ.",
        "paymentType": {
            "paymentType": "Τρόπος Πληρωμής",
            "required": "Απαιτείται ο τρόπος πληρωμής."
        },
        "displayAltName": "Προβολή εναλλακτικού ονόματος στα παραστατικά",
        "displayAltCode": "Προβολή εναλλακτικού κωδικού στα παραστατικά",
        "posBankAccount": "POS/Τραπεζικός λογαριασμός",
        "posBankAccountRequired": "Απαιτείται το πεδίο POS/Τραπεζικός λογαριασμός.",
        "salePurpose" : "Σκοπός Διακίνησης",
        "salesNotes": "Σημειώσεις Πωλήσεων",
        "addNotes": "Προσθήκη Σημειώσεων",
        "warning": "Προειδοποίηση!!",
        "warningMessage": "Όλα τα δεδομένα που δεν έχουν αποθηκευτεί θα χαθούν, Θέλετε να συνεχίσετε;",
        "no": "Όχι",
        "yes": "Ναι"
    },
    "SalesNewView": {
        "clientTable": {
            "code": "Κωδικός",
            "name": "Όνομα",
            "phone": "Τηλέφωνο",
            "email": "Ηλεκτρονική Διεύθυνση",
            "vatNumber": "Αριθμός Α.Φ.Μ."
        },
        "productTable": {
            "title": "Είδη",
            "code": "Κωδ. Είδους",
            "name": "Ονομασία Είδους",
            "quantity": "Ποσ.",
            "mu": "Μ.Μ.",
            "unitPrice": "Τιμή Μονάδας",
            "discount": "Έκπτωση",
            "vat": "Φ.Π.Α. %",
            "netValue": "Καθαρή Αξία",
            "vatValue": "Αξία Φ.Π.Α.",
            "taxes": "Φόροι",
            "totalValue": "Συνολική Αξία"
        },
        "extraDataTable": {
            "title": "Επιπλέον Δεδομένα",
            "locationDelivery": "Τοποθεσία Παράδοσης",
            "locationCountry": {
                "locationCountry": "Τοποθεσία Χώρας",
                "required": "Απαιτείται η τοποθεσία χώρας."
            },
            "locationCity": {
                "locationCity": "Τοποθεσία Πόλης",
                "required": "Απαιτείται η τοποθεσία πόλης."
            },
            "locationAddress": {
                "locationAddress": "Διεύθυνση τοποθεσίας",
                "required": "Απαιτείται διεύθυνση τοποθεσίας."
            },
            "locationPostalCode": {
                "locationPostalCode": "Ταχυδρομικός Κώδικας Τοποθεσίας",
                "required": "Απαιτείται ταχυδρομικός κώδικας τοποθεσίας ."
            },
            "wayOfSendingGoods": "Τρόπος αποστολής εμπορευμάτων",
            "otherTaxes": "Άλλοι Φόροι",
            "withHoldTaxes": "Παρακρατούμενοι Φόροι",
            "goodsSendDate": "Ημερομηνία Αποστολής Εμπορευμάτων",
            "carNumber": "Αριθμός Αυτοκινήτου",
            "fees": "Τέλη",
            "stampDuty": "Τέλος Χαρτοσήμου"
        },
        "productCodeTable": {
            "code": "Κωδικός",
            "alternativeCode": "Εναλλακτικός Κωδικός",
            "productName": "Ονομασία Είδους",
            "alternativeName": "Εναλλακτικό Όνομα"
        },
        "quickClientTable": {
            "name": "Όνομα Πελάτη",
            "vatCategory": "Κατηγορία Φ.Π.Α.",
            "vatNumber": "Α.Φ.Μ.",
            "phone": "Αριθμός Τηλεφώνου",
            "email": "Ηλεκτρονική Διεύθυνση",
            "address": "Διεύθυνση",
            "city": "Πόλη"
        },
        "corelatedTable": {
            "name": "Όνομα Πελάτη",
            "clientVat": "Α.Φ.Μ. πελάτη",
            "documentType": "Τύπος Παραστατικού",
            "date": "Ημερομηνία",
            "preNumber": "Σειρά",
            "number": "Αριθμός",
            "totalAmount": "Συνολικό Ποσό"
        },
        "salesTaxesTables": {
            "vat%": "Φ.Π.Α. %",
            "netValue": "Καθαρή Αξία €",
            "vat": "Φ.Π.Α. €",
            "withHoldTaxes": "Παρακρατούμενοι Φόροι",
            "otherTaxes": "Άλλοι Φόροι",
            "fees": "Τέλη",
            "stampDuty": "Τέλος Χαρτοσήμου"
        },
        "installationTable": {
            "type": "Τύπος",
            "address": "Διεύθυνση"
        },
        "totalsTable": {
            "title": "Σύνολα",
            "totalQuantity": "Συνολική Ποσότητα",
            "totalBeforeDiscount": "Σύνολο πριν από την Έκπτωση",
            "totalDiscount": "Συνολική Έκπτωση",
            "totalNetValue": "Συνολική Καθαρή Αξία",
            "totalVatAmount": "Συνολικό Ποσό Φ.Π.Α.",
            "totalWithHoldTaxesAmount": "Συνολικό Ποσό Παρακρατούμενων Φόρων",
            "totalTaxesAmount": "Συνολικό Ποσό Φόρων",
            "totalAmount": "Συνολικό ποσό",
            "paymentAmount": "Πληρωτέο Ποσό"
        },
        "message": "Επιλέξτε πρώτα τον Τύπο παραστατικού...",
        "message2": "Επιλέξτε πρώτα πελάτη..",
        "myDataErrors" : "Εμφάνιση σφάλματος MyData",
        "sendToMyData" : "Αποστολή στο MyData",
        "addNewClient": "Προσθήκη νέου πελάτη",
        "loading": "Φόρτωση...",
        "messageProductList": "Η λίστα ειδών δεν πρέπει να είναι κενή.",
        "myDataStatus": "Κατάσταση My Data",
        "files": "Αρχεία",
        "installation": "Εγκατάσταση",
        "DocumentType": "Τύπος Παραστατικού",
        "Date": "Ημερομηνία",
        "time": "Ώρα",
        "preNumber": {
            "preNumber": "Σειρά",
            "required": "Απαιτείται σειρά."
        },
        "number": {
            "number": "Αριθμός",
            "placeholder": "Αριθμός",
            "required": "Απαιτείται αριθμός."
        },
        "corelatedDocument": {
            "corelatedDocument": "Συσχετιζόμενο παραστατικό",
            "placeholder": "Επιλέξτε Συσχετιζόμενο παραστατικό",
            "required": "Απαιτείται Συσχετιζόμενο παραστατικό."
        },
        "corelatedCreditDocument": "Συσχετισμένο/Πιστωτικό Παραστατικό",
        "corelatedConvertDocument": "Συσχετισμένο Παραστατικό / Μετατροπή Παραστατικού",
        "newRetailClient": {
            "newRetailClient": "Νέος Πελάτης Λιανικής",
            "placeholder": "Προσθήκη νέου ονόματος πελάτη λιανικής"
        },
        "client": {
            "client": "Πελάτης",
            "placeholder": "Επιλέξτε Πελάτη",
            "required": "Απαιτείται ο Πελάτης."
        },
        "clientInstallation": {
            "clientInstallation": "Εγκατάσταση Πελάτη",
            "placeholder": "Εγκατάσταση Πελάτη"
        },
        "vat": "Α.Φ.Μ.",
        "email": {
            "email": "Ηλεκτρονική Διεύθυνση",
            "required": "Απαιτείται ηλεκτρονική διεύθυνση ή τηλέφωνο."
        },
        "phone": {
            "phone": "Τηλέφωνο",
            "required": "Απαιτείται ηλεκτρονική διεύθυνση ή τηλέφωνο."
        },
        "address": "Διεύθυνση",
        "doy": "Δ.Ο.Υ.",
        "city": "Πόλη",
        "pc": "Τ.Κ.",
        "paymentType": {
            "paymentType": "Τρόπος Πληρωμής",
            "required": "Απαιτείται ο τρόπος πληρωμής."
        },
        "posBankAccount": "POS/Τραπεζικός λογαριασμός",
        "salePurpose" : "Σκοπός Διακίνησης",
        "salesNotes": "Σημειώσεις Πωλήσεων",
        "addNotes": "Προσθήκη Σημειώσεων"
    },
    "SalesNewEdit": {
        "tableProduct": {
            "code": "Κωδικός",
            "productName": "Ονομασία Είδους",
            "alternateName": "Εναλλακτικό Όνομα"
        },
        "tableClient": {
            "code": "Κωδικός",
            "name": "Όνομα",
            "phone": "Τηλέφωνο",
            "email": "Ηλεκτρονική Διεύθυνση",
            "vatNumber": "Α.Φ.Μ."
        },
        "tableClientInstallations": {
            "type": "Τύπος",
            "address": "Διεύθυνση"
        },
        "table": {
            "clientName": "Όνομα Πελάτη",
            "clientVat": "Α.Φ.Μ. Πελάτη",
            "documentType": "Τύπος Παραστατικού",
            "date": "Ημερομηνία",
            "preNumber": "Σειρά",
            "number": "Αριθμός",
            "totalAmount": "Συνολικό Ποσό"
        },
        "tableClientProducts": {
            "productCode": {
                "productCode": "Κωδικός Είδους",
                "placeholder": "Επιλέξτε Κωδικό Είδους"
            },
            "productName": {
                "productName": "Ονομασία Είδους",
                "placeholder": "Επιλέξτε Όνομα Είδους"
            },
            "quantity": "ποσότητα",
            "mu": "Μ.Μ.",
            "unitPrice": "Τιμή Μονάδας",
            "discount": "Έκπτωση",
            "vat%": "Φ.Π.Α.%",
            "netValue": "Καθαρή Αξία",
            "vatValue": "Αξία Φ.Π.Α.",
            "taxes": "Φόροι",
            "totalValue": "Συνολική Αξία"
        },
        "tableQuickClient": {
            "clientName": "Όνομα Πελάτη",
            "vatCategory": "Κατηγορία Φ.Π.Α.",
            "vatNumber": "Α.Φ.Μ.",
            "phoneNumber": "Αριθμός τηλεφώνου",
            "email": "Ηλεκτρονική Διεύθυνση",
            "address": "Διεύθυνση",
            "city": "Πόλη"
        },
        "tableSalesTaxes": {
            "vat%": "Φ.Π.Α. %",
            "netValue": "Καθαρή Αξία €",
            "vat": "Φ.Π.Α. €",
            "withholdTaxes": "Παρακρατούμενοι Φόροι",
            "otherTaxes": "Άλλοι Φόροι",
            "fees": "Τέλη",
            "stampDuty": "Τέλος Χαρτόσημου (Ψηφ. τέλος συν.)"
        },
        "message": "Παρακαλώ επιλέξτε πρώτα πελάτη..",
        "message2": "Η λίστα ειδών δεν πρέπει να είναι κενή.",
        "loading": "Φόρτωση...",
        "wayOfSendingGoods": "Τρόπος αποστολής εμπορευμάτων",
        "carNumber": "Αριθμός Αυτοκινήτου",
        "otherTaxes": "Άλλοι Φόροι",
        "withholdTaxes": "Παρακρατούμενοι Φόροι",
        "goodsSendDate": "Ημερομηνία Αποστολής Εμπορευμάτων",
        "fees": "Τέλη",
        "stampDuty": "Τέλος Χαρτοσήμου",
        "myDataStatus": "Κατάσταση My Data:",
        "files": "Αρχεία",
        "time": "Ώρα",
        "installation": "Εγκατάσταση",
        "preNumber": "Σειρά",
        "number": "Αριθμός",
        "correlatedDocument": {
            "correlatedDocument": "Συσχετιζόμενο Παραστατικό",
            "placeholder": "Επιλέξτε Συσχετιζόμενο Παραστατικό",
            "required": "Απαιτείται Συσχετιζόμενο Παραστατικό"
        },
        "client": {
            "client": "Πελάτης",
            "placeholder": "Επιλέξτε Πελάτη"
        },
        "newRetailClient": {
            "newRetailClient": "Νέος Πελάτης Λιανικής",
            "placeholder": "Νέος Πελάτης Λιανικής"
        },
        "clientIsRequired": "Απαιτείται πελάτης",
        "clientInstallation": {
            "clientInstallation": "Εγκατάσταση πελάτη",
            "placeholder": "Επιλέξτε Εγκατάσταση πελάτη"
        },
        "vat": "Α.Φ.Μ.",
        "emailOrPhoneIsRequired.": "Απαιτείται email ή τηλέφωνο.",
        "phone": "Τηλέφωνο",
        "address": "Διεύθυνση",
        "doy": "Δ.Ο.Υ.",
        "city": "Πόλη",
        "paymentType": "Τρόπος Πληρωμής",
        "posBankAccount": "POS/Τραπεζικός Λογαριασμός",
        "salePurpose": "Σκοπός Πώλησης",
        "totals": {
            "titles": "Σύνολα",
            "totalQuantity": "Συνολική Ποσότητα",
            "totalBeforeDiscount": "Σύνολο πριν από την Έκπτωση",
            "totalDiscount": "Συνολική Έκπτωση",
            "totalNetValue": "Συνολική Καθαρή Αξία",
            "totalVATAmount": "Συνολικό Ποσό Φ.Π.Α.",
            "totalWithHoldTaxesAmount": "Συνολικό Ποσό Παρακρατούμενων Φόρων",
            "totalTaxesAmount": "Συνολικό Ποσό Φόρων",
            "totalAmount": "Συνολικό Ποσό",
            "paymentAmount": "Πληρωτέο Ποσό"
        },
        "sales": "Πωλήσεις",
        "addNotes": "Προσθέστε Σημειώσεις",
        "warning": "Προσοχή!!",
        "warningMessage": "Όλα τα δεδομένα που δεν έχουν αποθηκευτεί θα χαθούν. Θέλετε να συνεχίσετε;",
        "no": "Όχι",
        "yes": "Ναι"
    },
    "SalesSearchEmailButton": {
        "title": "Αποστολή Email",
        "message1": {
            "message1": "Αποστολή email σε υπάρχοντες επαφές:",
            "placeholder": "Επιλέξτε ένα ή περισσότερες επαφές"
        },
        "message2": {
            "message2": "Αποστολή email σε άλλες διευθύνσεις email:",
            "placeholder": "Παρακαλώ γράψτε email διαχωρισμένα με κόμμα"
        },
        "required": "Παρακαλώ επιλέξτε τουλάχιστον μία ηλεκτρονική διεύθυνση.",
        "emailError": "Παρακαλώ εισαγάγετε μια σωστή ηλεκτρονική διεύθυνση.",
        "close": "Κλείσιμο",
        "send": "Αποστολή"
    },
    "SalesSearch": {
        "table": {
            "date": "Ημερομηνία",
            "client": "Πελάτης",
            "documentType": "Τύπος Παραστατικού",
            "number": "Αριθμός",
            "totalNetValue": "Συνολική Καθαρή Αξία",
            "totalVatValue": "Συνολική Αξία Φ.Π.Α.",
            "totalSum": "Συνολικό Άθροισμα",
            "myDataStatus": "Κατάσταση My Data",
            "providerChannel": "Κανάλι Προγράμματος"
        },
        "table2": {
            "documentType": "Είδος Παραστατικού",
            "clientNameFrom": "Όνομα/ΑΦΜ Πελάτη",
            "clientNameTo": "Όνομα Πελάτη Μέχρι",
            "totalSumFrom": "Συνολικό άθροισμα Από",
            "totalSumTo": "Συνολικό άθροισμα Μέχρι",
            "preNumberFrom": "Σειρά Από",
            "preNumberTo": "Σειρά Μέχρι",
            "numberFrom": "Αριθμός Από",
            "numberTo": "Αριθμός Μέχρι",
            "paymentWays": "Τρόποι Πληρωμής",
            "myDataStatus": "Κατάσταση My Data",
            "providerChannel": "Κανάλι Προγράμματος",
            "productName" : "Όνομα περιέχοντος είδους",
            "paymentStatus": "Κατάσταση Πληρωμής",
            "notes": "Σημειώσεις Παραστατικού"
        }
    },
    "QuickRetailSalesNew": {
        "smallTable": {
            "code": "Κωδικός",
            "name": "Όνομα",
            "Phone": "Τηλέφωνο",
            "email": "Ηλεκτρονική Διεύθυνση"
        },
        "table": {
            "productName": "Ονομασία Είδους",
            "quantity": "Ποσότητα",
            "price": "Τιμή",
            "totals": "Σύνολα"
        },
        "client": {
            "client": "Πελάτης",
            "placeholder": "Αναζήτηση πελάτη με όνομα, ηλεκτρονική διεύθυνση και κωδικό."
        },
        "client2": {
            "client2": "Πελάτης",
            "placeholder": "Προσθήκη ονόματος πελάτη",
            "question": "Είναι νέος πελάτης;"
        },
        "files": "Αρχεία",
        "address": {
            "address": "Διεύθυνση",
            "placeholder": "Εισάγετε διεύθυνση"
        },
        "phone": {
            "phone": "Αριθμός τηλεφώνου",
            "placeholder": "Εισάγετε Αριθμό τηλεφώνου"
        },
        "email": {
            "email": "Ηλεκτρονική διεύθυνση",
            "placeholder": "π.χ. example@example.com",
            "warning": "Μη έγκυρη ηλεκτρονική διεύθυνση."
        },
        "message": "Παρακαλώ επιλέξτε πρώτα πελάτη..",
        "messageTable": "Ο πίνακας δεν πρέπει να είναι κενός.",
        "sendEmail": "Αποστολή Email",
        "cash": "CASH",
        "issue": "ISSUE",
        "products": "Είδη",
        "searchResult": "Αποτέλεσμα αναζήτησης",
        "notFound": "Δεν βρέθηκε...",
        "recommendedProducts": "Προτεινόμενα Είδη",
        "cashRegister": "CASH REGISTER",
        "paymentAnalysis": "Ανάλυση Πληρωμής",
        "totalAmount": "Συνολικό ποσό:",
        "cash2": {
            "cash2": "Cash:",
            "placeholder": "Ποσό"
        },
        "clientPaymentTotals": "Σύνολα Πληρωμών Πελάτη:",
        "clientChange": {
            "clientChange": "Αλλαγή Πελάτη:",
            "issue": "ISSUE"
        }
    },
    "QuickRetailSearchTabs": {
        "search": "Αναζήτηση",
        "table": {
            "date": "Ημερομηνία",
            "client": "Πελάτης",
            "preNumber": "Σειρά",
            "number": "Αριθμός",
            "products": "Είδη",
            "totalSum": "Συνολικό Άθροισμα"
        },
        "clientNameFrom": "Όνομα πελάτη",
        "clientNameTo": "Όνομα πελάτη Μέχρι",
        "totalSumFrom": "Συνολικό Άθροισμα Από",
        "totalSumTo": "Συνολικό Άθροισμα Μέχρι",
        "preNumberFrom": "Σειρά Από",
        "preNumberTo": "Σειρά Μέχρι",
        "numberFrom": "Αριθμός Από",
        "numberTo": "Αριθμός Μέχρι",
        "paymentWays": "Τρόποι πληρωμής",
        "products": "Είδη"
    },
    "SalesClientPaymentsTabs": {
        "general": "Γενικά"
    },
    "SalesClientPaymentsNew": {
        "dropTable": {
            "code": "Κωδικός",
            "name": "Όνομα",
            "phone": "Τηλέφωνο",
            "email": "Ηλεκτρονικό Ταχυδρομείο"
        },
        "smallTable": {
            "name": "Όνομα",
            "serialNumber": "Αριθμός Μητρώου"
        },
        "bankTable": {
            "accountName": "Όνομα Τραπεζικού Λογαριασμού",
            "bankName": "Όνομα Τράπεζας",
            "bankAccountName": "Αριθμός Τραπεζικού Λογαριασμού"
        },
        "posTable": {
            "posName": "Όνομα POS",
            "posRegistrationNumber": "Αριθμός μητρώου POS",
            "amount": "Ποσό",
            "notes": "Σημειώσεις"
        },
        "bank2Table": {
            "bankAccount": "Τραπεζικός Λογαριασμός",
            "accountNumber": "Αριθμός Λογαριασμού",
            "amount": "Ποσό",
            "notes": "Σημειώσεις"
        },
        "checkTable": {
            "startDate": "Ημερομηνία Έναρξης",
            "endDate": "Ημερομηνία Λήξης",
            "amount": "Ποσό",
            "notes": "Σημειώσεις"
        },
        "message": "Παρακαλώ επιλέξτε πρώτα τον τύπο παραστατικού...",
        "documentTypes": "Τύποι Παραστατικών",
        "files": "Αρχεία",
        "date": "Ημερομηνία",
        "installation": {
            "installation": "Εγκατάσταση",
            "required": "Απαιτείται εγκατάσταση."
        },
        "preNumber": "Σειρά",
        "number": {
            "number": "Αριθμός",
            "placeholder": "Αριθμός"
        },
        "paymentType": "Τρόπος Πληρωμής",
        "client": {
            "client": "Πελάτης",
            "placeholder": "Επιλέξτε Πελάτη",
            "required": "Απαιτείται Πελάτης."
        },
        "vatNumber": "Α.Φ.Μ",
        "address": "Διεύθυνση",
        "country": "Χώρα",
        "phone": "Τηλέφωνο",
        "email": "Ηλεκτρονική Διεύθυνση",
        "reason": "Αιτιολογία",
        "paymentAmount": {
            "paymentAmount": "Πληρωτέο Ποσό",
            "placeholder": "Εισάγετε το ποσό"
        },
        "bankAccountData": "Στοιχεία Τραπεζικού Λογαριασμού",
        "chequeData": "Έλεγχος Δεδομένων",
        "posData": "Δεδομένα POS",
        "paymentNotes": "Σημειώσεις Πληρωμής",
        "addNotes": "Προσθήκη Σημειώσεων",
        "warning": "Προειδοποίηση!!",
        "message2": "Όλα τα δεδομένα που δεν έχουν αποθηκευτεί θα χαθούν, Θέλετε να συνεχίσετε;",
        "no": "Όχι",
        "yes": "Ναι"
    },
    "SalesClientPaymentsSearchTabs": {
        "search": "Αναζήτηση"
    },
    "SalesClientPaymentsSearch": {
        "table": {
            "date": "Ημερομηνία",
            "client": "Πελάτης",
            "documentType": "Τύπος Παραστατικού",
            "preNumberAndNumber": "Αρίθμηση",
            "paymentType": "Τρόπος Πληρωμής",
            "amount": "Ποσό"
        },
        "tableFilter": {
            "documentType": "Τύπος Παραστατικού",
            "clientNameFrom": "Όνομα Πελάτη",
            "clientNameTo": "Όνομα Πελάτη Μέχρι",
            "paymentTypes": "Τρόποι Πληρωμής",
            "amountFrom": "Ποσό Από",
            "amountTo": "Ποσό Μέχρι"
        }
    },
    "SalesClientPaymentsNewEdit": {
        "dropTable": {
            "code": "Κωδικός",
            "name": "Όνομα",
            "phone": "Τηλέφωνο",
            "email": "Ηλεκτρονικό Ταχυδρομείο"
        },
        "smallTable": {
            "name": "Όνομα",
            "serialNumber": "Αριθμός Μητρώου"
        },
        "bankTable": {
            "accountName": "Όνομα Τραπεζικού Λογαριασμού",
            "bankName": "Όνομα Τράπεζας",
            "bankAccountName": "Αριθμός Τραπεζικού Λογαριασμού"
        },
        "posTable": {
            "posName": "Όνομα POS",
            "posRegistrationNumber": "Αριθμός μητρώου POS",
            "amount": "Ποσό",
            "notes": "Σημειώσεις"
        },
        "bank2Table": {
            "bankAccount": "Τραπεζικός Λογαριασμός",
            "accountNumber": "Αριθμός Λογαριασμού",
            "amount": "Ποσό",
            "notes": "Σημειώσεις"
        },
        "checkTable": {
            "startDate": "Ημερομηνία Έναρξης",
            "endDate": "Ημερομηνία Λήξης",
            "amount": "Ποσό",
            "notes": "Σημειώσεις"
        },
        "message": "Παρακαλώ επιλέξτε πρώτα τον τύπο παραστατικού...",
        "documentTypes": "Τύποι Παραστατικών",
        "files": "Αρχεία",
        "date": "Ημερομηνία",
        "installation": {
            "installation": "Εγκατάσταση",
            "required": "Απαιτείται εγκατάσταση."
        },
        "preNumber": "Σειρά",
        "number": {
            "number": "Αριθμός",
            "placeholder": "Αριθμός"
        },
        "paymentType": "Τρόπος Πληρωμής",
        "client": {
            "client": "Πελάτης",
            "placeholder": "Επιλέξτε Πελάτη",
            "required": "Απαιτείται Πελάτης."
        },
        "vatNumber": "Α.Φ.Μ",
        "address": "Διεύθυνση",
        "country": "Χώρα",
        "phone": "Τηλέφωνο",
        "email": "Ηλεκτρονική Διεύθυνση",
        "reason": "Αιτιολογία",
        "paymentAmount": {
            "paymentAmount": "Πληρωτέο Ποσό",
            "placeholder": "Εισάγετε το ποσό"
        },
        "bankAccountData": "Στοιχεία Τραπεζικού Λογαριασμού",
        "chequeData": "Έλεγχος Δεδομένων",
        "posData": "Δεδομένα POS",
        "paymentNotes": "Σημειώσεις Πληρωμής",
        "addNotes": "Προσθήκη Σημειώσεων",
        "warning": "Προειδοποίηση!!",
        "message2": "Όλα τα δεδομένα που δεν έχουν αποθηκευτεί θα χαθούν, Θέλετε να συνεχίσετε;",
        "no": "Όχι",
        "yes": "Ναι"
    },
    "SalesAutomaticSalesNewTabs": {
        "general": "Γενικά"
    },
    "SalesAutomaticSalesNew": {
        "saleActive": "Ενεργή Πώληση:",
        "name": {
            "name": "Όνομα",
            "placeholder": "Προσθέστε Όνομα",
            "required": "Το όνομα είναι υποχρεωτικό πεδίο."
        },
        "files": "Αρχεία",
        "startDate": {
            "startDate": "Ημερομηνία Έναρξης",
            "required": "Η Ημερομηνία έναρξης είναι υποχρεωτική."
        },
        "endDate": "Ημερομηνία Λήξης",
        "issueInvoiceEvery": "Έκδοση τιμολογίου κάθε",
        "days": {
            "days": "Ημέρα",
            "required": "Απαιτείται πεδίο ημερών."
        },
        "or": "Ή",
        "ofEachMonth": "κάθε μήνα",
        "require": "Η ημέρα του μήνα είναι υποχρεωτικό πεδίο.",
        "invoiceData": "Δεδομένα Τιμολογίου",
        "createNewSalesDocument": "Δημιουργία Νέου Παραστατικού Πωλήσεων",
        "selectSalesTemplate": "Επιλέξτε Πρότυπο πωλήσεων",
        "notes": "Σημειώσεις",
        "addNotes": "Προσθήκη Σημειώσεων"
    },
    "SalesAutomaticSalesSearchTabs": {
        "search": "Αναζήτηση"
    },
    "SalesAutomaticSalesSearch": {
        "table": {
            "client": "Πελάτης",
            "dateStarted": "Ημερομηνία έναρξης",
            "endDate": "Ημερομηνία λήξης",
            "issueInterval": "Διάστημα Έκδοσης",
            "documentType": "Τύπος Παραστατικού",
            "totalSum": "Συνολικό Άθροισμα",
            "active": "Ενεργό",
            "lastLog": "Τελευταίο Σφάλμα",
            "failReason": "Λόγος Αποτυχίας"
        },
        "clientNameFrom": "Όνομα πελάτη Από",
        "clientNameTo": "Όνομα πελάτη Μέχρι",
        "dateStartedFrom": "Ημερομηνία Έναρξης Από",
        "dateStartedTo": "Ημερομηνία Έναρξης Μέχρι",
        "endDateFrom": "Ημερομηνία λήξης Από",
        "endDateTo": "Ημερομηνία λήξης Μέχρι",
        "documentType": "Είδος Παραστατικού",
        "totalSumFrom": "Συνολικό άθροισμα Από",
        "totalSumTo": "Συνολικό άθροισμα Μέχρι",
        "active": "Ενεργά",
        "inActive": "Μη ενεργά",
        "all": "Όλα",
        "null": "Μηδενικό (Κενό)",
        "success": "Επιτυχία",
        "fail": "Αποτυχία"
    },
    "SalesMyDataTabs": {
        "myDataReport": "Αναφορά MyData Πωλήσεων"
    },
    "SalesMyData": {
        "thisMonth": "Αυτόν Το Μήνα",
        "allDocuments": "Όλα Τα Παραστατικά",
        "html": "Εξαγωγή HTML σε Έγγραφο",
        "table": {
            "date": "Ημερομηνία",
            "client": "Πελάτης",
            "clientVat": "Α.Φ.Μ. Πελάτη",
            "invoiceType": "Τύπος Παραστατικού",
            "number": "Αρίθμηση",
            "netValue": "Καθαρή Αξία",
            "vatAmount": "Ποσό Φ.Π.Α.",
            "totalValue": "Συνολική Αξία",
            "erpStatus": "Κατάσταση ERP",
            "myDataStatus":"Κατάσταση MyData",
            "changeClassifications": "Εμφάνιση Χαρακτηρισμών",
            "classificationsModalTitle": "Χαρακτηρισμοί MyData",
            "classificationsModalDesc": "Από εδώ μπορείτε να δείτε και να επεξεργαστείτε τους χαρακτηρισμούς των ειδών του παραστατικού πατώντας Αποθήκευση",
            "classificationsModalClose": "Κλείσιμο",
            "classificationsModalSave": "Αποθήκευση"
        },
        "table2": {
            "allDocuments": "Όλα Τα Παραστατικά",
            "onlyDifferences": "Μόνο Διαφορές",
            "onlyTheSent": "Μόνο Τα Σταλμένα",
            "onlyTheFailed": "Μόνο Τα Αποτυχημένα",
            "onlyFromSales": "Μόνο Από Πωλήσεις",
            "onlyFromAccounting": "Μόνο Από Τη Λογιστική",
            "onlyFromMyData": "Μόνο απο κανάλι MyData",
            "onlyFromMyProvider": "Μόνο απο κανάλι Παρόχου"
        },
        "smallTable": {
            "client": "Πελάτης",
            "vatNumber": "Αριθμός Α.Φ.Μ.",
            "phoneNumber": "Αριθμός τηλεφώνου:"
        },
        "filterBy": "Φιλτράρισμα Κατά",
        "dateFrom": "Ημερομηνία Από",
        "dateTo": "Ημερομηνία Μέχρι",
        "invoiceType": "Τύπος Παραστατικού",
        "invoiceNumberFrom": "Αριθμός Τιμολογίου Από:",
        "invoiceNumberTo": "Αριθμός Τιμολογίου Μέχρι:",
        "client": {
            "client": "Πελάτης",
            "placeholder": "Επιλέξτε Πελάτη"
        },
        "showFilter": "Εμφάνιση φίλτρου:",
        "showDocumentsFrom": "Εμφάνιση παραστατικών από:",
        "showDocumentsFromChannel": "Εμφάνιση παραστατικών από Κανάλι:",
        "applyFilter": "Εφαρμόστε φίλτρο",
        "myDataReport": "Αναφορά MyData Πωλήσεων",
        "page": "Σελίδα:",
        "of": "από",
        "first": "<< Πρώτη",
        "previous": "< Προηγούμενη",
        "next": "Επόμενη >",
        "last": "Τελευταία >>",
        "pageTotals": "Σύνολα",
        "TotalsERP": "Σύνολα ERP",
        "TotalsMyData": "Σύνολα MyData",
        "totalNetValue": "Συνολική Καθαρή Αξία",
        "totalVatAmount": "Συνολικό Ποσό Φ.Π.Α.",
        "totalsCount": "Συνολική Ποσότητα",
        "differences": "Διαφορές",
        "discord": "Αποτέλεσμα: Βρίσκεται σε ασυμφωνία",
        "discordOk": "Αποτέλεσμα: Βρίσκεται σε συμφωνία",
        "totalValue": "Συνολική Αξία",
        "printResults": {
            "printResults": "Εκτύπωση Αποτελεσμάτων",
            "printer": "Εκτυπωτής",
            "printToCSV": "Εκτύπωση σε CSV",
            "printToPDF": "Εκτύπωση σε PDF",
            "printToExcel": "Εκτύπωση σε Excel",
            "printToWord": "Εκτύπωση σε Word"
        },
        "message": "Παρακαλώ επιλέξτε πρώτα φίλτρα και πατήστε \"Εφαρμόστε φίλτρα\""
    },
    "SalesBalanceSheetTabs": {
        "balanceSheet": "Αναφορά Πωλήσεων"
    },
    "SalesBalanceSheet": {
        "table": {
            "date": "Ημερομηνία",
            "client": "Πελάτης",
            "clientVat": "Α.Φ.Μ. Πελάτη",
            "invoiceType": "Τύπος Παραστατικού",
            "providerChannel": "Κανάλι Προγράμματος",
            "number": "Αριθμός",
            "netValue": "Καθαρή Αξία",
            "vatAmount": "Ποσό Φ.Π.Α.",
            "totalValue": "Συνολική Αξία",
            "paymentType": "Τρόπος Πληρωμής",
            "vehicleNumber": "Αριθμός Οχήματος"
        },
        "table2": {
            "clientFrom": "Από Πελάτη",
            "clientTo": "Προς Πελάτη"
        },
        "table3": {
            "clientName": "Όνομα Πελάτη",
            "vatNumber": "Α.Φ.Μ.",
            "phoneNumber": "Αριθμός Τηλεφώνου:"
        },
        "filterBy": "Φιλτράρισμα Κατά",
        "dateFrom": "Ημερομηνία Από",
        "clientFrom": {
            "clientFrom": "Από Πελάτη",
            "placeholder": "Επιλέξτε Πελάτη"
        },
        "invoiceType": "Τύπος Παραστατικού",
        "providerChannel": "Κανάλι Προγράμματος",
        "showAutomaticSales": "Εμφάνιση Αυτόματων Πωλήσεων",
        "dateTo": "Ημερομηνία Μέχρι",
        "clientTo": {
            "clientTo": "Προς Πελάτη",
            "placeholder": "Επιλέξτε Πελάτη"
        },
        "paymentType": "Τρόπος Πληρωμής",
        "vehicleNumber": "Αριθμός Οχήματος",
        "applyFilter": "Εφαρμόστε φίλτρο",
        "salesBalance": "Υπόλοιπο Πωλήσεων",
        "page": "Σελίδα:",
        "of": "από",
        "first": "<< Πρώτη",
        "previous": "< Προηγούμενη",
        "next": "Επόμενη >",
        "last": "Τελευταία >>",
        "pageTotals": "Σύνολα",
        "totalNetValue": "Συνολική Καθαρή Αξία",
        "totalVatAmount": "Συνολικό Ποσό Φ.Π.Α.",
        "totalValue": "Συνολική Αξία",
        "printResults": {
            "printResults": "Εκτύπωση Αποτελεσμάτων",
            "printer": "Εκτυπωτής",
            "printToCSV": "Εκτύπωση σε CSV",
            "printToPDF": "Εκτύπωση σε PDF",
            "printToExcel": "Εκτύπωση σε Excel",
            "printToWord": "Εκτύπωση σε Word"
        },
        "message": "Παρακαλώ επιλέξτε πρώτα φίλτρα και πατήστε \"Εφαρμόστε φίλτρα\""
    },
    "SalesGraphicReportTabs": {
        "graphicReport": "Γραφική Αναφορά Πωλήσεων"
    },
    "SalesGraphicReport": {
        "table": {
            "clientFrom": "Από Πελάτη",
            "clientTo": "Προς Πελάτη"
        },
        "table2": {
            "clientName": "Όνομα Πελάτη",
            "vatNumber": "Α.Φ.Μ.",
            "phoneNumber": "Αριθμός Τηλεφώνου:"
        },
        "filterBy": "Φιλτράρισμα Κατά",
        "dateFrom": "Ημερομηνία Από",
        "clientFrom": {
            "clientFrom": "Από Πελάτη",
            "placeholder": "Επιλέξτε Πελάτη"
        },
        "invoiceType": "Τύπος Παραστατικού",
        "dateTo": "Ημερομηνία Μέχρι",
        "clientTo": {
            "clientTo": "Προς Πελάτη",
            "placeholder": "Επιλέξτε Πελάτη"
        },
        "paymentType": "Τρόπος Πληρωμής",
        "applyFilter": "Εφαρμόστε φίλτρο",
        "printResults": {
            "printResults": "Εκτύπωση Αποτελεσμάτων",
            "printer": "Εκτυπωτής",
            "printToCSV": "Εκτύπωση σε CSV",
            "printToPDF": "Εκτύπωση σε PDF",
            "printToExcel": "Εκτύπωση σε Excel",
            "printToWord": "Εκτύπωση σε Word"
        },
        "message": "Παρακαλώ επιλέξτε πρώτα φίλτρα και πατήστε \"Εφαρμόστε φίλτρα\""
    },
    "SalesClientPaymentReportTabs": {
        "clientPaymentReport": "Αναφορά Εισπράξεων"
    },
    "SalesClientPaymentReport": {
        "table": {
            "date": "Ημερομηνία",
            "clientName": "Όνομα Πελάτη",
            "clientVat": "Α.Φ.Μ. Πελάτη",
            "invoiceType": "Τύπος Παραστατικού",
            "number": "Αριθμός",
            "paymentAmount": "Πληρωτέο Ποσό",
            "paymentType": "Τρόπος Πληρωμής"
        },
        "table2": {
            "clientFrom": "Από Πελάτη",
            "clientTo": "Προς Πελάτη"
        },
        "table3": {
            "clientName": "Όνομα Πελάτη",
            "vatNumber": "Α.Φ.Μ.",
            "phoneNumber": "Αριθμός Τηλεφώνου:"
        },
        "filterBy": "Φιλτράρισμα Κατά",
        "dateFrom": "Ημερομηνία Από",
        "clientFrom": {
            "clientFrom": "Από Πελάτη",
            "placeholder": "Επιλέξτε Πελάτη"
        },
        "invoiceType": "Τύπος Παραστατικού",
        "dateTo": "Ημερομηνία Μέχρι",
        "clientTo": {
            "clientTo": "Προς Πελάτη",
            "placeholder": "Επιλέξτε Πελάτη"
        },
        "paymentType": "Τρόπος Πληρωμής",
        "applyFilter": "Εφαρμόστε φίλτρο",
        "clientPaymentBalance": "Υπόλοιπο Πληρωμών Πελάτη",
        "page": "Σελίδα:",
        "of": "από",
        "first": "<< Πρώτη",
        "previous": "< Προηγούμενη",
        "next": "Επόμενη >",
        "last": "Τελευταία >>",
        "pageTotals": "Σύνολα",
        "paymentAmount": "Πληρωτέο Ποσό",
        "printResults": {
            "printResults": "Εκτύπωση Αποτελεσμάτων",
            "printer": "Εκτυπωτής",
            "printToCSV": "Εκτύπωση σε CSV",
            "printToPDF": "Εκτύπωση σε PDF",
            "printToExcel": "Εκτύπωση σε Excel",
            "printToWord": "Εκτύπωση σε Word"
        },
        "message": "Παρακαλώ επιλέξτε πρώτα φίλτρα και πατήστε \"Εφαρμόστε φίλτρα\""
    },
    "SalesGeneralSettingsTabs": {
        "settings": "Ρυθμίσεις"
    },
    "SalesGeneralSettings": {
        "name": "Όνομα",
        "number": "Αριθμός",
        "type": "Τύπος",
        "salesDocument": "Έγγραφο Πώλησης:",
        "waysOfSendingGoods": "Τρόποι αποστολής εμπορευμάτων:",
        "carNumbers": "Αριθμοί αυτοκινήτων:",
        "forbidChangeInPricesInSalesProducts": "Απαγόρευση αλλαγής τιμών στα είδη κατά την εισαγωγή πωλήσεων",
        "paymentTypes": "Τρόποι Πληρωμής:",
        "paymentOptions": "Επιλογές Πληρωμής:",
        "paymentType": "Τρόπος Πληρωμής -",
        "posBankAccount": "Προ-επιλεγμένο POS/Τραπεζικός Λογαριασμός",
        "createAutomaticPaymentInSales": "Δημιουργία Αυτόματης Είσπραξης στις Πωλήσεις",
        "paymentDocumentType": "Τύπος Παραστατικού Είσπραξης",
        "preNumber": "Σειρά",
        "paymentReason": {
            "paymentReason": "Αιτιολογία Είσπραξης",
            "placeholder": "Προσθήκη Αιτιολογίας Είσπραξης"
        },
        "addWildcard": "Προσθήκη Μεταβλητής",
        "wildCards": "Μεταβλητές -",
        "clickOnWildcardToAddInThePaymentReason": "Κάντε κλικ στην τιμή μεταβλητής για να προσθέσετε την αιτιολογία πληρωμής."
    },
    "SalesQuickRetailSales": {
        "activated": "Απενεργοποιήθηκε",
        "deactivated": "Ενεργοποιήθηκε",
        "defaultSalesDocumentType": "Προεπιλεγμένος Τύπος Παραστατικού Πωλήσεων",
        "activateCashRegister": "Ενεργοποίηση Ταμειακής Μηχανής",
        "allowCreationOfNewClient": "Επιτρέψτε δημιουργία νέου πελάτη",
        "allowSelectionOfClient": "Επιτρέψτε την επιλογή πελάτη",
        "defaultRetailClient": "Προεπιλεγμένος Πελάτης Λιανικής",
        "defaultSendEmailStatus": "Προκαθορισμένη κατάσταση \"Αποστολή email\"",
        "forbidChangeInPricesInSalesProducts": "Απαγόρευση αλλαγής τιμών στα είδη κατά την εισαγωγή πωλήσεων",
        "defaultProducts": "Προεπιλεγμένα Είδη",
        "defaultInstallation": "Προεπιλεγμένη Εγκατάσταση",
        "defaultPreNumber": "Προεπιλεγμένη Σειρά",
        "paymentWay1Name": {
            "paymentWay1Name": "Τρόπος πληρωμής όνομα 1",
            "placeholder": "Προσθέστε όνομα"
        },
        "paymentType1": "Τρόπος πληρωμής 1",
        "active": "Ενεργό",
        "createAutomaticPayment": "Δημιουργία Αυτόματης Πληρωμής",
        "paymentWay2Name": {
            "paymentWay2Name": "Τρόπος πληρωμής όνομα 2",
            "placeholder": "Προσθέστε όνομα"
        },
        "paymentType2": "Τρόπος πληρωμής 2",
        "paymentWay3Name": {
            "paymentWay3Name": "Τρόπος πληρωμής όνομα 3",
            "placeholder": "Προσθέστε όνομα"
        },
        "paymentType3": "Τρόπος πληρωμής 3",
        "preSelectedPaymentWay": "Προεπιλεγμένος Τρόπος Πληρωμής",
        "warning": "Προσοχή!!",
        "message": "Μπορεί να διαγράψει ή να αλλάξει την υπάρχουσα ρύθμιση. Θέλετε να συνεχίσετε;",
        "no": "Όχι",
        "yes": "Ναι"
    },
    "ClientsNewTabs": {
        "general": "Γενικά",
        "installations": "Εγκαταστάσεις",
        "communicationHistory": "Ιστορικό Επικοινωνίας",
        "information": "Πληροφορίες",
        "notes": "Σημειώσεις",
        "accounting": "Λογιστική"
    },
    "ClientsGeneralSearchTabs": {
        "search": "Αναζήτηση"
    },
    "ClientsMovementNewTabs": {
        "general": "Γενικά"
    },
    "ClientsMovementSearchTabs": {
        "general": "Γενικά"
    },
    "ReportsClientsListTabs": {
        "general": "Γενικά"
    },
    "ReportsClientsMovementsTabs": {
        "general": "Γενικά"
    },
    "ReportsClientsSettingsTabs": {
        "general": "Γενικά",
        "massEmail": "Μαζικό email"
    },
    "QuickRetailSalesNewTabs": {
        "retail": "Λιανεμπόριο"
    },
    "QuickRetailSalesSearchTabs": {
        "search": "Αναζήτηση"
    },
    "ClientsNewGeneral": {
        "files": "Αρχεία",
        "message": "Επιλέξτε πρώτα κατηγορία..",
        "details": "Αυτόματη Συμπλήρωση Στοιχείων",
        "clientCategory": "Κατηγορία",
        "systemCode": "Κωδικός Συστήματος",
        "manualCode": {
            "code": "Χειροκίνητος Κωδικός",
            "eg": "πχ. mcc-001"
        },
        "name": {
            "name": "Όνομα Πελάτη",
            "placeholder": "Εισάγετε Όνομα",
            "required": "Το όνομα απαιτείται.",
            "exist": "Το όνομα υπάρχει ήδη."
        },
        "smallName" : {
            "smallName": "Διακριτικός Τίτλος",
            "placeholder": "Εισάγετε διακριτικό τίτλο"
        },
        "vatCategory": {
            "vatCategory": "Κατηγορία Φ.Π.Α",
            "required": "Απαιτείται κατηγορία Φ.Π.Α."
        },
        "0vatReason": {
            "0vatReason": "Κατηγορία Εξαίρεσης Φ.Π.Α.",
            "required": "Απαιτείται η κατηγορία εξαίρεσης Φ.Π.Α."
        },
        "customVat": {
            "customVat": "Προσαρμοσμένο % Φ.Π.Α.",
            "placeholder": "Προσαρμοσμένο Φ.Π.Α.",
            "required": "Απαιτείται προσαρμοσμένο Φ.Π.Α."
        },
        "vatNumber": {
            "vatNumber": "Α.Φ.Μ.",
            "placeholder": "Εισάγετε το Α.Φ.Μ.",
            "required": "Απαιτείται ο αριθμός Α.Φ.Μ."
        },
        "doy": {
            "doy": "Δ.Ο.Υ.",
            "required": "Απαιτείται η Δ.Ο.Υ"
        },
        "activity": {
            "activity": "Δραστηριότητα",
            "placeholder": "Εισάγετε δραστηριότητα",
            "required": "Απαιτείται δραστηριότητα."
        },
        "amka": {
            "amka": "Α.Μ.Κ.Α.",
            "placeholder": "Εισάγετε Α.Μ.Κ.Α.",
            "required": "Απαιτείται email ή τηλέφωνο ή Α.Μ.Κ.Α."
        },
        "country": {
            "country": "Χώρα",
            "required": "Απαιτείται η χώρα."
        },
        "address": {
            "address": "Διεύθυνση",
            "placeholder": "Εισάγετε Διεύθυνση",
            "required": "Απαιτείται η διεύθυνση."
        },
        "city": {
            "city": "Πόλη",
            "placeholder": "Εισάγετε Πόλη",
            "required": "Απαιτείται η πόλη."
        },
        "postalCode": {
            "postalCode": "Ταχυδρομικός Κώδικας",
            "placeholder": "Εισάγετε Ταχυδρομικό Κώδικα",
            "required": "Απαιτείται ταχυδρομικός κώδικας"
        },
        "email": {
            "email": "Ηλεκτρονική Διεύθυνση",
            "eg": "πχ. example@example.com",
            "invalid": "Μη έγκυρη διεύθυνση email.",
            "required": "Απαιτείται email ή τηλέφωνο.",
            "required2": "Απαιτείται email ή τηλέφωνο ή Α.Μ.Κ.Α."
        },
        "phone": {
            "phone": "Τηλέφωνο",
            "placeholder": "Εισάγετε Τηλέφωνο"
        },
        "gemh": {
            "gemh": "ΓΕΜΗ",
            "placeholder": "Εισάγετε αριθμό ΓΕΜΗ"
        },
        "webpage": {
            "webpage": "Ιστοσελίδα",
            "eg": "πχ. https://www.example.com/"
        },
        "contactPoints": {
            "title": "Στοιχεία Επαφής:",
            "contactName": "Όνομα Επαφής",
            "mobilePhone": "Κινητό Τηλέφωνο",
            "landLine": "Σταθερό Τηλέφωνο",
            "otherPhone": "Άλλο Τηλέφωνο",
            "email": "Ηλεκτρονική Διεύθυνση",
            "contactNotes": "Σημειώσεις Επικοινωνίας",
            "acceptNotifications": "Αποδοχή Ειδοποιήσεων",
            "actions": "Ενέργειες"
        },
        "clientNotes": {
            "title": "Σημειώσεις Πελάτη:",
            "note": "Εισάγετε Σημειώσεις Πελάτη"
        }
    },
    "ClientsNewInstallations" : {
        "installations": "Εγκαταστάσεις:",
        "type": "Τύπος",
        "address": "Διεύθυνση",
        "installationDoy": "Δ.Ο.Υ.",
        "city": "Πόλη",
        "postalCode": "Ταχυδρομικός Κώδικας",
        "InstallationVatCategory": "Κατηγορία Φ.Π.Α. Εγκατάστασης",
        "0%vatReason": "Κατηγορία Εξαίρεσης Φ.Π.Α.",
        "customVat0": "Προσαρμοσμένο Φ.Π.Α. 0%"
    },
    "ClientsNewCommunicationHistory" : {
        "table": {
            "date": "Ημερομηνία",
            "time": "Ώρα",
            "subject": "Θέμα",
            "subjectPlaceholder": "Επιλέξτε Θέμα",
            "details": "Λεπτομέρειες",
            "followUpDate": "Ημερομηνία παρακολούθησης",
            "createCalendar": "Δημιουργία εκδήλωσης ημερολογίου για παρακολούθηση",
            "done": "Ολοκληρώθηκε",
            "null": "Μηδενικό (Κενό)",
            "yes": "Ναι",
            "no": "Όχι"
        },
        "dateFrom": "Ημερομηνία Από",
        "dateTo": "Ημερομηνία Μέχρι",
        "subject": "Θέμα",
        "subjectPlaceholder": "Επιλέξτε Θέμα",
        "followUpDateFrom": "Ημερομηνία Παρακολούθησης Από",
        "followUpDateTo": "Ημερομηνία Παρακολούθησης Μέχρι",
        "done": "Ολοκλήρωση",
        "applyFilter": "Εφαρμογή Φίλτρων"
    },
    "ClientsNewInformation": {
        "table": {
            "description": "Περιγραφή",
            "details": "Λεπτομέρειες",
            "date": "Ημερομηνία",
            "time": "Ώρα",
            "lastEditedBy": "Τελευταία Επεξεργασία Από"
        },
        "title": "Πληροφορίες:",
        "notes": "Σημειώσεις",
        "addNotes": "Προσθέστε Σημειώσεις"
    },
    "ClientsNewNotes": {
        "description": "Περιγραφή",
        "details": "Λεπτομέρειες",
        "date": "Ημερομηνία",
        "time": "Ώρα",
        "lastEditedBy": "Τελευταία Επεξεργασία Από",
        "notes": "Σημειώσεις",
        "addNotes": "Προσθήκη Σημειώσεων"
    },
    "ClientsNewEmron": {
        "tablePassword": {
            "type": "Τύπος",
            "username": "Όνομα Χρήστη",
            "password": "Κωδικός",
            "notes": "Σημειώσεις"
        },
        "stockholder": {
            "name": "Όνομα",
            "surname": "Επώνυμο",
            "vat": "Α.Φ.Μ.",
            "position": "Θέση",
            "percentage": "Ποσοστό",
            "stockValue": "Αξία Μετοχής",
            "dateFrom": "Ημερομηνία Από",
            "dateTo": "Ημερομηνία Μέχρι"
        },
        "passwords": "Κωδικοί:",
        "stockholders": "Μέτοχοι:",
        "capital": "Κεφάλαιο",
        "placeholder": "Προσθήκη Αξίας"

    },
    "ClientsNewCommunicationHistoryEdit": {
        "table1": {
            "date": "Ημερομηνία",
            "time": "Χρόνος",
            "subject": "Θέμα",
            "details": "Λεπτομέρειες",
            "followUpDate": "Ημερομηνία Παρακολούθησης",
            "createCalenderEvent": "Δημιουργία συμβάντος ημερολογίου για παρακολούθηση",
            "true": "Αληθές",
            "false": "Ψευδές",
            "done": "Ολοκλήρωση"
        },
        "table2": {
            "subject": "Θέμα",
            "followUpDateFrom": "Ημερομηνία Παρακολούθησης Από",
            "followUpDateTo": "Ημερομηνία Παρακολούθησης Μέχρι",
            "done": "Ολοκλήρωση",
            "null": "Μηδενικό (Κενό)",
            "yes": "Ναι",
            "no": "Όχι"
        },
        "dateFrom": "Ημερομηνία Από",
        "dateTo": "Ημερομηνία Μέχρι",
        "subject": "Θέμα",
        "followUpDateFrom": "Ημερομηνία Παρακολούθησης Από",
        "followUpDateTo": "Ημερομηνία Παρακολούθησης Μέχρι",
        "done": "Ολοκλήρωση",
        "selectSubjects": "Επιλέξτε θέματα.",
        "clientName": {
            "clientName": "Όνομα Πελάτη",
            "placeholder": "Προσθήκη ονόματος πελάτη."
        },
        "applyFilter": "Εφαρμογή Φίλτρων"
    },
    "ClientsNewInformationEdit": {
        "description": "Περιγραφή",
        "details": "Λεπτομέρειες",
        "date": "Ημερομηνία",
        "time": "Ώρα",
        "lastEditedBy": "Τελευταία Επεξεργασία Από",
        "information": "Πληροφορίες:",
        "notes": "Σημειώσεις",
        "addNotes": "Προσθέστε Σημειώσεις"
    },
    "ClientsNewNotesEdit": {
        "table": {
            "description": "Περιγραφή",
            "details": "Λεπτομέρειες",
            "date": "Ημερομηνία",
            "time": "Ώρα",
            "lastEditedBy": "Τελευταία Επεξεργασία Από"
        },
        "notes": "Σημειώσεις",
        "addNotes": "Προσθέστε Σημειώσεις"
    },
    "ClientsNewEmronEdit": {
        "table1": {
            "type": "Τύπος",
            "username": "Όνομα Χρήστη",
            "password": "Κωδικός",
            "notes": "Σημειώσεις"
        },
        "table2": {
            "name": "Όνομα",
            "surname": "Επώνυμο",
            "vat": "Α.Φ.Μ.",
            "position": "Θέση",
            "percentage": "Ποσοστό",
            "stockValue": "Αξία Μετοχής",
            "dateFrom": "Ημερομηνία Από",
            "dateTo": "Ημερομηνία Μέχρι"
        },
        "password": "Κωδικοί",
        "stockholders": "Μέτοχοι",
        "capital": "Κεφάλαιο",
        "addValue": "Προσθήκη Αξίας"
    },
    "ClientsNewAccounting": {
        "message": "Δεν υπάρχουν πληροφορίες για αυτήν την καρτέλα"
    },
    "ClientsSearch" : {
        "clientSearch": "Αναζήτηση Πελάτη",
        "clientName": "Όνομα Πελάτη",
        "contactName": "Όνομα Επαφής",
        "manualCode": "Χειροκίνητος Κωδικός",
        "clientCode": "Κωδικός Πελάτη",
        "clientCategory": "Κατηγορία Πελάτη",
        "clientVatNumber": "Α.Φ.Μ. Πελάτη",
        "clientPhone": "Τηλέφωνο Πελάτη",
        "inactiveClient": "Εμφάνιση Ανενεργών Πελατών",
        "table": {
            "clientCode": "Κωδικός πελάτη",
            "manualCode": "Χειροκίνητος Κωδικός",
            "clientName": "Όνομα Πελάτη",
            "clientCategory": "Κατηγορία πελάτη",
            "vatNo": "Α.Φ.Μ.",
            "contactName": "Όνομα επαφής",
            "phoneNo": "Τηλέφωνο",
            "amka": "Α.Μ.Κ.Α."
        }
    },
    "ClientsMovementsNew" : {
        "files": "Αρχεία",
        "message": "Επιλέξτε πρώτα τον τύπο παραστατικού...",
        "sum": "Άθροισμα",
        "clientCode": "Κωδικός Πελάτη",
        "clientName": "Όνομα Πελάτη",
        "amount": "Ποσό",
        "documentTypes": "Τύπος Παραστατικού",
        "installation": "Εγκατάσταση",
        "preNumber": "Σειρά",
        "number": {
            "number": "Αριθμός",
            "placeholder": "Αριθμός Παραστατικού"
        },
        "date": "Ημερομηνία",
        "reason": {
            "reason": "Αιτιολογία",
            "placeholder": "Εισαγάγετε αιτιολογία"
        },
        "movementsNotes": {
            "movementsNotes": "Σημειώσεις Κινήσεων",
            "placeholder": "Προσθέστε Σημειώσεις Κινήσεων"
        },
        "code": "Κωδικός",
        "name": "Όνομα",
        "placeholder1": "Επιλέξτε Κωδικό Πελάτη",
        "placeholder2": "Επιλέξτε Όνομα Πελάτη"
    },
    "ClientMovementsSearch" : {
        "columns" : {
            "date": "Ημερομηνία",
            "clientName": "Όνομα Πελάτη",
            "reason": "Αιτιολογία",
            "clientCode": "Κωδικός πελάτη",
            "movementCategory": "Κατηγορία κίνησης",
            "totalAmount": "Συνολικό ποσό"
        },
        "clientName": "Όνομα Πελάτη",
        "totalAmountFrom": "Συνολικό Ποσό Από",
        "totalAmountTo": "Συνολικό Ποσό Μέχρι"
    },
    "ClientsReportsClientBalance": {
        "table" : {
            "tableClientName": "Όνομα Πελάτη",
            "tableVatNumber": "Α.Φ.Μ.",
            "tablePhoneNumber": "Αριθμός Τηλεφώνου"
        },
        "tableFilter" : {
            "tableInventory": "Απογραφή",
            "tableClientName": "Όνομα Πελάτη",
            "tableBalance": "Υπόλοιπο"
        },
        "calculateBalanceUpTo" : "Υπολογίστε το υπόλοιπο μέχρι:",
        "clientFrom" : {
            "clientFrom": "Από Πελάτη",
            "placeholder": "Επιλέξτε Πελάτη"
        },
        "clientTo": {
            "clientTo" : "Προς Πελάτη",
            "placeholder": "Επιλέξτε Πελάτη"
        },
        "includeInactiveClients": "Συμπεριλάβετε μη ενεργούς πελάτες",
        "includeClientsWithZeroBalance": "Συμπεριλάβετε πελάτες με μηδενικό υπόλοιπο",
        "pleaseSelectFiltersFirstAndPressApplyFilters": "Επιλέξτε πρώτα φίλτρα και πατήστε \"Εφαρμογή φίλτρων\"\n",
        "applyFilter": "Εφαρμογή φίλτρων",
        "clientBalance": "Υπόλοιπο Πελάτη",
        "pageTotals": "Σύνολα",
        "totalBalance": "Συνολικό υπόλοιπο",
        "printResults": "Εκτύπωση Αποτελεσμάτων",
        "printer" : "Εκτυπωτής",
        "printToCsv": "Εκτύπωση σε CSV",
        "printToPdf": "Εκτύπωση σε PDF",
        "printToExcel": "Εκτύπωση σε Excel",
        "printToWord": "Εκτύπωση σε Word"
    },
    "ClientsReportsClientMovement": {
        "table" : {
            "date": "Ημερομηνία",
            "invoiceType": "Τύπος Παραστατικού",
            "number": "Αριθμός",
            "amount": "Ποσό",
            "balance": "Υπόλοιπο",
            "sale": "Πώληση",
            "payment": "Πληρωμή",
            "pageTotals": "Σύνολα"
        },
        "table2" : {
            "thisMonth": "Αυτό τον Μήνα",
            "lastMonth": "Τον προηγούμενο Μήνα",
            "thisYear": "Αυτό το Έτος"
        },
        "tableClient": {
            "clientName": "Όνομα Πελάτη",
            "vatNumber": "Α.Φ.Μ.",
            "phone": "Αριθμός Τηλεφώνου:"
        },
        "tableClientFilter": {
            "includeClientsWithZeroBalance": "Συμπεριλάβετε πελάτες με μηδενικό υπόλοιπο",
            "includeInactiveClients": "Συμπεριλάβετε ανενεργούς πελάτες",
            "clientFrom": "Από Πελάτη",
            "clientTo": "Πρός Πελάτη"
        },
        "filterBy" : "Φιλτράρισμα Κατά",
        "dateFrom" : "Ημερομηνία Από",
        "clientFrom":{
            "clientFrom": "Από Πελάτη",
            "placeholder": "Επιλέξτε Πελάτης"
        },
        "dateTo": "Ημερομηνία Έως",
        "clientTo": {
            "clientTo": "Προς Πελάτη",
            "placeholder": "Επιλέξτε Πελάτης"
        },
        "includeClientsWithZeroBalance": "Συμπεριλάβετε πελάτες με μηδενικό υπόλοιπο",
        "includeInactiveClients": "Συμπεριλάβετε μη ενεργούς πελάτες",
        "pleaseSelectFiltersFirstAndPressApplyFilters": "Επιλέξτε πρώτα φίλτρα και πατήστε \"Εφαρμογή φίλτρων\"\n",
        "applyFilter": "Εφαρμογή φίλτρων",
        "clientTab": "Καρτέλα Πελάτη",
        "clientCode": "Κωδικός Πελάτη:",
        "dateRange": "Εύρος Ημερομηνιών:",
        "clientDetails": "Στοιχεία Πελάτη:",
        "page": "Σελίδα:",
        "of": "από",
        "first": "Πρώτη",
        "previous": "Προηγούμενη",
        "next": "Επόμενη",
        "last": "Τελευταία",
        "printResults": "Εκτύπωση Αποτελεσμάτων",
        "printer" : "Εκτυπωτής",
        "printToCsv": "Εκτύπωση σε CSV",
        "printToPdf": "Εκτύπωση σε PDF",
        "printToExcel": "Εκτύπωση σε Excel",
        "printToWord": "Εκτύπωση σε Word"
    },
    "ReportClientIsozygio": {
        "clientsIsozygio": "Ισοζύγιο Πελατών",
        "table": {
            "carryOver": "Από Μεταφορά",
            "clientName": "Όνομα Πελάτη",
            "clientCode": "Κωδικός Πελάτη",
            "clientVat": "Α.Φ.Μ. Πελάτη",
            "debit": "Χρέωση",
            "credit": "Πίστωση",
            "balance": "Υπόλοιπο Περιόδου",
            "totalBalance": "Συνολικό Υπόλοιπο"
        }
    },
    "ReportSupplierIsozygio": {
        "suppliersIsozygio": "Ισοζύγιο Προμηθευτών",
        "table": {
            "carryOver": "Από Μεταφορά",
            "supplierCode": "Κωδικός Προμηθευτή",
            "supplierName": "Όνομα Προμηθευτή",
            "supplierVat": "Α.Φ.Μ. Προμηθευτή",
            "debit": "Χρέωση",
            "credit": "Πίστωση",
            "balance": "Υπόλοιπο Περιόδου",
            "totalBalance": "Συνολικό Υπόλοιπο"
        }
    },
    "ClientsSettings": {
        "instructions": "Οδηγίες:",
        "instructionsCategoryName": "Το όνομα κατηγορίας είναι το όνομα της κατηγορίας για τον πελάτη:",
        "instructionsCodeMask": "Το πρόθεμα  χρησιμοποιείται για τη δημιουργία του κώδικα πελάτη. Ο χαρακτήρας \"*\", παράγει αυξανόμενη αρίθμηση. Παράδειγμα: Το Abc-***, παράγει τον κωδικό Abc-001",
        "googleCalendarApi": "Ημερολόγιο Google API",
        "clientsCommunicationHistory": "Ιστορικό Επικοινωνίας Πελατών",
        "subjectOptions": {
            "subjectOptions": "Επιλογές Θέματος",
            "placeholder": "π.χ. θέμα1, θέμα2"
        },
        "instructionsSubject": "Διαχωρίστε κάθε επιλογή με κόμμα \",\", χωρίς κενά",
        "clientInfoTabSettings": "Καρτέλα ρυθμίσεων \"πληροφοριών\" πελατών ",
        "addNewSection": {
            "addNewSection": "Προσθήκη νέας ενότητας",
            "placeholder": "Εισαγάγετε την ετικέτα ενότητας"
        }
    },
    "ClientsGeneralEdit" : {
        "message": "Επιλέξτε πρώτα κατηγορία..",
        "table": {
            "title": "Στοιχεία Επαφής:",
            "contactName": "Όνομα Επαφής",
            "mobilePhone": "Κινητό Τηλέφωνο",
            "landLine": "Σταθερό Τηλέφωνο",
            "otherPhone": "Άλλο Τηλέφωνο",
            "email": "Ηλεκτρονική Διεύθυνση",
            "contactNotes": "Σημειώσεις Επικοινωνίας",
            "acceptNotifications": "Αποδοχή Ειδοποιήσεων"
        },
        "bankInfoTable": {
            "title": "Τραπεζικά Στοιχεία:",
            "bankFriendlyName": "Φιλική Ονομασία",
            "bankInstitute": "Τραπεζικό Ίδρυμα"
        },
        "clientActive": "Ενεργός πελάτης:",
        "clientBalance": "Υπόλοιπο Πελάτη: ",
        "category" : "Κατηγορία",
        "systemCode": {
            "systemCode": "Κωδικός Συστήματος",
            "placeholder": "π.χ. sc-***"
        },
        "manualCode":{
            "manualCode": "Χειροκίνητος Κωδικός",
            "placeholder": "π.χ. mcc-001"
        },
        "name": {
            "name": "Όνομα",
            "placeholder": "Εισαγάγετε όνομα",
            "required": "Απαιτείται όνομα."
        },
        "smallName": {
            "smallName": "Διακριτικός Τίτλος",
            "placeholder": "Εισαγάγετε διακριτικό τίτλο"
        },
        "files": "Αρχεία",
        "vatCategory": {
            "vatCategory": "Κατηγορία Φ.Π.Α.",
            "required": "Απαιτείται κατηγορία Φ.Π.Α."
        },
        "0VatReason": {
            "0VatReason": "Κατηγορία Εξαίρεσης Φ.Π.Α.",
            "required": "Απαιτείται η κατηγορία εξαίρεσης Φ.Π.Α."
        },
        "customVat%": {
            "customVat%": "Προσαρμοσμένο % Φ.Π.Α.",
            "placeholder": "Προσαρμοσμένο Φ.Π.Α.",
            "required": "Απαιτείται προσαρμοσμένο Φ.Π.Α."
        },
        "vatNumber": {
            "vatNumber": "Α.Φ.Μ.",
            "placeholder": "Εισάγετε το Α.Φ.Μ.",
            "required": "Απαιτείται το Α.Φ.Μ."
        },
        "getDetails": "Αυτόματη Συμπλήρωση Στοιχείων",
        "doy": {
            "doy": "Δ.Ο.Υ.",
            "required": "Απαιτείται η Δ.Ο.Υ."
        },
        "activity": {
            "activity": "Δραστηριότητα ",
            "placeholder": "Εισαγάγετε τη Δραστηριότητα",
            "required": "Απαιτείται δραστηριότητα."
        },
        "amka": {
            "amka": "ΑΜΚΑ ",
            "placeholder": "Εισαγάγετε ΑΜΚΑ",
            "required": "Απαιτείται ηλεκτρονική διεύθυνση ή τηλέφωνο ή ΑΜΚΑ."
        },
        "country": {
            "country": "Χώρα",
            "required": "Απαιτείται χώρα."
        },
        "address": {
            "address": "Διεύθυνση",
            "placeholder": "Εισαγάγετε τη διεύθυνση ",
            "required": "Απαιτείται διεύθυνση."
        },
        "city": {
            "city": "Πόλη",
            "placeholder": "Εισαγάγετε πόλη ",
            "required": "Απαιτείται πόλη."
        },
        "postalCode": {
            "postalCode": "Ταχυδρομικός Κώδικας",
            "placeholder": "Εισαγάγετε Ταχυδρομικό Κώδικα",
            "required": "Απαιτείται ταχυδρομικός κώδικας."
        },
        "email": {
            "email": "Ηλεκτρονική Διεύθυνση",
            "placeholder": "π.χ. example@example.com",
            "error": "Μη έγκυρη ηλεκτρονική διεύθυνση.",
            "required": "Απαιτείται ηλεκτρονική διεύθυνση ή τηλέφωνο ή ΑΜΚΑ."
        },
        "phone": {
            "phone": "Τηλέφωνο",
            "placeholder": "Εισαγάγετε αριθμό τηλεφώνου"
        },
        "gemh": {
            "gemh": "ΓΕΜΗ",
            "placeholder": "Εισαγάγετε τον αριθμό ΓΕΜΗ."
        },
        "webpage": {
            "webpage": "Ιστοσελίδα",
            "placeholder": "π.χ https://www.example.com/"
        },
        "clientNotes": {
            "clientNotes": "Σημειώσεις Πελάτη:",
            "placeholder": "Προσθέστε σημειώσεις πελάτη"
        },
        "representativeName": {
            "representativeName": "Όνομα Νόμιμου Εκπροσώπου",
            "placeholder": "Όνομα Νόμιμου Εκπροσώπου"
        },
        "representativeSurname": {
            "representativeSurname": "Επώνυμο Νόμιμου Εκπροσώπου",
            "placeholder": "Επώνυμο Νόμιμου Εκπροσώπου"
        },
        "representativeVatNumber": {
            "representativeVatNumber": "ΑΦΜ Νόμιμου Εκπροσώπου",
            "placeholder": "ΑΦΜ Νόμιμου Εκπροσώπου"
        }
    },
    "ClientsGeneralInstallations": {
        "table": {
            "type": "Τύπος",
            "address": "Διεύθυνση",
            "installationDoy": "Δ.Ο.Υ.",
            "city": "Πόλη",
            "postalCode": "Ταχυδρομικός Κώδικας",
            "installationVatCategory": "Κατηγορία Φ.Π.Α. εγκατάστασης",
            "0VatReason": "Λόγοι Εξαίρεσης Φ.Π.Α.",
            "customVat": "Προσαρμοσμένο % Φ.Π.Α"
        },
        "installations": "Εγκαταστάσεις:"
    },
    "ClientMovementEdit": {
        "name": "Επιλέξτε πρώτα τον τύπο παραστατικού...",
        "table": {
            "clientCode": "Κωδικός Πελάτη",
            "clientName": "Όνομα Πελάτη",
            "amount": "Ποσό"
        },
        "files": "Αρχεία",
        "documentTypes": "Τύπος Παραστατικού",
        "installation": "Εγκατάσταση",
        "preNumber": "Σειρά",
        "number": {
            "number": "Αριθμός",
            "placeholder": "Αριθμός παραστατικού"
        },
        "date": "Ημερομηνία",
        "reason": {
            "reason": "Αιτιολογία",
            "placeholder": "Εισάγετε αιτιολογία"
        },
        "sum": "Άθροισμα",
        "movementsNotes": "Σημειώσεις Κινήσεων",
        "addMovementsNotes": "Προσθέστε Σημειώσεις Κινήσεων"
    },
    "NewClientModal": {
        "message": "Προσθήκη πελάτη",
        "message2": "Παρακαλώ επιλέξτε πρώτα κατηγορία..",
        "category": "Κατηγορία",
        "systemCode": {
            "systemCode": "Κωδικός Συστήματος",
            "placeholder": "π.χ. sc-***"
        },
        "name": {
            "name": "Όνομα",
            "placeholder": "Εισαγάγετε Όνομα",
            "required": "Το όνομα απαιτείται."
        },
        "email": {
            "email": "Ηλεκτρονική Διεύθυνση",
            "placeholder": "π.χ. example@example.com",
            "required": "Μη έγκυρη ηλεκτρονική διεύθυνση.",
            "required2": "Απαιτείται ηλεκτρονική διεύθυνση ή τηλέφωνο."
        },
        "phone": {
            "phone": "Τηλέφωνο",
            "placeholder": "Εισάγετε τον αριθμό τηλεφώνου"
        },
        "vatCategory":  {
            "vatCategory": "Κατηγορία Φ.Π.Α.",
            "required": "Απαιτείται κατηγορία Φ.Π.Α."
        },
        "0%VatReason": {
            "0%VatReason": "Κατηγορία Εξαίρεσης Φ.Π.Α.",
            "required": "Απαιτείται λόγος εξαίρεσης Φ.Π.Α."
        },
        "customVat": {
            "customVat": "Προσαρμοσμένο % Φ.Π.Α.",
            "placeholder": "Προσαρμοσμένο Φ.Π.Α.",
            "required": "Απαιτείται προσαρμοσμένο Φ.Π.Α."
        },
        "vatNumber": {
            "vatNumber": "Α.Φ.Μ.",
            "placeholder": "Μην εισάγετε τίποτα"
        },
        "vatNumber2": {
            "vatNumber2": "Α.Φ.Μ.",
            "placeholder": "Προσθέστε Α.Φ.Μ.",
            "required": "Απαιτείται Α.Φ.Μ."
        },
        "getDetails": "Αυτόματη Συμπλήρωση Στοιχείων",
        "doy": {
            "doy": "Δ.Ο.Υ.",
            "required": "Απαιτείται η Δ.Ο.Υ."
        },
        "activity": {
            "activity": "Δραστηριότητα",
            "placeholder": "Εισαγάγετε Δραστηριότητα",
            "required": "Απαιτείται δραστηριότητα."
        },
        "amka": {
            "amka": "Α.Μ.Κ.Α.",
            "placeholder": " Α.Μ.Κ.Α."
        },
        "country": {
            "country": "Χώρα",
            "required": "Απαιτείται η χώρα."
        },
        "address": {
            "address": "Διεύθυνση",
            "placeholder": "Εισαγάγετε Διεύθυνση",
            "required": "Απαιτείται η διεύθυνση."
        },
        "city": {
            "city": "Πόλη",
            "placeholder": "Εισαγάγετε Πόλη",
            "required": "Απαιτείται η πόλη."
        },
        "postalCode": {
            "postalCode": "Ταχυδρομικός Κώδικας",
            "placeholder": "Εισαγάγετε Ταχυδρομικό Κώδικα",
            "required": "Απαιτείται ο ταχυδρομικός κώδικας."
        },
        "cancel": "Ακύρωση",
        "save": "Αποθήκευση"
    },
    "cashRegistersNewTabs": {
        "cashRegisters": "Ταμειακές Μηχανές"
    },
    "cashRegistersNew": {
        "active": "Ενεργό",
        "name": {
            "name": "Όνομα ",
            "placeholder": "Εισαγάγετε Όνομα ",
            "required": "Απαιτείται το όνομα."
        },
        "isSentToAADE": "Αποστέλλεται στην ΑΑΔΕ",
        "files": "Αρχεία",
        "date": {
            "date": "Ημερομηνία",
            "required": "Απαιτείται η ημερομηνία."
        },
        "serialNumber": {
            "serialNumber": "Σειριακός Αριθμός",
            "placeholder": "Εισαγάγετε Σειριακό Αριθμό",
            "required": "Απαιτείται ο σειριακός αριθμός."
        },
        "notes": "Σημειώσεις",
        "addNotes": "Προσθέστε Σημειώσεις"

    },
    "cashRegistersSearchTabs": {
        "cashRegisters": "Αναζήτηση"
    },
    "cashRegistersSearch": {
        "table": {
            "name": "Όνομα",
            "serialNumber": "Σειριακός Αριθμός",
            "date": "Ημερομηνία",
            "isSentToAade": "Αποστέλλεται στην ΑΑΔΕ"
        },
        "name": "Όνομα",
        "serialNumber": "Σειριακός Αριθμός",
        "date": "Ημερομηνία",
        "sent": "Στάλθηκε (Ενεργό)",
        "notSent": "Δεν εστάλη (Μη Ενεργό)"
    },
    "PosNewTabs": {
        "registers": "Ταμειακές"
    },
    "PosNew": {
        "active": "Ενεργό",
        "name": {
            "name": "Όνομα",
            "placeholder": "Εισαγάγετε Όνομα",
            "required": "Απαιτείται το όνομα."
        },
        "isSentToAade": "Αποστέλλεται στην ΑΑΔΕ",
        "files": "Αρχεία",
        "date": {
            "date": "Ημερομηνία",
            "required": "Απαιτείται η ημερομηνία."
        },
        "serialNumber" : {
            "serialNumber": "Σειριακός Αριθμός",
            "placeholder": "Εισαγάγετε Σειριακό Αριθμό",
            "required": "Απαιτείται ο σειριακός αριθμός."
        },
        "isETameiaki" : "Είναι e-Ταμειακή",
        "tameiakiUsername" : {
            "placeholder" : "Εισαγάγετε Όνομα Χρήστη",
            "label" : "Όνομα Χρήστη",
            "required" : "Απαιτείται όνομα χρήστη"
        },
        "tameiakiPassword" : {
            "placeholder" : "Εισαγάγετε Κωδικό Χρήστη",
            "label" : "Κωδικός Χρήστη",
            "required" : "Απαιτείται κωδικός χρήστη"
        },
        "tid:" : {
            "required" : "Απαιτείται TID"
        },
        "notes": "Σημειώσεις",
        "addNotes": "Προσθέστε Σημειώσεις"
    },
    "EmployeeNew": {
        "active": "Ενεργό",
        "firstName": {
            "name": "Όνομα",
            "placeholder": "Εισαγάγετε Όνομα",
            "required": "Απαιτείται το Όνομα."
        },
        "lastName": {
            "name": "Επώνυμο",
            "placeholder": "Εισαγάγετε Επώνυμο",
            "required": "Απαιτείται το Επώνυμο."
        },
        "fatherFirstName": {
            "name": "Όνομα Πατέρα",
            "placeholder": "Εισαγάγετε Όνομα Πατέρα",
            "required": "Απαιτείται το Όνομα Πατέρα."
        },
        "fatherLastName": {
            "name": "Επώνυμο Πατέρα",
            "placeholder": "Εισαγάγετε Επώνυμο Πατέρα",
            "required": "Απαιτείται το Επώνυμο Πατέρα."
        },
        "motherFirstName": {
            "name": "Όνομα Μητέρας",
            "placeholder": "Εισαγάγετε Όνομα Μητέρας",
            "required": "Απαιτείται το Όνομα Μητέρας."
        },
        "motherLastName": {
            "name": "Επώνυμο Μητέρας",
            "placeholder": "Εισαγάγετε Επώνυμο Μητέρας",
            "required": "Απαιτείται το Επώνυμο Μητέρας."
        },
        "vatNumber": {
            "name": "Α.Φ.Μ.",
            "placeholder": "Εισαγάγετε Α.Φ.Μ.",
            "required": "Απαιτείται το Α.Φ.Μ. ."
        },
        "amka": {
            "name": "Α.Μ.Κ.Α.",
            "placeholder": "Εισαγάγετε Α.Μ.Κ.Α.",
            "required": "Απαιτείται το Α.Μ.Κ.Α."
        },
        "amika": {
            "name": "Α.Μ.Ι.Κ.Α.",
            "placeholder": "Εισαγάγετε Α.Μ.Ι.Κ.Α.",
            "required": "Απαιτείται το Α.Μ.Ι.Κ.Α."
        },
        "specialty": {
            "name": "Ειδικότητα",
            "placeholder": "Εισαγάγετε Ειδικότητα",
            "required": "Απαιτείται η Ειδικότητα"
        },
        "sex": {
            "name": "Φύλο",
            "required": "Απαιτείται το Φύλο."
        },
        "birthDate": {
            "name": "Ημερομηνία Γέννησης",
            "required": "Απαιτείται η Ημερομηνία Γέννησης"
        },
        "employeeType": {
            "name": "Τύπος Εργαζομένου",
            "placeholder": "Εισαγάγετε Τύπο Εργαζομένου",
            "required": "Απαιτείται ο Τύπος Εργαζομένου"
        },
        "employeeCategory": {
            "name": "Κατηγορία Εργαζομένου",
            "placeholder": "Εισαγάγετε Κατηγορία Εργαζομένου",
            "required": "Απαιτείται η Κατηγορία Εργαζομένου"
        },
        "installation": {
            "name": "Εγκατάσταση",
            "placeholder": "Εισαγάγετε Εγκατάσταση",
            "required": "Απαιτείται η Εγκατάσταση"
        },
        "employmentDate": {
            "name": "Ημερομηνία Πρόσληψης",
            "required": "Απαιτείται η Ημερομηνία Πρόσληψης"
        },
        "salary": {
            "name": "Μισθός",
            "required": "Απαιτείται ο Μισθός"
        },
        "personalLabel": "Προσωπικά Στοιχεία",
        "securityLabel": "Ασφαλιστικά Στοιχεία",
        "workingLabel": "Εργασιακά Στοιχεία",
        "resignationDate": "Ημερομηνία Αποχώρησης",
        "resignationCause": "Αιτία Αποχώρησης"
    },
    "EmployeeSearch": {
        "filters": {
            "firstName": "Όνομα",
            "lastName": "Επώνυμο",
            "employeeType": "Τύπος Υπαλλήλου",
            "isActive": "Εμφάνιση Ανενεργών",
            "employmentDate": "Ημερομηνία Πρόσληψης",
            "installation": "Εγκατάσταση",
            "vatNumber": "Α.Φ.Μ."
        },
        "columns": {
            "firstName": "Όνομα",
            "lastName": "Επώνυμο",
            "employeeType": "Τύπος Υπαλλήλου",
            "installation": "Εγκατάσταση",
            "employmentDate": "Ημερομηνία Πρόσληψης",
            "resignationDate": "Ημερομηνία Αποχώρησης",
            "resignationCause": "Αιτία Αποχώρησης",
            "birthDate": "Ημερομηνία Γέννησης",
            "vatNumber": "Α.Φ.Μ.",
            "AMKA": "Α.Μ.Κ.Α.",
            "AMIKA": "Α.Μ.Ι.Κ.Α.",
            "salary": "Μισθός"
        }
    },
    "AccountingAccountSettings": {
        "description": "Το Όνομα προτύπου είναι το Όνομα του προτύπου για τον λογιστικό λογαριασμό.\n Πατώντας πάνω σε ένα πρότυπο μπορείτε να προσθέσετε προεπιλεγμένες επιλογές για τον πίνακα MyData, τον ΦΠΑ-Καθαρή Αξία καθώς και τον υπολογαριασμό του λογαριασμού."
    },
    "AccountingRecordSettings": {
        "description": "Το Όνομα κατηγορίας είναι το Όνομα τής κατηγορίας για τον λογιστικό άρθρο.\n Πατώντας πάνω σε μια κατηγορία μπορείτε να προσθέσετε υποκατηγορίες με τις οποίες μπορείτε να προσθέσετε και να επεξεργαστείτε τις προεπιλεγμένες επιλογές και λογαριασμούς για ένα λογιστικό άρθρο."
    },
    "AccountingAccountNew": {
        "isActive": "Ενεργός Λογαριασμός",
        "movable": "Κινείται",
        "transferable": "Μεταφέρεται",
        "balance": "Υπόλοιπο Λογαριασμού:",
        "category": "Πρότυπο Λογαριασμού",
        "accountingCode":
            {
                "name": "Κωδικός Λογαριασμού",
                "placeholder": "Εισάγετε Κωδικό Λογαριασμού",
                "required": "Ο Κωδικός Λογαριασμού είναι υποχρεωτικός"
            },
        "alternativeName":{
            "name": "Εναλλακτικό Όνομα",
            "placeholder": "Εισάγετε Εναλλακτικό Όνομα"
        },
        "name": {
            "name": "Όνομα Λογαριασμού",
            "placeholder": "Εισάγετε Όνομα Λογαριασμού",
            "required": "Το Όνομα Λογαριασμού είναι υποχρεωτικό"
        },
        "isVat": "Είναι ΦΠΑ",
        "vatReason": "Αιτία Εξαίρεσης ΦΠΑ",
        "vatReasonRequired": "Απαιτείται η Αιτία Εξαίρεσης ΦΠΑ",
        "isNetValue": "Είναι Καθαρή Αξία",
        "subAccount": {
            "name": "Υποκατηγορία",
            "placeholder": "Επιλέξτε Υπολογαριασμό",
            "required": "Η Υποκατηγορία είναι υποχρεωτική"
        },
        "clientCategories": {
            "name": "Κατηγορίες Πελατών",
            "required": "Το πεδίο είναι υποχρεωτικό"
        },
        "supplierCategories": {
            "name": "Κατηγορίες Προμηθευτών",
            "required": "Το πεδίο είναι υποχρεωτικό"
        },
        "employeeCategories": {
            "name": "Κατηγορίες Εργαζόμενων",
            "required": "Το πεδίο είναι υποχρεωτικό"
        }
    },
    "AccountingAccountSearch": {
        "filters": {
            "name": "Όνομα Λογαριασμού",
            "code": "Κωδικός Λογαριασμού",
            "alternativeName": "Εναλλακτικό Όνομα Λογαριασμού",
            "category": "Κατηγορία Λογαριασμού",
            "subAccount": "Υποκατηγορία Λογαριασμού",
            "isActive": "Εμφάνιση Ανενεργών"
        },
        "columns": {
            "name": "Όνομα",
            "code": "Κωδικός",
            "alternativeName": "Εναλλακτικό Όνομα",
            "category": "Κατηγορία",
            "subAccount": "Υποκατηγορία",
            "transferable": "Μεταφέρεται",
            "movable": "Κινείται"
        }
    },
    "PosSearchTabs": {
        "search": "Αναζήτηση"
    },
    "PosSearch": {
        "table": {
            "name": "Όνομα",
            "serialNumber": "Σειριακός Αριθμός",
            "date": "Ημερομηνία",
            "isSentToAade": "Αποστέλλεται στην ΑΑΔΕ"
        },
        "name": "Όνομα",
        "serialNumber": "Σειριακός Αριθμός",
        "date": "Ημερομηνία",
        "sent": "Στάλθηκε (Ενεργό)",
        "notSent": "Δεν εστάλη (Μη Ενεργό)"
    },
    "PosNewEdit": {
        "active": "Ενεργό",
        "name": {
            "name": "Όνομα",
            "placeholder": "Εισαγάγετε Όνομα",
            "required": "Απαιτείται το όνομα."
        },
        "isSentToAade": "Αποστέλλεται στην ΑΑΔΕ",
        "files": "Αρχεία",
        "date": {
            "date": "Ημερομηνία",
            "required": "Απαιτείται η ημερομηνία."
        },
        "serialNumber" : {
            "serialNumber": "Σειριακός Αριθμός",
            "placeholder": "Εισαγάγετε Σειριακό Αριθμό",
            "required": "Απαιτείται ο σειριακός αριθμός."
        },
        "isETameiaki" : "Είναι e-Ταμειακή",
        "tameiakiUsername" : {
            "placeholder" : "Εισαγάγετε Όνομα Χρήστη",
            "label" : "Όνομα Χρήστη",
            "required" : "Απαιτείται όνομα χρήστη"
        },
        "tameiakiPassword" : {
            "placeholder" : "Εισαγάγετε Κωδικό Χρήστη",
            "label" : "Κωδικός Χρήστη",
            "required" : "Απαιτείται κωδικός χρήστη"
        },
        "notes": "Σημειώσεις",
        "addNotes": "Προσθέστε Σημειώσεις"
    },
    "BankAccountsNewTabs": {
        "registers": "Ταμειακές"
    },
    "BankAccountsNew": {
        "smallTable": {
            "name": "Όνομα",
            "swift": "Κωδικός SWIFT",
            "country": "Χώρα"
        },
        "active": "Ενεργό:",
        "name": {
            "name": "Όνομα",
            "placeholder": "Εισάγετε Όνομα",
            "required": "Το όνομα είναι υποχρεωτικό πεδίο."
        },
        "bank": {
            "bank": "Τράπεζα",
            "placeholder": "Επιλέξτε Πρότυπο"
        },
        "files": "Αρχεία",
        "date": {
            "date": "Ημερομηνία",
            "required": "Απαιτείται η ημερομηνία."
        },
        "iban": {
            "iban": "IBAN",
            "placeholder": "Εισάγετε IBAN",
            "required": "Απαιτείται ο IBAN."
        },
        "isSentToAade": "Αποστέλλεται στην ΑΑΔΕ",
        "notes": "Σημειώσεις",
        "addNotes": "Προσθέστε Σημειώσεις"
    },
    "BankAccountsSearchTabs": {
        "search": "Αναζήτηση"
    },
    "BankAccountsSearch": {
        "table": {
            "name": "Όνομα",
            "bank": "Τράπεζα",
            "iban": "IBAN",
            "date": "Ημερομηνία",
            "isSentToAade": "Αποστέλλεται στην ΑΑΔΕ"
        },
        "name": "Όνομα",
        "iban": "IBAN",
        "bank": "Τράπεζα",
        "date": "Ημερομηνία",
        "active": "Στάλθηκε (Ενεργό)",
        "inactive": "Δεν εστάλη (Μη Ενεργό)"
    },
    "BankAccountsNewEdit": {
        "smallTable": {
            "name": "Όνομα",
            "swift": "Κωδικός SWIFT",
            "country": "Χώρα"
        },
        "active": "Ενεργό:",
        "name": {
            "name": "Όνομα",
            "placeholder": "Εισάγετε Όνομα",
            "required": "Το όνομα είναι υποχρεωτικό πεδίο."
        },
        "bank": {
            "bank": "Τράπεζα",
            "placeholder": "Επιλέξτε Πρότυπο"
        },
        "files": "Αρχεία",
        "date": {
            "date": "Ημερομηνία",
            "required": "Απαιτείται η ημερομηνία."
        },
        "iban": {
            "iban": "IBAN",
            "placeholder": "Εισάγετε IBAN",
            "required": "Απαιτείται ο IBAN."
        },
        "isSentToAade": "Αποστέλλεται στην ΑΑΔΕ",
        "notes": "Σημειώσεις",
        "addNotes": "Προσθέστε Σημειώσεις"
    },
    "SettingPrimerMyDataTabs": {
        "setting": "Ρυθμίσεις"
    },
    "SettingPrimerMyData": {
        "enableSyncPrimerMyDataProvider": "Ενεργοποίηση  Συγχρονισμού Παραστατικών από τον Πάροχο MyData Primer Software",
        "enablePrimerMyDataProvider": "Ενεργοποίηση Παρόχου MyData Primer Software",
        "primerMyDataProvider": "Κωδικοί MyData",
        "username": {
            "username": "Όνομα Χρήστη",
            "placeholder": "Προσθέστε Όνομα Χρήστη"
        },
        "password": {
            "password": "Κωδικός πρόσβασης",
            "placeholder": "Προσθέστε Κωδικό πρόσβαση"
        },
        "serialNumber": {
            "serialNumber": "Σειριακός Αριθμός",
            "placeholder": "Προσθέστε Σειριακός αριθμός"
        },
        "environment": "Περιβάλλον:",
        "activate": "Ενεργοποίηση",
        "primerMyDataInformation": "Πληροφορίες Primer MyData",
        "totalRemainingMyDataDocuments": "Σύνολο Υπολειπόμενων Παραστατικών MyData:",
        "monthlyRemainingMyDataDocuments": "Μηνιαία Υπολειπόμενα Παραστατικά MyData:",
        "contractActivationDate": "Ημερομηνία Ενεργοποίησης:",
        "contractEndDate": "Ημερομηνία Λήξης:",
        "updateInformation": "Ενημέρωση Πληροφοριών",
        "myDataCredentials": "Κωδικοί MyData",
        "userId": {
            "userId": "Όνομα Χρήστη",
            "placeholder": "Προσθέστε όνομα Χρήστη"
        },
        "subscriptionKey": {
            "subscriptionKey": "Subscription Key",
            "placeholder": "Προσθέστε Subscription Key"
        },
        "myDataSendingMode": "Λειτουργία Αποστολής Δεδομένων MyData:"
    },
    "SettingsPrimerDataTabs": {
        "vat": "Φ.Π.Α",
        "otherTaxes1": "Λοιποί Φόροι 1",
        "otherTaxes2": "Λοιποί Φόροι 2",
        "otherData": "Λοιπά Δεδομένα"
    },
    "SettingsPrimerData": {
        "tableZero": {
            "code": "Κωδικός",
            "description": "Περιγραφή"
        },
        "tableMatching": {
            "normalVat": "Κανονικό Φ.Π.Α.",
            "reducedVat": "Μειωμένο Φ.Π.Α.",
            "zeroVat": "Μηδενικό Φ.Π.Α."
        },
        "table": {
            "code": "Κωδικός",
            "percentage": "Ποσοστό",
            "accountingCode": "Πρόθεμα Λογιστικής",
            "defaultValue": "Προεπιλεγμένη Τιμή",
            "deactivated": "Απενεργοποιημένο"
        },
        "tableWithhold": {
            "name": "Όνομα",
            "taxLevel": "Επίπεδο Φόρου",
            "vatIncluded": "Περιλαμβάνει Φ.Π.Α.",
            "vatPercentage": "Ποσοστό Φ.Π.Α.",
            "value": "Αξία",
            "myData": "Περιγραφή MyData"
        },
        "tableOtherTax": {
            "name": "Όνομα",
            "taxLevel": "Επίπεδο Φόρου",
            "vatIncluded": "Περιλαμβάνει Φ.Π.Α.",
            "vatPercentage": "Ποσοστό Φ.Π.Α.",
            "value": "Αξία",
            "myData": "Περιγραφή MyData"
        },
        "tableStamp": {
            "code": "Κωδικός MyData",
            "description": "Περιγραφή",
            "taxStamp": "Φόρος Χαρτόσημου (Ψηφ. τέλος συν.)"
        },
        "tablePaymentWay": {
            "myDataCode": "Κωδικός MyData",
            "name": "Όνομα",
            "active": "Ενεργό"
        },
        "tableMeasurementUnits" : {
            "myDataCode": "Κωδικός MyData",
            "name": "Όνομα",
            "shortName": "Σύντομο Όνομα",
            "active": "Ενεργό"
        },
        "tableHours": {
            "name": "Όνομα",
            "hours": "Ώρες"
        },
        "tableProductLine": {
            "myDataCode": "Κωδικός MyData",
            "name": "Όνομα",
            "developerNotes": "Λοιπές Πληροφορίες",
            "active": "Ενεργό"
        },
        "vat%": "Φ. Π. Α. %",
        "vatMatchingTable": "Πίνακας Αντιστοίχισης Φ.Π.Α.",
        "vat0%Reason": "Λόγοι Εξαίρεσης Φ.Π.Α.",
        "withholdTaxes": "Παρακρατούμενοι Φόροι",
        "otherTaxes": "Λοιποί Φόροι",
        "feesChargesCategory": "Τέλη",
        "stamp": "Χαρτόσημα",
        "paymentWays": "Τρόποι πληρωμής",
        "measurementUnits": "Μονάδες μέτρησης",
        "highlight": "Επισήμανση",
        "allowIssuingInvoicesBefore": "Να επιτρέπεται η έκδοση τιμολογίων πριν:",
        "salePurpose": "Σκοπός Διακίνησης",
        "myDataProductLineCoding": "Κωδικοί Γραμμής Ειδών MyData"
    },
    "DocumentTypeBasicNewTabs": {
        "basicTypes": "Βασικά Παραστατικά",
        "basicTypesSearch": "Αναζήτηση Βασικών Παραστατικών"
    },
    "DocumentTypeBasicNew": {
        "table": {
            "basicTypeName": "Όνομα Βασικού Παραστατικού",
            "typeAffectsInventory": "Επηρεάζει Απόθεμα",
            "typeAffectsClient": "Επηρεάζει Πελάτη",
            "typeAffectsSupplier": "Επηρεάζει Υπόλοιπο Προμηθευτή"
        },
        "tableSearch": {
            "basicTypeNameFrom": "Όνομα Βασικού Παραστατικού",
            "basicTypeNameTo": "Όνομα Βασικού Παραστατικού Μέχρι",
            "typeAffectsInventory": "Επηρεάζει Απόθεμα",
            "typeAffectsClient": "Επηρεάζει Πελάτη",
            "typeAffectsSupplier": "Επηρεάζει Υπόλοιπο Προμηθευτή"
        },
        "name": {
            "name": "Όνομα",
            "placeholder": "Εισάγετε Όνομα"
        },
        "typeAffectsInventory": "Επηρεάζει Απόθεμα",
        "typeAffectsClient": "Επηρεάζει Πελάτη",
        "typeAffectsSupplier": "Επηρεάζει Υπόλοιπο Προμηθευτή"
    },
    "DocumentTypeAdvancedNewTabs": {
        "advancedTypes": "Γενικά Παραστατικά",
        "advancedTypesSearch": "Αναζήτηση Γενικών Παραστατικών"
    },
    "DocumentTypeAdvancedNew": {
        "tableSmall": {
            "address": "Διεύθυνση",
            "city": "Πόλη",
            "type": "Τύπος"
        },
        "table": {
            "installation": "Εγκατάσταση",
            "numberingMode": "Λειτουργία Αρίθμησης",
            "preNumber": "Σειρά",
            "selected": "Προεπιλεγμένη",
            "number": "Αριθμός",
            "placeholder": "Επιλέξτε Εγκατάσταση",
            "true": "Αληθές",
            "false": "Ψευδές"
        },
        "table2": {
            "automatic": "Αυτόματα",
            "manual": "Χειροκίνητα"
        },
        "tableAdvanced": {
            "advancedTypeName": "Όνομα Γενικού Τύπου ",
            "basicDocumentType": "Τύπος Βασικού Παραστατικού",
            "section": "Κατηγορία"
        },
        "tableAdvancedSearch": {
            "advancedTypeNameFrom": "Όνομα Γενικού Τύπου",
            "advancedTypeNameTo": "Όνομα Γενικού Τύπου Μέχρι",
            "section": "Κατηγορία",
            "basicDocumentType": "Τύπος Βασικού Παραστατικού",
            "showInactiveAdvancedTypes": "Εμφάνιση Μη Ενεργών Γενικών Τύπων"
        },
        "message": "Παρακαλώ κάντε πρώτα μια επιλογή στην κατηγορία.",
        "section": "Κατηγορία",
        "basicDocumentType": {
            "basicDocumentType": "Βασικός Τύπος Παραστατικού",
            "required": "Απαιτείται Βασικός Τύπος Παραστατικού."
        },
        "active": "Ενεργό",
        "name": {
            "name": "Όνομα",
            "placeholder": "Εισάγετε Όνομα",
            "required": "Απαιτείται Όνομα.",
            "warning": "Το όνομα υπάρχει ήδη."
        },
        "printTemplate": "Πρότυπο Εκτύπωσης",
        "alwaysPrintAfterSave": "Εκτύπωση Πάντα Μετά Την Αποθήκευση",
        "alwaysSendEmailAfterSave": "Αποστολή Email Πάντα Μετά Την Αποθήκευση",
        "useLogo": "Ενεργοποίηση Logo κατά την εκτύπωση",
        "isCensus": "Ενεργοποίηση παραστατικού απογραφής",
        "canBePaidOff": "Ενεργοποίηση δυνατότητας εξόφλησης μέσω είσπραξης",
        "enableMyDataProvider": "Ενεργοποίηση Παρόχου MyData",
        "handwrittenDocument": "Ενεργοποίηση έκδοσης/αποτυχίας σύνδεσης χειρόγραφου παραστατικού",
        "enableMyData": "Ενεργοποίηση MyData",
        "enableMyDataRules": "Ενεργοποίηση Κανόνων MyData",
        "myDataInvoiceType": {
            "myDataInvoiceType": "Κωδικός MyData (Τιμολόγιο)",
            "required": "Απαιτείται ο Τύπος MyData."
        },
        "creditDocument": "Πιστωτικό Παραστατικό",
        "creditDocumentPreNumber": "Σειρά Πιστωτικού Παραστατικού",
        "conversionDocument": "Μετατρέψιμο Παραστατικό",
        "conversionDocumentPreNumber": "Σειρά Μετατρέψιμου Παραστατικού",
        "proposedSalePurpose": "Προτεινόμενος Σκοπός Διακίνησης",
        "thirdPartySales": "Πωλήσεις Τρίτων",
        "myDataType": "Κωδικός MyData",
        "proposedPaymentType": {
            "proposedPaymentType": "Προτεινόμενος Τρόπος Πληρωμής",
            "required": "Απαιτείται Προτεινόμενος Τρόπος Πληρωμής."
        },
        "proposedPOSBankAccount": {
            "proposedPOSBankAccount": "Προτεινόμενος POS/Τραπεζικός Λογαριασμός",
            "required": "Απαιτείται Προτεινόμενος Τύπος Πληρωμής."
        },
        "documentNumbering": "Αρίθμηση Παραστατικού",
        "message2": "Η αρίθμηση παραστατικών δεν πρέπει να είναι κενή.",
        "enableDisplayClientBalance": "Προβολή προηγούμενου-νέου υπολοίπου πελάτη στο παραστατικό"
    },
    "DocumentTypeAdvancedNewEdit": {
        "tableSmall": {
            "address": "Διεύθυνση",
            "city": "Πόλη",
            "type": "Τύπος"
        },
        "table": {
            "installation": "Εγκατάσταση",
            "numberingMode": "Λειτουργία Αρίθμησης",
            "preNumber": "Σειρά",
            "selected": "Προεπιλεγμένη",
            "number": "Αριθμός"
        },
        "tableAdvanced": {
            "advancedTypeName": "Όνομα Γενικού Τύπου ",
            "basicDocumentType": "Τύπος Βασικού Παραστατικού",
            "section": "Κατηγορία"
        },
        "tableAdvancedSearch": {
            "advancedTypeNameFrom": "Όνομα Γενικού Τύπου Από",
            "advancedTypeNameTo": "Όνομα Γενικού Τύπου Μέχρι",
            "section": "Κατηγορία",
            "basicDocumentType": "Τύπος Βασικού Παραστατικού",
            "showInactiveAdvancedTypes": "Εμφάνιση Μη Ενεργών Γενικών Τύπων"
        },
        "message": "Παρακαλώ κάντε πρώτα μια επιλογή στην κατηγορία.",
        "section": "Κατηγορία",
        "basicDocumentType": {
            "basicDocumentType": "Βασικός Τύπος Παραστατικού",
            "required": "Απαιτείται Βασικός Τύπος Παραστατικού."
        },
        "active": "Ενεργό",
        "name": {
            "name": "Όνομα",
            "placeholder": "Εισάγετε Όνομα",
            "required": "Απαιτείται Όνομα.",
            "warning": "Το όνομα υπάρχει ήδη."
        },
        "printTemplate": "Πρότυπο Εκτύπωσης",
        "alwaysPrintAfterSave": "Εκτύπωση Πάντα Μετά Την Αποθήκευση",
        "alwaysSendEmailAfterSave": "Αποστολή Email Πάντα Μετά Την Αποθήκευση",
        "enableMyDataProvider": "Ενεργοποίηση Παρόχου MyData",
        "handwrittenDocument": "Ενεργοποίηση έκδοσης/αποτυχίας σύνδεσης χειρόγραφου παραστατικού",
        "enableMyData": "Ενεργοποίηση MyData",
        "enableMyDataRules": "Ενεργοποίηση Κανόνων MyData",
        "myDataInvoiceType": {
            "myDataInvoiceType": "Κωδικός MyData (Τιμολόγιο)",
            "required": "Απαιτείται ο Τύπος MyData."
        },
        "creditDocument": "Πιστωτικό Παραστατικό",
        "creditDocumentPreNumber": "Σειρά Πιστωτικού Παραστατικού",
        "conversionDocument": "Μετατρέψιμο Παραστατικό",
        "conversionDocumentPreNumber": "Σειρά Μετατρέψιμου Παραστατικού",
        "proposedSalePurpose": "Προτεινόμενος Σκοπός Διακίνησης",
        "thirdPartySales": "Πωλήσεις Τρίτων",
        "myDataType": "Κωδικός MyData",
        "proposedPaymentType": {
            "proposedPaymentType": "Προτεινόμενος Τρόπος Πληρωμής",
            "required": "Απαιτείται Προτεινόμενος Τρόπος Πληρωμής."
        },
        "proposedPOSBankAccount": {
            "proposedPOSBankAccount": "Προτεινόμενος POS/Τραπεζικός Λογαριασμός",
            "required": "Απαιτείται Προτεινόμενος Τύπος Πληρωμής."
        },
        "documentNumbering": "Αρίθμηση Παραστατικού",
        "message2": "Η αρίθμηση παραστατικών δεν πρέπει να είναι κενή.",
        "enableDisplayClientBalance": "Προβολή προηγούμενου-νέου υπολοίπου πελάτη στο παραστατικό"
    },
    "GeneralSettingsTabs": {
        "companySettings": "Ρυθμίσεις Εταιρείας",
        "tasks": "Καθήκοντα"
    },
    "GeneralSettings":{
        "tableClientInstallations": {
            "type": "Τύπος",
            "address": "Διεύθυνση",
            "doy": "Δ.Ο.Υ.",
            "city": "Πόλη",
            "postalCode": "Ταχυδρομικός Κώδικας"
        },
        "tableCompanyUser": {
            "firstName": "Όνομα",
            "lastName": "Επώνυμο",
            "email": "Email",
            "userRights": "Τύπος Χρήστη",
            "username": "Όνομα Χρήστη"
        },
        "licensedTo": "Άδεια χρήσης για",
        "companyName": {
            "companyName": "Όνομα Εταιρείας:",
            "placeholder": "Κενό"
        },
        "companySmallName": {
            "companySmallName": "Διακριτικός Τίτλος Εταιρείας:",
            "placeholder": "Κενό"
        },
        "activity": {
            "activity": "Δραστηριότητα:",
            "placeholder": "Κενό"
        },
        "vatNumber": {
            "vatNumber": "Α.Φ.Μ.:",
            "placeholder": "Κενό"
        },
        "headquartersAddress": {
            "headquartersAddress": "Διεύθυνση Έδρας:",
            "placeholder": "Κενό"
        },
        "city": {
            "city": "Πόλη:",
            "placeholder": "Κενό"
        },
        "country": {
            "country": "Χώρα:",
            "placeholder": "Κενό"
        },
        "postalCode": {
            "postalCode": "Ταχυδρομικός Κώδικας:",
            "placeholder": "Κενό"
        },
        "phoneNumber": {
            "phoneNumber": "Αριθμός Τηλεφώνου:",
            "placeholder": "Κενό"
        },
        "email": {
            "email": "Ηλεκτρονικού Διεύθυνση:",
            "placeholder": "Κενό"
        },
        "gemh": {
            "gemh": "Αριθμός Γ.Ε.Μ.Η. :",
            "placeholder": "Κενό"
        },
        "representativeName": {
            "representativeName": "Όνομα Εκπροσώπου:",
            "placeholder": "Κενό"
        },
        "representativeSurname": {
            "representativeSurname": "Επώνυμο Εκπροσώπου:",
            "placeholder": "Κενό"
        },
        "representativeVatNumber": {
            "representativeVatNumber": "Α.Φ.Μ. Εκπροσώπου:",
            "placeholder": "Κενό"
        },
        "companyStartDate": "Ημερομηνία Έναρξης Επιχείρησης: ",
        "companyExpireDate": "Ημερομηνία Λήξης Επιχείρησης: ",
        "companyLogo": "Λογότυπο Επιχείρησης:",
        "uploadFile": "Ανέβασμα Λογοτύπου",
        "uploadFileDesc": "Υποστηρίζονται αρχεία JPG, PNG διαστάσεων 350 x 100px.",
        "useLogoInInvoices": "Ενεργοποίηση λογότυπου στα παραστατικά",
        "finished": "Ολοκληρωμένο",
        "installations": "Εγκαταστάσεις",
        "companyUsers": "Χρήστες"
    },
    "SettingsSystemTasks": {
        "reUpdateProductsInventoryBalance": "Ενημέρωση του υπολοίπου αποθέματος ειδών",
        "reUpdateClientBalance": "Ενημέρωση του υπολοίπου πελατών",
        "reUpdateSupplierBalance": "Ενημέρωση του υπολοίπου προμηθευτών",
        "reUpdateClientInfo": "Ενημέρωση στοιχείων των πελατών",
        "reUpdateSupplierInfo": "Ενημέρωση στοιχείων των προμηθευτών",
        "syncClientPaymentsWithSales" : "Συγχρονισμός εισπράξεων με πωλήσεις",
        "reupdate": "Ενημέρωση",
        "sync": "Συγχρονισμός",
        "warning": "Προειδοποίηση!!",
        "message": "Όλα τα υπόλοιπα αποθέματος ειδών θα υπολογιστούν εκ νέου. Η διαδικασία μπορεί να χρησιμοποιηθεί μόνο μία φορά ανά 60 λεπτά. Όλοι οι χρήστες που έχουν συνδεθεί θα αποσυνδεθούν μέχρι να ολοκληρωθεί η διαδικασία. Θέλετε να συνεχίσετε;",
        "clientMessage": "Όλα τα υπόλοιπα πελατών θα υπολογιστούν εκ νέου. Η διαδικασία μπορεί να χρησιμοποιηθεί μόνο μία φορά ανά 60 λεπτά. Όλοι οι χρήστες που έχουν συνδεθεί θα αποσυνδεθούν μέχρι να ολοκληρωθεί η διαδικασία. Θέλετε να συνεχίσετε;",
        "supplierMessage": "Όλα τα υπόλοιπα προμηθευτών θα υπολογιστούν εκ νέου. Η διαδικασία μπορεί να χρησιμοποιηθεί μόνο μία φορά ανά 60 λεπτά. Όλοι οι χρήστες που έχουν συνδεθεί θα αποσυνδεθούν μέχρι να ολοκληρωθεί η διαδικασία. Θέλετε να συνεχίσετε;",
        "clientUpdateMessage": "Όλες οι πληροφορίες των πελατών θα ενημερωθούν εκ νέου. Όλοι οι χρήστες που έχουν συνδεθεί θα αποσυνδεθούν μέχρι να ολοκληρωθεί η διαδικασία. Θέλετε να συνεχίσετε;",
        "clientUpdateCompletedMessage1": "Η ενημέρωση πελατών ολοκληρώθηκε.",
        "clientUpdateCompletedMessage2": "Συνολικοί πελάτες:",
        "clientUpdateCompletedMessage3": "Ενημερώθηκαν:",
        "supplierUpdateMessage": "Όλες οι πληροφορίες των προμηθευτών θα ενημερωθούν εκ νέου. Όλοι οι χρήστες που έχουν συνδεθεί θα αποσυνδεθούν μέχρι να ολοκληρωθεί η διαδικασία. Θέλετε να συνεχίσετε;",
        "supplierUpdateCompletedMessage1": "Η ενημέρωση προμηθευτών ολοκληρώθηκε.",
        "supplierUpdateCompletedMessage2": "Συνολικοί προμηθευτές:",
        "supplierUpdateCompletedMessage3": "Ενημερώθηκαν:",
        "syncMessage" : "Όλες οι πωλήσεις θα συγχρονιστούν με τις υπάρχουσες εισπράξεις. Η διαδικασία αυτή μπορεί να πάρει εως και 5 λεπτά. Όλοι οι χρήστες που έχουν συνδεθεί θα αποσυνδεθούν μέχρι να ολοκληρωθεί η διαδικασία. Θέλετε να συνεχίσετε;",
        "no": "Όχι",
        "yes": "Ναι"
    },
    "SettingsEmailSMTP": {
        "usePrimerSmtp": "Χρησιμοποιήστε Primer SMTP",
        "useCustomSmtp": "Χρησιμοποιήστε Προσαρμοσμένο SMTP",
        "smtpSettings": "Ρυθμίσεις SMTP",
        "fromEmail": {
            "fromEmail": "Από Email",
            "placeholder": "Προσθέστε Από Email"
        },
        "username": {
            "username": "Όνομα Χρήστη",
            "placeholder": "Προσθέστε Όνομα Χρήστη"
        },
        "password": {
            "password": "Κωδικός",
            "placeholder": "Προσθέστε Κωδικός"
        },
        "encryptionType": "Τύπος Κρυπτογράφησης",
        "none": "Κανένα",
        "start": "Start",
        "message": "Για τους περισσότερους servers το SSL/TLS είναι η προτεινόμενη επιλογή",
        "no": "Όχι",
        "yes": "Ναι",
        "smtpAuthentication": "Αυθεντικοποίηση SMTP",
        "smtpServerPlaceholder": "Προσθέστε SMTP Server",
        "smtpPort": "Θύρα SMTP",
        "smtpPortPlaceholder": "Προσθέστε Θύρα SMTP",
        "emailSettings": "Ρυθμίσεις Email",
        "correspondentName": {
            "correspondentName": "Όνομα Αποστολέα",
            "required": "Προσθέστε Όνομα Αποστολέα"
        },
        "mailSubject": {
            "mailSubject": "Θέμα Αλληλογραφίας",
            "placeholder": "Προσθέστε Θέμα αλληλογραφίας"
        },
        "addWildcard": "Προσθέστε Μεταβλητές",
        "wildcards": "Μεταβλητές -",
        "message2": "Κάντε κλικ στις μεταβλητές για προσθήκη στο Θέμα Αλληλογραφίας.",
        "testSMTPConnection": "Δοκιμάστε τη σύνδεση SMTP"
    },
    "SettingsImportExport" : {
        "section" : "Κατηγορία",
        "sectionProducts" : "Είδη",
        "sectionProductMovements": "Κινήσεις Ειδών",
        "sectionClients" : "Πελάτες",
        "sectionClientPayments" : "Εισπράξεις",
        "sectionClientMovements" : "Κινήσεις Πελατών",
        "sectionSupplierMovements" : "Κινήσεις Προμηθευτών",
        "sectionSales" : "Πωλήσεις",
        "sectionPOS" : "POS",
        "sectionCashRegisters" : "Ταμειακές Μηχανές",
        "sectionBankAccounts" : "Τραπεζικοί Λογαριασμοί",
        "sectionSuppliers" : "Προμηθευτές",
        "sectionEmployees" : "Εργαζομένοι",
        "sectionAccountingAccounts" : "Λογιστικοί Λογαριασμοί",
        "sectionAccountingRecords" : "Λογιστικές Εγγραφές",
        "sectionFixedAssets": "Πάγια",
        "sectionFixedAssetMovements": "Κινήσεις Παγίων",
        "help" : "Βοήθεια",
        "no" : "Αρ.",
        "fieldName" : "Όνομα Πεδίου",
        "excelColumn" : "Στήλη Excel",
        "mandatoryFields" : "Τα πεδία με * είναι υποχρεωτικά",
        "results" : "Αποτελέσματα",
        "startImport" : "Εκκίνηση Εισαγωγής",
        "startExport" : "Εκκίνηση Εξαγωγής",
        "autocomplete": "Συμπλήρωση Στηλών",
        "Products" : {
            "name" : "Όνομα είδους",
            "alternativeName" : "Εναλλακτικό Όνομα",
            "category" : "Κατηγορία",
            "alternativeCode" : "Εναλλακτικός Κωδικός",
            "barCode" : "Barcode",
            "vat" : "Φ.Π.Α. %",
            "measurementUnit" : "Μονάδα Μέτρησης",
            "vatReason" : "Κατηγορία Εξαίρεσης Φ.Π.Α.",
            "price" : "Τιμή",
            "buyPrice" : "Τιμή Αγοράς",
            "vatIncluded" : "Περιλαμβάνεται Φ.Π.Α.",
            "vatIncludedBuy" : "Περιλαμβάνεται Φ.Π.Α. Για Αγορά",
            "productNotes" : "Σημειώσεις",
            "feeTax" : "Τέλη",
            "otherTax" : "Άλλοι Φόροι",
            "withholdTax" : "Παρακρατούμενοι Φόροι",
            "stampDutyTax" : "Χαρτόσημο (Ψηφ. τέλος συν.)",
            "myDataIncExp" : "My Data Έσοδο/Έξοδο",
            "myDataRowType" : "Τύπος My Data",
            "myDataRowCategory" : "Κατηγορία My Data",
            "myDataRowInvoiceType" : "Τύπος Παραστατικού My Data",
            "myDataRowVatExpenseType": "Τύπος Εξόδων Φ.Π.Α. My Data",
            "accountingCode": "Πρόθεμα Κωδικού Λογαριασμού",
            "netAmountAccountingCode": "Κωδικός Παράκαμψης Καθαρής Αξίας",
            "vatAccountingCode": "Κωδικός Παράκαμψης Φ.Π.Α.",
            "taxAccountCode": "Κωδικός Παράκαμψης Φόρου",
            "accountingNonDeductibleVAT": "Μη Εκπιπτόμενος Φ.Π.Α.",
            "accountingCodeSales": "Πρόθεμα Κωδικού Λογαριασμού για Πωλήσεις",
            "netAmountAccountingCodeSales": "Κωδικός Παράκαμψης Καθαρής Αξίας για Πωλήσεις",
            "vatAccountingCodeSales": "Κωδικός Παράκαμψης Φ.Π.Α. για Πωλήσεις",
            "taxAccountCodeSales": "Κωδικός Παράκαμψης Φόρου για Πωλήσεις",
            "accountingCodeBuys": "Πρόθεμα Κωδικού Λογαριασμού για Αγορές",
            "netAmountAccountingCodeBuys": "Κωδικός Παράκαμψης Καθαρής Αξίας για Αγορές",
            "vatAccountingCodeBuys": "Κωδικός Παράκαμψης Φ.Π.Α. για Αγορές",
            "taxAccountCodeBuys": "Κωδικός Παράκαμψης Φόρου για Αγορές",
            "cpvCode": "Κωδικός CPV",
            "showAlternativeNameOnPrint": "Προβολή εναλλακτικού ονόματος στα παραστατικά",
            "showAlternativeCodeOnPrint": "Προβολή εναλλακτικού κωδικού στα παραστατικά"
        },
        "Clients" : {
            "name" : "Όνομα Πελάτη",
            "smallName" : "Μικρό Όνομα",
            "manualCode" : "Χειροκίνητος Κωδικός",
            "category" : "Κατηγορία",
            "vatNumber" : "Α.Φ.Μ.",
            "vatCategory" : "Κατηγορία Φ.Π.Α.",
            "vatReason" : "Κατηγορία Εξαίρεσης Φ.Π.Α.",
            "country" : "Χώρα",
            "city" : "Πόλη",
            "address" : "Διεύθυνση",
            "postalCode" : "Ταχυδρομικός Κώδικας",
            "DOY" : "ΔΟΥ",
            "activity" : "Δραστηριότητα",
            "GEMH" : "ΓΕΜΗ",
            "webpage" : "Ιστοσελίδα",
            "email" : "Ηλεκτρονική Διεύθυνση",
            "phone" : "Τηλέφωνο",
            "amka" : "ΑΜΚΑ",
            "clientNotes" : "Σημειώσεις Πελάτη",
            "contactName" : "Όνομα Επαφής",
            "contactPhone" : "Κινητό Τηλέφωνο Επαφής",
            "contactPhone2" : "Άλλο Τηλέφωνο Επαφής",
            "contactLandline" : "Σταθερό Τηλέφωνο Επαφής",
            "contactEmail" : "Ηλεκτρονική Διεύθυνση Επαφής",
            "contactNotes" : "Σημειώσεις Επικοινωνίας Επαφής",
            "contactAcceptNotifications" : "Αποδοχή Ειδοποιήσεων Επαφής",
            "installationNo" : "Αριθμός Εγκατάστασης",
            "installationAddress" : "Διεύθυνση Εγκατάστασης",
            "installationDOY" : "ΔΟΥ Εγκατάστασης",
            "installationCity" : "Πόλη Εγκατάστασης",
            "installationPostalCode" : "Ταχυδρομικός Κώδικας Εγκατάστασης",
            "installationVatCategory" : "Κατηγορία Φ.Π.Α. Εγκατάστασης",
            "installationVatReason" : "Κατηγορία Εξαίρεσης Φ.Π.Α. Εγκατάστασης",
            "installationCustomVat" : "Προσαρμοσμένο Φ.Π.Α. 0% Εγκατάστασης",
            "accounting": "Πρόθεμα Λογιστικής Γέφυρας",
            "bypassAccounting": "Κωδικός Παράκαμψης Λογιστικής Γέφυρας"
        },
        "Client Movements" : {
            "documentTypeName" : "Τύπος Παραστατικού",
            "installationMasterID" : "Αριθμός Εγκατάστασης",
            "serialNumber" : "Σειρά",
            "number" : "Αριθμός",
            "date" : "Ημερομηνία",
            "reason" : "Αιτιολογία",
            "clientVATNumber" : "Α.Φ.Μ. Πελάτη",
            "clientMovementAmount" : "Ποσό",
            "notes" : "Σημειώσεις",
            "clientPhone" : "Τηλέφωνο Πελάτη",
            "clientEmail" : "Ηλεκτρονική Διεύθυνση Πελάτη",
            "clientAMKA" : "ΑΜΚΑ Πελάτη"
        },
        "Supplier Movements" : {
            "documentTypeName" : "Τύπος Παραστατικού",
            "installationMasterID" : "Αριθμός Εγκατάστασης",
            "serialNumber" : "Σειρά",
            "number" : "Αριθμός",
            "date" : "Ημερομηνία",
            "reason" : "Αιτιολογία",
            "supplierVATNumber" : "Α.Φ.Μ. Προμηθευτή",
            "supplierMovementAmount" : "Ποσό",
            "notes" : "Σημειώσεις",
            "supplierPhone" : "Τηλέφωνο Προμηθευτή",
            "supplierEmail" : "Ηλεκτρονική Διεύθυνση Προμηθευτή",
            "supplierAMKA" : "ΑΜΚΑ Προμηθευτή"
        },
        "Client Payments" : {
            "documentTypeName" : "Τύπος Παραστατικού",
            "installation" : "Αριθμός Εγκατάστασης",
            "serialNumber" : "Σειρά",
            "number" : "Αριθμός",
            "vatNumber" : "Α.Φ.Μ. Πελάτη",
            "paymentDate" : "Ημερομηνία Είσπραξης",
            "paymentReason" : "Αιτιολογία",
            "paymentNotes" : "Σημειώσεις Είσπραξης",
            "paymentType" : "Τρόπος Πληρωμής",
            "bankNumber" : "Τραπεζικός Λογαριασμός",
            "posSerial" : "Σειριακός Αριθμός POS",
            "amount" : "Ποσό Πληρωμής",
            "chequeFirstDate" : "Ημερομηνία Έναρξης Επιταγής",
            "chequeLastDate" : "Ημερομηνία Λήξης Επιταγής",
            "clientPhone" : "Τηλέφωνο Πελάτη",
            "clientEmail" : "Ηλεκτρονική Διεύθυνση Πελάτη",
            "clientAMKA" : "ΑΜΚΑ Πελάτη",
            "clientName" : "Όνομα Πελάτη"
        },
        "Sales" : {
            "documentTypeName" : "Τύπος Παραστατικού",
            "date" : "Ημερομηνία πώλησης",
            "time" : "Ώρα πώλησης",
            "installationMasterID" : "Αριθμός Εγκατάστασης",
            "serialNumber" : "Σειρά",
            "number" : "Αριθμός",
            "clientVATNumber" : "Α.Φ.Μ. Πελάτη",
            "clientPhone" : "Τηλέφωνο Πελάτη",
            "clientEmail" : "Ηλεκτρονική Διεύθυνση Πελάτη",
            "clientAMKA" : "ΑΜΚΑ Πελάτη",
            "clientInstallation" : "Αριθμός Εγκατάστασης Πελάτη",
            "paymentType" : "Τρόπος Πληρωμής",
            "bankNumber" : "Τραπεζικός Λογαριασμός",
            "posSerial" : "Σειριακός αριθμός POS",
            "productName" : "Όνομα Είδους",
            "quantity" : "Ποσότητα",
            "unitPrice" : "Τιμή Μονάδας",
            "discount" : "Έκπτωση",
            "netValue" : "Καθαρή Αξία",
            "vat" : "Αξία Φ.Π.Α.",
            "vatPercentage" : "Ποσοστό Φ.Π.Α.",
            "vatReason" : "Κατηγορία Εξαίρεσης Φ.Π.Α.",
            "totalValue" : "Συνολική Αξία με Φ.Π.Α.",
            "isTaxLine" : "Είναι γραμμή φόρος",
            "productExtraTaxType" : "Τύπος Επιπλέον Φόρου Είδους",
            "productExtraTaxCode" : "Κωδικός Επιπλέον Φόρου Είδους",
            "productExtraTaxAmount" : "Ποσό Επιπλέον Φόρου Είδους",
            "salePurpose": "Σκοπός Διακίνησης",
            "deliveryLocation" : "Τοποθεσία Παράδοσης",
            "deliveryLocationAddress" : "Διεύθυνση Τοποθεσίας",
            "deliveryLocationCity" : "Πόλη τοποθεσίας",
            "deliveryLocationCountry" : "Χώρα τοποθεσίας",
            "deliveryLocationPostalCode" : "Ταχυδρομικός Κωδικός Τοποθεσίας",
            "myDataUID" : "My Data UID",
            "myDataMark" : "My Data Mark",
            "myDataAuthCode" : "My Data Auth Code",
            "extraDataTaxType" : "Τύπος Επιπλέον Φόρου",
            "extraDataTaxCode" : "Κωδικός Επιπλέον Φόρου",
            "extraDataTaxAmount" : "Πόσο Επιπλέον Φόρου",
            "mutedBasicData" : "Βασικά στοιχεία παραστατικού",
            "mutedBasicDataLine" : "Στοιχεία γραμμής παραστατικού",
            "mutedMyData" : "Στοιχεία My Data",
            "mutedExtraData" : "Επιπλέον Δεδομένα - Φόροι παραστατικού",
            "wayOfSendingGoods" : "Τρόπος Αποστολής εμπορευμάτων",
            "carNumber" : "Αριθμός Αυτοκινήτου",
            "otherCorrelatedEntitiesTypes": "Τύποι Λοιπών Συσχετιζόμενων Οντοτήτων",
            "otherCorrelatedEntitiesVatNumbers": "ΑΦΜ Λοιπών Συσχετιζόμενων Οντοτήτων"
        },
        "Employees": {
            firstName: "Όνομα",
            lastName: "Επώνυμο",
            sex: "Φύλο",
            birthDate: "Ημερομηνία Γέννησης",
            vatNumber: "ΑΦΜ",
            fatherFirstName: "Όνομα Πατέρα",
            fatherLastName: "Επώνυμο Πατέρα",
            motherFirstName: "Όνομα Μητέρας",
            motherLastName: "Επώνυμο Μητέρας",
            phone: "Τηλέφωνο",
            email: "E-Mail",
            amka: "ΑΜΚΑ",
            amika: "ΑΜΙΚΑ",
            ama: "ΑΜΑ",
            employeeCategory: "Κατηγορία Εργαζομένου",
            employeeType: "Τύπος Εργαζομένου",
            specialty: "Ειδικότητα",
            installation: "Εγκατάσταση",
            workingDaysPerWeek: "Εβδομαδιαίες Ημέρες Εργασίας",
            workingHoursPerWeek: "Εβδομαδιαίες Ώρες Εργασίας",
            symbatikesWorkingHoursPerWeek: "Συμβατικές Ώρες Εργασίας ανά Εβδομάδα",
            workingExperienceYears: "Έτη Προϋπηρεσίας",
            firstYearPermits: "Άδειες Πρώτου Έτους",
            breakMinutes: "Λεπτά Διαλείμματος",
            breakMinutesWhen: "Διάλλειμα εντός/εκτός",
            kathestos: "Καθεστώς",
            employmentDate: "Ημερομηνία Πρόσληψης",
            salary: "Μισθός",
            erganiCard: "Κάρτα ΕΡΓΑΝΗ",
            flexibleAttendanceMinutes: "Λεπτά Ευέλικτης Προσέλευσης",
            resignationDate: "Ημερομηνία Αποχώρησης",
            resignationCause: "Αιτία Αποχώρησης",
            notes: "Σημειώσεις",
        },
        "POS" : {
            "name" : "Όνομα",
            "date" : "Ημερομηνία",
            "serialNumber" : "Σειριακός Κωδικός",
            "sendToAADE" : "Αποστολή στην ΑΑΔΕ",
            "notes" : "Σημειώσεις"
        },
        "Cash Registers" : {
            "name" : "Όνομα",
            "date" : "Ημερομηνία",
            "serialNumber" : "Σειριακός Κωδικός",
            "sendToAADE" : "Αποστολή στην ΑΑΔΕ",
            "notes" : "Σημειώσεις"
        },
        "Bank Accounts" : {
            "name" : "Όνομα",
            "bankSwift" : "Swift Τράπεζας",
            "date" : "Ημερομηνία",
            "iban" : "IBAN",
            "sendToAADE" : "Αποστολή στην ΑΑΔΕ",
            "notes" : "Σημειώσεις"
        },
        "Suppliers" : {
            "name" : "Όνομα Προμηθευτή",
            "smallName" : "Μικρό Όνομα",
            "manualCode" : "Χειροκίνητος Κωδικός",
            "category" : "Κατηγορία",
            "vatNumber" : "Α.Φ.Μ.",
            "vatCategory" : "Κατηγορία Φ.Π.Α.",
            "vatReason" : "Κατηγορία Εξαίρεσης Φ.Π.Α.",
            "country" : "Χώρα",
            "city" : "Πόλη",
            "address" : "Διεύθυνση",
            "postalCode" : "Ταχυδρομικός Κώδικας",
            "DOY" : "ΔΟΥ",
            "activity" : "Δραστηριότητα",
            "GEMH" : "ΓΕΜΗ",
            "webpage" : "Ιστοσελίδα",
            "email" : "Ηλεκτρονική Διεύθυνση",
            "phone" : "Τηλέφωνο",
            "amka" : "ΑΜΚΑ",
            "notes" : "Σημειώσεις Προμηθευτή",
            "contactName" : "Όνομα Επαφής",
            "contactPhone" : "Κινητό Τηλέφωνο Επαφής",
            "contactPhone2" : "Άλλο Τηλέφωνο Επαφής",
            "contactLandline" : "Σταθερό Τηλέφωνο Επαφής",
            "contactEmail" : "Ηλεκτρονική Διεύθυνση Επαφής",
            "contactNotes" : "Σημειώσεις Επικοινωνίας Επαφής",
            "contactAcceptNotifications" : "Αποδοχή Ειδοποιήσεων Επαφής",
            "installationNo" : "Αριθμός Εγκατάστασης",
            "installationAddress" : "Διεύθυνση Εγκατάστασης",
            "installationDOY" : "ΔΟΥ Εγκατάστασης",
            "installationCity" : "Πόλη Εγκατάστασης",
            "installationPostalCode" : "Ταχυδρομικός Κώδικας Εγκατάστασης",
            "installationVatCategory" : "Κατηγορία Φ.Π.Α. Εγκατάστασης",
            "installationVatReason" : "Κατηγορία Εξαίρεσης Φ.Π.Α. Εγκατάστασης",
            "installationCustomVat" : "Προσαρμοσμένο Φ.Π.Α. 0% Εγκατάστασης",
            "accounting": "Πρόθεμα Λογιστικής Γέφυρας",
            "bypassAccounting": "Κωδικός Παράκαμψης Λογιστικής Γέφυρας"
        },
        "Accounting Accounts" : {
            "category" : "Πρότυπο Λογαριασμού",
            "code" : "Κωδικός Λογαριασμού",
            "name" : "Όνομα Λογαριασμού",
            "alternativeName" : "Εναλλακτικό Όνομα",
            "movable" : "Κινείται",
            "transferable" : "Μεταφέρεται",
            "isNetValue" : "Καθαρή Αξία %",
            "vat" : "ΦΠΑ %",
            "taxType" : "Είναι Φόρος",
            "subAccount" : "Υποκατηγορία",
            "mutedCaseTax" : "Σε περίπτωση επιλογής φόρου",
            "fee" : "Κωδικός Τέλους",
            "stamp" : "Κωδικός Χαρτοσήμου",
            "withHoldTax" : "Κωδικός Παρακρατούμενου Φόρου",
            "otherTax" : "Κωδικός Λοιπών Φόρων"
        },
        "Product Movements": {
            "documentTypeName": "Γενικό Παραστατικό",
            "installationMasterID": "Αρ. Εγκατάστασης",
            "preNumber": "Σειρά",
            "number": "Αρίθμηση",
            "date": "Ημερομηνία",
            "reason": "Αιτία",
            "productName": "Όνομα Είδους",
            "productUnitPrice": "Τιμή Μονάδος",
            "productQuantity": "Ποσότητα",
            "notes": "Σημειώσεις"
        },
        "Fixed Assets": {
            "category": "Κατηγορία",
            "name": "Όνομα",
            "quantity": "Ποσότητα",
            "date": "Ημερομηνία κτήσης",
            "manualCode": "Χειροκίνητος Κωδικός",
            "acquisitionCost": "Κόστος κτήσης",
            "percentage": "Ετήσιο % απόσβεσης",
            "accounting": "Πρόθεμα Λογιστικής Γέφυρας",
            "bypassAccounting": "Κωδικός Παράκαμψης Λογ. Γέφυρας",
            "installation": "Αρ. Εγκατάστασης",
            "inverseAccounting": "Πρόθεμα Αντισυμβαλλόμενου Κωδικού Λογιστικής",
            "bypassInverseAccounting": "Αντισυμβαλλόμενος Κωδικός Παράκαμψης Λογιστικής Γέφυρας",
            "accountingCodeSales": "Πρόθεμα Κωδικού Λογαριασμού για Πωλήσεις",
            "netAmountAccountingCodeSales": "Κωδικός Παράκαμψης Καθαρής Αξίας για Πωλήσεις",
            "vatAccountingCodeSales": "Κωδικός Παράκαμψης Φ.Π.Α. για Πωλήσεις",
            "taxAccountCodeSales": "Κωδικός Παράκαμψης Φόρου για Πωλήσεις",
            "accountingCodeBuys": "Πρόθεμα Κωδικού Λογαριασμού για Αγορές",
            "netAmountAccountingCodeBuys": "Κωδικός Παράκαμψης Καθαρής Αξίας για Αγορές",
            "vatAccountingCodeBuys": "Κωδικός Παράκαμψης Φ.Π.Α. για Αγορές",
            "taxAccountCodeBuys": "Κωδικός Παράκαμψης Φόρου για Αγορές"
        },
        "Fixed Asset Movements": {
            "documentTypeName": "Γενικό Παραστατικό",
            "date": "Ημερομηνία",
            "installation": "Αριθμός Εγκατάστασης",
            "preNumber": "Σειρά",
            "number": "Αρίθμηση",
            "reason": "Αιτιολογία",
            "fixedAsset": "Όνομα παγίου",
            "amount": "Ποσό απόσβεσης",
            "notes": "Σημειώσεις"
        },
        "Accounting Records": {
            "categoryName": "Κατηγορία",
            "subCategoryName": "Υποκατηγορία",
            "documentTypeName": "Γενικό Παραστατικό",
            "date": "Ημερομηνία",
            "time": "Ώρα",
            "installation": "Εγκατάσταση",
            "preNumber": "Σειρά",
            "number": "Αρίθμηση",
            "reason": "Αιτιολογία",
            "paymentTypeName": "Τρόπος Πληρωμής",
            "accountCode": "Κωδικός Λογαριασμού",
            "subAccount": "Υπολογαριασμός",
            "debit": "Ποσό Χρέωσης",
            "credit": "Ποσό Πίστωσης"
        },
        "chooseFile" : "Επιλογή Αρχείου",
        "firstLine" : "Πρώτη Γραμμή δεδομένων στο Excel",
        "insertNewRecords" : "Να γίνει εισαγωγή νέων δεδομένων",
        "updateExistingRecords" : "Να γίνει ενημέρωση δεδομένων",
        "back" : "Πίσω",
        "checkData" : "Έλεγχος Δεδομένων",
        "insertData" : "Εισαγωγή Δεδομένων",
        "textInstead" : "Κείμενο αντί κωδικών (*)",
        "textOnlyDanger" : "(*) Επιλέγοντας την παραπάνω επιλογή, μερικές στήλες θα εξαχθούν ως κείμενο για να είναι ευανάγνωστο από τον χρήστη με αποτέλεσμα να μην είναι διαθέσιμο για εισαγωγή.",
        "export" : "Εξαγωγή",
        "joyride" : {
            "back" : "Πίσω",
            "close" : "Κλείσιμο",
            "last" : "Εντάξει",
            "next" : "Επόμενο",
            "open" : "Άνοιγμα",
            "skip" : "Παράλειψη",
            "section" : "Επιλέξτε την κατηγορία που θέλετε να εισάγετε.",
            "fields" : "Τα πεδία που είναι με κόκκινο αστερίσκο είναι υποχρεωτικά.",
            "columns" : "Εδώ επιλέγετε την στήλη που υπάρχει αντίστοιχα στο αρχείο Excel σας.",
            "tooltips" : "Κουμπιά σαν αυτό, εμφανίζουν ένα παράθυρο με τυχόν διευκρινήσεις που χρειάζονται.",
            "file" : "Επιλέγετε το αρχείο Excel (XLS ή XLSX) από τον υπολογιστή σας.",
            "firstLine" : "Εκχωρείτε την πρώτη γραμμή που υπάρχουν δεδομένα.",
            "insertNew" : "Επιλέγετε αυτήν την επιλογή αν θέλετε να εισάγετε νέα δεδομένα που εντοπίζονται στο Excel σας.",
            "updateExisting" : "Επιλέγετε αυτήν την επιλογή αν θέλετε να ενημερώσετε τα δεδομένα που υπάρχουν στο ERP με αυτά που ταυτίζονται στο Excel σας.",
            "checkData" : "Πρωτού ξεκινήσει η εισαγωγή, πρέπει να κάνετε έλεγχο έτσι ώστε να δείτε τυχόν προβλήματα που παρουσιάζονται στο Excel σας.",
            "insertData" : "Σε περίπτωση που έχετε τουλάχιστον μία σωστή γραμμή στο Excel, ενεργοποιείται το κουμπί της εισαγωγής. Εισαγωγή θα γίνουν ΜΟΝΟ οι γραμμές που είναι σωστές με βάση τον προηγούμενο έλεγχο.",
            "columnsExport" : "Εδώ επιλέγετε την στήλη που θέλετε να εξαχθεί το αντίστοιχο πεδίο.",
            "tooltipsExport" : "Κουμπιά σαν αυτό, εμφανίζουν ένα παράθυρο με τυχόν διευκρινήσεις που χρειάζονται.",
            "textInstead" : "Επιλέγοντας αυτήν την επιλογή, μερικές στήλες θα εξαχθούν ως κείμενο για να είναι ευανάγνωστο από τον χρήστη με αποτέλεσμα να μην είναι διαθέσιμο για εισαγωγή.",
            "exportButton" : "Πατώντας το κουμπί εξαγωγή, θα προετοιμαστεί από το σύστημα ένα αρχείο Excel (.XLSX) με βάση τις προηγούμενες επιλογές σας και κατόπιν θα γίνει λήψη στον υπολογιστή σας.",
            "backButton" : "Οποιαδήποτε στιγμή μπορείτε να επιστρέψετε πίσω στα πεδία/στήλες πατώντας αυτό το κουμπί."
        },
        "toasts" : {
            "alreadySelectedColumn" : "Αυτή η στήλη είναι ήδη επιλεγμένη σε άλλη γραμμή",
            "pleaseSelectColumnFor" : "Παρακαλώ, επιλέξτε στήλη για το πεδίο",
            "someExcelColumnsAreEmpty" : "Κάποιες στήλες είναι άδειες",
            "pleaseSelectAFileFirst" : "Παρακαλώ επιλέξτε αρχείο πρώτα",
            "onlyXLSXValid" : "Μόνο αρχεία τύπου XLS και XLSX είναι διαθέσιμα",
            "firstLineIsEmpty" : "Το πεδίο πρώτη γραμμή δεν μπορεί να είναι άδειο",
            "pleaseCheckData" : "Παρακαλώ κάντε έλεγχο δεδομένων πρώτα",
            "atLeastOneCheckbox": "Τουλάχιστον μία από τις δύο επιλογές πρέπει να είναι επιλεγμένη",
            "selectionEmpty" : "Παρακαλώ επιλέξτε κατηγορία πρώτα",
            "myDataCheck" : "Πρέπει να έχετε επιλέξει το My Data Mark και My Data UID",
            "deliveryLocationCheck" : "Πρέπει να έχετε επιλέξει την Τοποθεσία Παράδοσης."
        }
    },
    "SettingsBackup" : {
        "buttonBackup" : "Δημιουργία αντιγράφου ασφαλείας",
        "buttonCompanyTemplate" : "Δημιουργία εταιρικού προτύπου",
        "creatingBackup" : "Δημιουργία αντιγράφου ασφαλείας...",
        "creatingBackupToast" : "Γίνεται δημιουργία αντιγράφου ασφαλείας, παρακαλώ περιμένετε.",
        "backupCreated" : "Το αντίγραφο ασφαλείας δημιουργήθηκε.",
        "backupCreatedToast" : "Το αντίγραφο ασφαλείας δημιουργήθηκε.",
        "creatingCompanyTemplate" : "Γίνεται δημιουργία του εταιρικού προτύπου...",
        "creatingCompanyTemplateToast" : "Γίνεται δημιουργία του εταιρικού προτύπου, παρακαλώ περιμένετε.",
        "companyTemplateCreated" : "Το εταιρικό πρότυπο δημιουργήθηκε.",
        "companyTemplateCreatedToast" : "Το εταιρικό πρότυπο δημιουργήθηκε."
    },
    "SettingsRestore" : {
        "restoring" : "Γίνεται επαναφορά...",
        "pleaseSelectFile" : "Παρακαλώ επιλέξτε αρχείο πρώτα",
        "onlyJSONFiles" : "Μόνο αρχεία τύπου JSON είναι αποδεκτά",
        "restorationComplete" : "Η επαναφορά ολοκληρώθηκε επιτυχώς.",
        "restorationFailed" : "Η επαναφορά απέτυχε!",
        "warningMessage" : "Η επαναφορά από αντίγραφο ασφαλείας πρέπει να γίνει με αντίγραφο ασφαλείας που έχει δημιουργηθεί από την παρούσα εταιρεία. Σε κάθε άλλη περίπτωση θα δημιουργηθεί πρόβλημα και στις 2 εταιρείες. Η επαναφορά από εταιρικό πρότυπο μπορεί να γίνει και από άλλη εταιρεία.",
        "warningMessage2" : "ΓΙΓΑΝΤΙΑ προσοχή στο κουμπί επαναφοράς που θα πατήσετε. Αν είναι από backup, πατήστε επαναφορά backup, αλλιώς επαναφορά εταιρικού προτύπου. Και οι δύο επαναφορές, διαγράφουν όλα τα δεδομένα.",
        "buttonRestoreBackup" : "Επαναφορά από αντίγραφο ασφαλείας",
        "buttonRestoreCompanyTemplate" : "Επαναφορά Εταιρικού Προτύπου"
    },
    "basicModal": {
        "close" : "Κλείσιμο",
        "ok" : "ΟΚ"
    },
    "searchSideTable": {
        "cancel": "Ακύρωση",
        "save": "Αποθήκευση",
        "currentValue": "Τρέχουσα Τιμή:",
        "sent": "Στάλθηκε (Ενεργό)",
        "notSent": "Δεν εστάλη (Μη Ενεργό)",
        "enterNew": ""
    },
    "ClosingTabWarning": {
        "warning": "Προσοχή!",
        "message": "Προσοχή: Τα μη αποθηκευμένα δεδομένα θα χαθούν, θέλετε να συνεχίσετε;",
        "no": "Όχι",
        "yes": "Ναι"
    },
    "dateFilterColumn": {
        "thisMonth": "Αυτόν τον μήνα",
        "lastMonth": "Τον προηγούμενο μήνα",
        "thisYear": "Αυτή την χρονιά",
        "custom": "Προσαρμοσμένο",
        "noRecordsFound": "Δεν βρέθηκαν καταγραφές.",
        "filter": "Φίλτρο..."
    },
    "insertPlaceholders": {
        "insert": "Εισαγωγή",
        "insertCategory": "Εισαγωγή Κατηγορίας",
        "insertCodeMask": "Εισαγωγή Προθέματος",
        "insertName": "Εισαγωγή Ονόματος",
        "add": "Εισάγετε ",
        "select": "Επιλέξτε...",
        "required": "Απαιτείται."
    },
    "AdvanceTypesNewDropDown": {
        "null": "Μηδενικό/Κενό",
        "productMovements": "Κινήσεις Ειδών",
        "sales": "Πωλήσεις",
        "clientMovements": "Κινήσεις Πελατών",
        "clientPayments": "Εισπράξεις Πελατών",
        "buys": "Αγορές",
        "supplierPayments": "Πληρωμές Προμηθευτών",
        "accountingRecords": "Λογιστικά Άρθρα",
        "fixedAssetRecords": "Αποσβέσεις Παγίων",
        "fixedAssetMovements": "Κινήσεις Παγίων"
    },
    "EmployeeTabs": {
        "New": "Γενικά",
        "Edit": "Γενικά",
        "Search": "Αναζήτηση"
    },
    "AccountingAccountTabs": {
        "New": "Γενικά",
        "NewMyData" : "MyData",
        "EditMyData" : "MyData",
        "Edit": "Γενικά",
        "Search": "Αναζήτηση"
    },
    "AccountingRecordTabs": {
        "New": "Γενικά",
        "Commercial" : "Εγγραφή από Εμπορικό",
        "Edit": "Γενικά",
        "Search": "Αναζήτηση"
    },
    "Logs": {
        "product_create": "Δημιουργία Είδους",
        "product_update": "Ενημέρωση Είδους",
        "product_delete": "Διαγραφή Είδους",
        "productMovement_create": "Δημιουργία Κίνησης Είδους",
        "productMovement_update": "Ενημέρωση Κίνησης Είδους",
        "productMovement_delete": "Διαγραφή Κίνησης Είδους",
        "productPrice_create": "Δημιουργία Τιμοκαταλόγου",
        "productPrice_update": "Ενημέρωση Τιμοκαταλόγου",
        "productPrice_delete": "Διαγραφή Τιμοκαταλόγου",
        "sale_create": "Δημιουργία Πώλησης",
        "sale_update": "Ενημέρωση Πώλησης",
        "sale_delete": "Διαγραφή Πώλησης",
        "sale_sendMyData": "Αποστολή myData",
        "sale_sendMyDataProvider": "Αποστολή myData (Πάροχος)",
        "buy_create": "Δημιουργία Αγοράς",
        "buy_update": "Ενημέρωση Αγοράς",
        "buy_delete": "Διαγραφή Αγοράς",
        "buy_sendMyData": "Αποστολή myData",
        "client_create": "Δημιουργία Πελάτη",
        "client_update": "Ενημέρωση Πελάτη",
        "client_delete": "Διαγραφή Πελάτη",
        "clientPayment_create": "Δημιουργία Είσπραξης",
        "clientPayment_update": "Ενημέρωση Είσπραξης",
        "clientPayment_delete": "Διαγραφή Είσπραξης",
        "clientMovement_create": "Δημιουργία Κίνησης Πελάτη",
        "clientMovement_update": "Ενημέρωση Κίνησης Πελάτη",
        "clientMovement_delete": "Διαγραφή Κίνησης Πελάτη",
        "supplier_create": "Δημιουργία Κίνησης Προμηθευτή",
        "supplier_update": "Ενημέρωση Κίνησης Προμηθευτή",
        "supplier_delete": "Διαγραφή Κίνησης Προμηθευτή",
        "supplierPayment_create": "Δημιουργία Πληρωμής",
        "supplierPayment_update": "Ενημέρωση Πληρωμής",
        "supplierPayment_delete": "Διαγραφή Πληρωμής",
        "supplierMovement_create": "Δημιουργία Κίνησης Προμηθευτή",
        "supplierMovement_update": "Ενημέρωση Κίνησης Προμηθευτή",
        "supplierMovement_delete": "Διαγραφή Κίνησης Προμηθευτή",
        "employee_create": "Δημιουργία Εργαζομένου",
        "employee_update": "Ενημέρωση Εργαζομένου",
        "employee_delete": "Διαγραφή Εργαζομένου",
        "workPermit_create": "Δημιουργία Άδειας Εργασίας",
        "workPermit_update": "Ενημέρωση Άδειας Εργασίας",
        "workPermit_delete": "Διαγραφή Άδειας Εργασίας",
        "workMovement_create": "Δημιουργία Κίνησης Εργασίας",
        "workMovement_update": "Ενημέρωση Κίνησης Εργασίας",
        "workMovement_delete": "Διαγραφή Κίνησης Εργασίας",
        "cash_create": "Δημιουργία Ταμειακής",
        "cash_update": "Ενημέρωση Ταμειακής",
        "cash_delete": "Διαγραφή Ταμειακής",
        "bank_create": "Δημιουργία Τραπεζικού Λογαριασμού",
        "bank_update": "Ενημέρωση Τραπεζικού Λογαριασμού",
        "bank_delete": "Διαγραφή Τραπεζικού Λογαριασμού",
        "pos_create": "Δημιουργία POS",
        "pos_update": "Ενημέρωση POS",
        "pos_delete": "Διαγραφή POS",
        "account_create": "Δημιουργία Λογιστικού Λογαριασμού",
        "account_update": "Ενημέρωση Λογιστικού Λογαριασμού",
        "account_delete": "Διαγραφή Λογιστικού Λογαριασμού",
        "record_create": "Δημιουργία Λογιστικής Εγγραφής",
        "record_update": "Ενημέρωση Λογιστικής Εγγραφής",
        "record_delete": "Διαγραφή Λογιστικής Εγγραφής",
        "basicSetting_create": "Δημιουργία Βασικού Παραστατικού",
        "basicSetting_update": "Ενημέρωση Βασικού Παραστατικού",
        "basicSetting_delete": "Διαγραφή Βασικού Παραστατικού",
        "advancedSetting_create": "Δημιουργία Γενικού Παραστατικού",
        "advancedSetting_update": "Ενημέρωση Γενικού Παραστατικού",
        "advancedSetting_delete": "Διαγραφή Γενικού Παραστατικού",
        "productCategory_create": "Δημιουργία Κατηγορίας Ειδών",
        "productCategory_update": "Ενημέρωση Κατηγορίας Ειδών",
        "productCategory_delete": "Διαγραφή Κατηγορίας Ειδών",
        "quickRetailSalesSetting_update": "Ενημέρωση Ρυθμίσεων Cloud e-Ταμειακή",
        "clientSetting_create": "Δημιουργία Ρυθμίσεων Πελατών",
        "clientSetting_update": "Ενημέρωση Ρυθμίσεων Πελατών",
        "supplierSetting_create": "Δημιουργία Ρυθμίσεων Προμηθευτών",
        "supplierSetting_update": "Ενημέρωση Ρυθμίσεων Προμηθευτών",
        "cashSetting_create": "Δημιουργία ρυθμίσεων Ταμειακών",
        "cashSetting_update": "Ενημέρωση ρυθμίσεων Ταμειακών",
        "salesSetting_update": "Ενημέρωση ρυθμίσεων Πωλήσεων",
        "buysSetting_update": "Ενημέρωση Ρυθμίσεων Αγορών",
        "accountingSetting_create": "Δημιουργία Ρυθμίσεων Λογιστικής",
        "accountingSetting_update": "Ενημέρωση Ρυθμίσεων Λογιστικής",
        "payrollSetting_update": "Ενημέρωση Ρυθμίσεων Μισθοδοσίας",
        "file_export": "Εξαγωγή αρχείου",
        "dcl_create": "Δημιουργία Εγγραφής Ψηφιακού Πελατολογίου",
        "dcl_update": "Επεξεργασία Εγγραφής Ψηφιακού Πελατολογίου",
        "cancel_dcl": "Ακύρωση Εγγραφής Ψηφιακού Πελατολογίου",
        "fixed_asset_create": "Δημιουργία παγίου",
        "fixed_asset_update": "Επεξεργασία παγίου",
        "fixed_asset_delete": "Διαγραφή παγίου",
        "fixed_asset_movement_create": "Δημιουργία κίνησης παγίων",
        "fixed_asset_movement_update": "Επεξεργασία κίνησης παγίων",
        "fixed_asset_movement_delete": "Διαγραφής κίνησης παγίων",
        "fixed_asset_record_create": "Δημιουργία απόσβεσης",
        "fixed_asset_record_update": "Επεξεργασία απόσβεσης",
        "fixed_asset_record_delete": "Διαγραφή απόσβεσης",
        "cancel_document": "Ακύρωση παραστατικού στο myDATA",
        "ai_register": "Καταχώρηση με Primer AI",
        "ai_reprocess": "Αποστολή επανεπεξεργασίας σε Primer AI",
        "ai_decline": "Απόρριψη εγγράφου Primer AI",
        "yes": "Ναι",
        "no": "Όχι",
        "name": "Όνομα",
        "alternateName": "Εναλλακτικό Όνομα",
        "code": "Κωδικός",
        "alternateCode": "Εναλλακτικός Κωδικός",
        "vat": "ΦΠΑ%",
        "price": "Προτιμώμενη Τιμή",
        "vatIncluded": "Περιλαμβάνεται ΦΠΑ",
        "measurementUnit": "Μονάδα Μέτρησης",
        "categoryName": "Κατηγορία",
        "isActive": "Ενεργό",
        "showAlternativeNameOnPrint": "Εναλλακτικό Όνομα Στην Εκτύπωση",
        "showAlternativeCodeOnPrint": "Εναλλακτικός Κωδικός Στην Εκτύπωση",
        "cpvCode": "Κωδικός CPV",
        "clientLog": "Ιστορικό Πελάτη",
        "clientsLog": "Ιστορικό Πελατών",
        "supplierLog": "Ιστορικό Προμηθευτή",
        "suppliersLog": "Ιστορικό Προμηθευτών",
        "employeeLog": "Ιστορικό Εργαζομένου",
        "employeesLog": "Ιστορικό Εργαζομένων",
        "workPermitLog": "Ιστορικό Άδειας Εργασίας",
        "workPermitsLog": "Ιστορικό Αδειών Εργασίας",
        "workMovementLog": "Ιστορικό Κίνησης Εργασίας",
        "workMovementsLog": "Ιστορικό Κινήσεων Εργασίας",
        "payrollSettingsLog": "Ιστορικό Ρυθμίσεων Μισθοδοσίας",
        "priceListLog": "Ιστορικό Τιμοκαταλόγων",
        "productLog": "Ιστορικό Είδους",
        "productsLog": "Ιστορικό Ειδών",
        "productMovementLog": "Ιστορικό Κίνησης Είδους",
        "productMovementsLog": "Ιστορικό Κινήσεων Ειδών",
        "clientMovementLog": "Ιστορικό Κινήσεων Πελάτη",
        "clientMovementsLog": "Ιστορικό Κινήσεων Πελατών",
        "supplierMovementLog": "Ιστορικό Κινήσεων Προμηθευτή",
        "supplierMovementsLog": "Ιστορικό Κινήσεων Προμηθευτών",
        "salesLog": "Ιστορικό Πωλήσεων",
        "buyLog": "Ιστορικό Αγοράς",
        "buysLog": "Ιστορικό Αγορών",
        "posLog": "Ιστορικό POS",
        "bankAccountLog": "Ιστορικό Τραπεζικού Λογαριασμού",
        "bankAccountsLog": "Ιστορικό Τραπεζικών Λογαριασμών",
        "accountingAccountLog": "Ιστορικό Λογιστικού Λογαριασμού",
        "accountingAccountsLog": "Ιστορικό Λογιστικών Λογαριασμών",
        "accountingRecordLog": "Ιστορικό Λογιστικής Εγγραφής",
        "accountingRecordsLog": "Ιστορικό Λογιστικών Εγγραφών",
        "settingBasicLog": "Ιστορικό Βασικού παραστατικού",
        "settingsBasicLog": "Ιστορικό Βασικών παραστατικών",
        "settingAdvancedLog": "Ιστορικό Γενικού παραστατικού",
        "settingsAdvancedLog": "Ιστορικό Γενικών παραστατικών",
        "clientPaymentLog": "Ιστορικό Είσπραξης",
        "clientPaymentsLog": "Ιστορικό Εισπράξεων",
        "supplierPaymentLog": "Ιστορικό Πληρωμής",
        "supplierPaymentsLog": "Ιστορικό Πληρωμών",
        "saleLog": "Ιστορικό Πώλησης",
        "quotationLog": "Ιστορικό Προσφοράς",
        "productCategoryLog": "Ιστορικό Ρυθμίσεων Κατηγοριών",
        "salesGeneralSettingsLog": "Ιστορικό Ρυθμίσεων Πωλήσεων",
        "buysGeneralSettingsLog": "Ιστορικό Ρυθμίσεων Αγορών",
        "clientSettingsLog": "Ιστορικό Ρυθμίσεων Πελατών",
        "supplierSettingsLog": "Ιστορικό Ρυθμίσεων Προμηθευτών",
        "cashSettingsLog": "Ιστορικό Ρυθμίσεων Ταμειακών",
        "accountingSettingsLog": "Ιστορικό Ρυθμίσεων Λογιστικής",
        "importLog": "Ιστορικό Εισαγωγής Αρχείου",
        "bank_sync": "Ενημέρωση Συναλλαγών Μέσω Email"
    },
    Countries: {
        GR: "Ελλάδα",
        AD: "Ανδόρα",
        AE: "Ηνωμένα Αραβικά Εμιράτα",
        AF: "Αφγανιστάν",
        AG: "Αντίγκουα και Μπαρμπούντα",
        AI: "Ανγκουίλα",
        AL: "Αλβανία",
        AM: "Αρμενία",
        AN: "Ολλανδικές Αντίλλες",
        AO: "Ανγκόλα",
        AQ: "Ανταρκτική",
        AR: "Αργεντινή",
        AS: "Αμερικανική Σαμόα",
        AT: "Αυστρία",
        AU: "Αυστραλία",
        AW: "Αρούμπα",
        AX: "Νήσοι Όλαντ",
        AZ: "Αζερμπαϊτζάν",
        BA: "Βοσνία και Ερζεγοβίνη",
        BB: "Μπαρμπάντος",
        BD: "Μπαγκλαντές",
        BE: "Βέλγιο",
        BF: "Μπουρκίνα Φάσο",
        BG: "Βουλγαρία",
        BH: "Μπαχρέιν",
        BI: "Μπουρούντι",
        BJ: "Μπενίν",
        BL: "Άγιος Βαρθολομαίος",
        BM: "Βερμούδες",
        BN: "Μπρουνέι",
        BO: "Βολιβία",
        BR: "Βραζιλία",
        BS: "Μπαχάμες",
        BT: "Μπουτάν",
        BV: "Νήσος Μπουβέ",
        BW: "Μποτσουάνα",
        BY: "Λευκορωσία",
        BZ: "Μπελίζ",
        CA: "Καναδάς",
        CC: "Νήσοι Κόκος (Κίλινγκ)",
        CD: "Λαϊκή Δημοκρατία του Κονγκό",
        CF: "Κεντροαφρικανική Δημοκρατία",
        CG: "Κονγκό",
        CH: "Ελβετία",
        CI: "Ακτή Ελεφαντοστού",
        CK: "Νήσοι Κουκ",
        CL: "Χιλή",
        CM: "Καμερούν",
        CN: "Κίνα",
        CO: "Κολομβία",
        CR: "Κόστα Ρίκα",
        CU: "Κούβα",
        CV: "Πράσινο Ακρωτήριο",
        CX: "Νήσος των Χριστουγέννων",
        CY: "Κύπρος",
        CZ: "Τσεχία",
        DE: "Γερμανία",
        DJ: "Τζιμπουτί",
        DK: "Δανία",
        DM: "Δομινίκα",
        DO: "Δομινικανή Δημοκρατία",
        DZ: "Αλγερία",
        EC: "Ισημερινός",
        EE: "Εσθονία",
        EG: "Αίγυπτος",
        EH: "Δυτική Σαχάρα",
        ER: "Ερυθραία",
        ES: "Ισπανία",
        ET: "Αιθιοπία",
        FI: "Φινλανδία",
        FJ: "Φίτζι",
        FK: "Νήσοι Φώκλαντ",
        FM: "Ομόσπονδες Πολιτείες της Μικρονησίας",
        FO: "Νήσοι Φερόες",
        FR: "Γαλλία",
        GA: "Γκαμπόν",
        GB: "Ηνωμένο Βασίλειο",
        GD: "Γρενάδα",
        GE: "Γεωργία",
        GF: "Γαλλική Γουιάνα",
        GG: "Γκέρνσεϊ",
        GH: "Γκάνα",
        GI: "Γιβραλτάρ",
        GL: "Γροιλανδία",
        GM: "Γκάμπια",
        GN: "Γουινέα",
        GP: "Γουαδελούπη",
        GQ: "Ισημερινή Γουινέα",
        GS: "Νότια Γεωργία και Νότιες Νήσοι Σάντουιτς",
        GT: "Γουατεμάλα",
        GU: "Γκουάμ",
        GW: "Γουινέα-Μπισάου",
        GY: "Γουιάνα",
        HK: "Χονγκ Κονγκ",
        HM: "Νήσοι Χερντ και Μακντόναλντ",
        HN: "Ονδούρα",
        HR: "Κροατία",
        HT: "Αϊτή",
        HU: "Ουγγαρία",
        ID: "Ινδονησία",
        IE: "Ιρλανδία",
        IL: "Ισραήλ",
        IM: "Νήσος του Μαν",
        IN: "Ινδία",
        IO: "Βρετανικό Έδαφος Ινδικού Ωκεανού",
        IQ: "Ιράκ",
        IR: "Ιράν",
        IS: "Ισλανδία",
        IT: "Ιταλία",
        JE: "Τζέρσεϊ",
        JM: "Τζαμάικα",
        JO: "Ιορδανία",
        JP: "Ιαπωνία",
        KE: "Κένυα",
        KG: "Κιργιζία",
        KH: "Καμπότζη",
        KI: "Κιριμπάτι",
        KM: "Κομόρες",
        KN: "Άγιος Χριστόφορος και Νέβις",
        KP: "Βόρεια Κορέα (Λαϊκή Δημοκρατία της Κορέας)",
        KR: "Νότια Κορέα",
        KW: "Κουβέιτ",
        KY: "Νήσοι Κέιμαν",
        KZ: "Καζακστάν",
        LA: "Λάος",
        LB: "Λίβανος",
        LC: "Αγία Λουκία",
        LI: "Λιχτενστάιν",
        LK: "Σρι Λάνκα",
        LR: "Λιβερία",
        LS: "Λεσότο",
        LT: "Λιθουανία",
        LU: "Λουξεμβούργο",
        LV: "Λετονία",
        LY: "Λιβύη",
        MA: "Μαρόκο",
        MC: "Μονακό",
        MD: "Μολδαβία",
        ME: "Μαυροβούνιο",
        MF: "Άγιος Μαρτίνος (γαλλικό τμήμα)",
        MG: "Μαδαγασκάρη",
        MH: "Νήσοι Μάρσαλ",
        MK: "Βόρεια Μακεδονία",
        ML: "Μάλι",
        MM: "Μιανμάρ",
        MN: "Μογγολία",
        MO: "Μακάο",
        MP: "Νήσοι Βόρειες Μαριάνες",
        MQ: "Μαρτινίκα",
        MR: "Μαυριτανία",
        MS: "Μονσεράτ",
        MT: "Μάλτα",
        MU: "Μαυρίκιος",
        MV: "Μαλδίβες",
        MW: "Μαλάουι",
        MX: "Μεξικό",
        MY: "Μαλαισία",
        MZ: "Μοζαμβίκη",
        NA: "Ναμίμπια",
        NC: "Νέα Καληδονία",
        NE: "Νίγηρας",
        NF: "Νήσος Νόρφολκ",
        NG: "Νιγηρία",
        NI: "Νικαράγουα",
        NL: "Ολλανδία",
        NO: "Νορβηγία",
        NP: "Νεπάλ",
        NR: "Ναουρού",
        NU: "Νιούε",
        NZ: "Νέα Ζηλανδία",
        OM: "Ομάν",
        PA: "Παναμάς",
        PE: "Περού",
        PF: "Γαλλική Πολυνησία",
        PG: "Παπούα Νέα Γουινέα",
        PH: "Φιλιππίνες",
        PK: "Πακιστάν",
        PL: "Πολωνία",
        PM: "Σαιν Πιερ και Μικελόν",
        PN: "Νήσοι Πίτκερν",
        PR: "Πουέρτο Ρίκο",
        PS: "Παλαιστίνη",
        PT: "Πορτογαλία",
        PW: "Παλάου",
        PY: "Παραγουάη",
        QA: "Κατάρ",
        RE: "Ρεϊνιόν",
        RO: "Ρουμανία",
        RS: "Σερβία",
        RU: "Ρωσία",
        RW: "Ρουάντα",
        SA: "Σαουδική Αραβία",
        SB: "Νήσοι Σολομώντος",
        SC: "Σεϋχέλλες",
        SD: "Σουδάν",
        SE: "Σουηδία",
        SG: "Σιγκαπούρη",
        SH: "Αγία Ελένη, Ασενσιόν και Τριστάν ντα Κούνια",
        SI: "Σλοβενία",
        SJ: "Σβάλμπαρντ και Γιαν Μαγιέν",
        SK: "Σλοβακία",
        SL: "Σιέρα Λεόνε",
        SM: "Άγιος Μαρίνος",
        SN: "Σενεγάλη",
        SO: "Σομαλία",
        SR: "Σουρινάμ",
        ST: "Σάο Τομέ και Πρίνσιπε",
        SV: "Ελ Σαλβαδόρ",
        SY: "Συρία",
        SZ: "Εσουατίνι",
        TC: "Νήσοι Τερκς και Κάικος",
        TD: "Τσαντ",
        TF: "Γαλλικά Νότια Εδάφη",
        TG: "Τογκό",
        TH: "Ταϊλάνδη",
        TJ: "Τατζικιστάν",
        TK: "Τοκελάου",
        TL: "Ανατολικό Τιμόρ",
        TM: "Τουρκμενιστάν",
        TN: "Τυνησία",
        TO: "Τόνγκα",
        TR: "Τουρκία",
        TT: "Τρινιντάντ και Τομπάγκο",
        TV: "Τουβαλού",
        TW: "Ταϊβάν",
        TZ: "Τανζανία",
        UA: "Ουκρανία",
        UG: "Ουγκάντα",
        UM: "Απομακρυσμένες Νησίδες των Ηνωμένων Πολιτειών",
        US: "Ηνωμένες Πολιτείες",
        UY: "Ουρουγουάη",
        UZ: "Ουζμπεκιστάν",
        VA: "Αγία Έδρα (Βατικανό)",
        VC: "Άγιος Βικέντιος και Γρεναδίνες",
        VE: "Βενεζουέλα",
        VG: "Βρετανικές Παρθένοι Νήσοι",
        VI: "Αμερικανικές Παρθένοι Νήσοι",
        VN: "Βιετνάμ",
        VU: "Βανουάτου",
        WF: "Γουάλις και Φουτούνα",
        WS: "Σαμόα",
        YE: "Υεμένη",
        YT: "Μαγιότ",
        ZA: "Νότια Αφρική",
        ZM: "Ζάμπια",
        ZW: "Ζιμπάμπουε",
        OC: "Άλλη χώρα",
    },
}
